{
  "accept_invite": {
    "back_to_home": "Tilbake til startside",
    "choose_password": "Velg et passord",
    "heading": "Godta invitasjon",
    "loading": "Laster inn",
    "save_button": "Godta invitasjon",
    "text": "Du har blitt invitert til å bli med i en arbeidsområde. Vennligst velg et passord for å fortsette."
  },
  "automation": {
    "audience": "Denne målgruppen har for tiden én aktiv ansatt | Denne målgruppen har for tiden {count} aktive ansatte",
    "automation_updated": "Automatisering oppdatert",
    "delete": {
      "are_you_sure": "Er du sikker på at du vil slette denne sekvensen? Denne handlingen kan ikke angres.",
      "automation_deleted": "Sekvens slettet",
      "button": "Slett"
    },
    "details": {
      "heading": "Detaljer",
      "text": "Automatiseringsdetaljer"
    },
    "edit": {
      "subtitle": "Bygg din automatiseringsflyt ved å legge til handlinger",
      "title": "Handlinger"
    },
    "edit_automation": "Rediger innstillinger",
    "employee_already_enrolled": "Denne ansatte er allerede registrert",
    "enroll_employees": "Registrer ansatte",
    "enrolled_employees": "Gruppe oppdatert",
    "flow": {
      "actions": {
        "assign_lesson": {
          "custom_label": "Tilpasset"
        },
        "assign_quiz": {
          "custom_help": "Når dette er deaktivert, velger Moxso Intelligence den mest relevante opplæringen basert på den ansattes risikoprofil.",
          "custom_label": "Tilpasset vurdering",
          "risk_categories": "Risikokategorier"
        },
        "delete": {
          "button": "Slett handling",
          "text": "Er du sikker på at du vil slette denne handlingen?"
        },
        "editing": {
          "add_tag_action": "Legg til tagg",
          "assign_course_action": "Tildel kurs",
          "assign_lesson_action": "Tildel leksjon",
          "assign_quiz_action": "Tildel vurdering",
          "assign_video_action": "Tildel video",
          "halt_action": "Stopp automatisering",
          "remove_tag_action": "Fjern tagg",
          "wait_action": "Vent i en varighet"
        },
        "preview": "Vis aktivitet",
        "repeat_enabled": "Denne automatiseringsflyten vil bli gjentatt for hver ansatt.",
        "status": {
          "active": "Aktiv: {count}",
          "completed": "Fullført: {count}",
          "halted": "Stoppet: {count}"
        },
        "step": "Steg {step}",
        "wait_units": {
          "days": "Dag | Dager",
          "months": "Måned | Måneder",
          "weeks": "Uke | Uker"
        }
      },
      "edit": "Rediger",
      "length": "Lengde",
      "save_step": "Lagre trinn",
      "title": {
        "preview": {
          "assign_lesson_action": {
            "text": "Moxso AI vil automatisk tildele den beste leksjonen for hver ansatt basert på deres ferdighetsnivå og læringsstil.",
            "title": "Bruk Moxso AI for å tildele en leksjon"
          },
          "halt_action": {
            "text": "Automatiseringen vil bli stanset for den ansatte som når dette trinnet.",
            "title": "Stans automatisering"
          }
        },
        "wait_action": "Vent i {duration} {unit}"
      },
      "unit": "Enhet"
    },
    "form_new_automation": {
      "button": "Opprett sekvens",
      "group": "Gruppe",
      "group_placeholder": "Velg gruppe",
      "name": "Navn",
      "template": {
        "label": "Mal",
        "placeholder": "Velg mal"
      },
      "title": "Opprett en sekvens"
    },
    "funnel": {
      "button": "Rediger sekvens",
      "start": "Start",
      "title": "Sekvens trakt"
    },
    "hide_advanced_settings": "Skjul avanserte innstillinger",
    "notification_frequency": "Varslingsfrekvens",
    "notifications": "Varsler",
    "notifications_active": "Aktiv",
    "notifications_inactive": "Inaktiv",
    "participants": {
      "filter": {
        "status": {
          "active": "Aktiv ({count})",
          "all": "Alle ({count})",
          "completed": "Fullført ({count})",
          "halted": "Stoppet ({count})"
        }
      },
      "heading": "Deltakere",
      "statistics": {
        "participant_coverage": "Deltakerdekning",
        "participant_coverage_text": "Beregnet poengsum basert på prosentandelen av ansatte som er påmeldt i denne øvelsen."
      },
      "text": "Deltakerstatistikk"
    },
    "pause": "Pause",
    "play": "Aktiver",
    "search": {
      "placeholder": "Søk alle ansatte",
      "results": "Søkeresultater for: {query}"
    },
    "sequence": {
      "subtitle": "Automatiseringsflytsekvensoversikt",
      "title": "Sekvens"
    },
    "settings": {
      "create_segment": "Opprett et segment",
      "help": {
        "content_skipping_enabled": "Tillat ansatte å hoppe over trinn i automatiseringen hvis ferdighetsnivået deres er tilstrekkelig.",
        "notification_flow_enabled": "Aktiver automatiske varsler for ansatte som ennå ikke har fullført opplæringen sin.",
        "notification_past_deadline_enabled": "Send ukentlige varsler i en måned etter en forfalt frist",
        "notification_prelude_enabled": "Send en varsling til ansatte når en ny vurdering tildeles dem.",
        "relative_deadlines_enabled": "En ansatt vil ikke gå videre i flyten før den forrige fristen er oppfylt.",
        "relative_progression_enabled": "En ansatt vil fortsette i flyten uavhengig av om den forrige leksjonen er fullført.",
        "repeat_enabled": "Tillat at ansatte kan gå gjennom automasjonen mer enn én gang",
        "repeat_only_after_halt": "Gjenta kun når ansatt ble stoppet",
        "repeatable_assignments_enabled": "En ansatt kan tildeles leksjoner som allerede er fullført.",
        "segment": "Begrens automatiseringsflyten til et spesifikt segment.",
        "trigger": "Velg utløseren for denne automatiseringsflyten."
      },
      "labels": {
        "content_skipping_enabled": "Hopp over innhold",
        "date": "Dato",
        "group": "Gruppe",
        "name": "Navn",
        "notification_flow_enabled": "Aktiver varslingsflyt",
        "notification_frequency": "Varslingsfrekvens",
        "notification_past_deadline_enabled": "Aktiver påminnelser etter fristen",
        "notification_prelude_enabled": "Aktiver preludebeskjed",
        "relative_deadlines_enabled": "Aktiver relative tidsfrister",
        "relative_progression_enabled": "Aktiver relativ progresjon",
        "repeat_enabled": "Gjenta automatiseringsflyt",
        "repeat_only_after_halt": "Gjenta kun etter stopp",
        "repeatable_assignments_enabled": "Aktiver repeterbare oppgaver",
        "segment": "Segment",
        "tag": "Merke",
        "trigger": "Utløser",
        "use_segment": "Bruk segment"
      },
      "no_segment_found": "Ingen segmenter funnet for denne gruppen",
      "not_editable_text": "Sett automasjonen på pause for å redigere innstillingene",
      "not_editable_title": "Automatisering kjører nå",
      "placeholder": {
        "course": "Velg kurs",
        "date": "Velg dato",
        "lesson": "Velg leksjon",
        "segment": "Velg segment",
        "tag": "Velg tagg",
        "video": "Velg video"
      },
      "repeatable_assignments_enabled": "Siden du har valgt at en ansatt kan tildeles øvelser de allerede har fullført tidligere, må sekvensen følge relative tidsfrister.",
      "save_settings": "Lagre innstillinger",
      "settings_saved": "Innstillinger lagret"
    },
    "show_advanced_settings": "Vis avanserte innstillinger"
  },
  "billing": {
    "missing_payment_banner": "Handling kreves: manglende betaling"
  },
  "breaches": {
    "breached_accounts": "Kompromitterte kontoer",
    "compromised_info": "Kompromittert info",
    "data_types": "Typer av data i denne lekkasjen",
    "date": "Dato for brudd",
    "disabled": {
      "button": "Gå til innstillinger",
      "heading": "Brudd er deaktivert",
      "text": "Varsle umiddelbart dine ansatte hvis de har blitt involvert i et databrudd, slik at de kan handle raskt for å beskytte sensitiv informasjon og minimere risiko, mens du får et omfattende overblikk over alle brudd som påvirker teamet ditt for bedre sikkerhetsstyring og rask respons."
    },
    "high": "Høy",
    "medium": "Middels",
    "untitled_data_breach": "Uten navngitt datainnbrudd"
  },
  "buttons": {
    "back": "Tilbake",
    "cancel": "Avbryt",
    "copy": "Kopier",
    "delete": "Slett",
    "download_csv": "Last ned CSV",
    "download_pdf": "Last ned PDF",
    "view_details": "Vis detaljer"
  },
  "charts": {
    "donut": {
      "amount_share": "Beløp / Andel",
      "category": "Kategori"
    },
    "resilience": {
      "score": "Poengsum"
    }
  },
  "competency_profile": {
    "current_level": "Nåværende nivå",
    "target_level": "Målnivå",
    "thresholds_info_text": "Tersklene er tilpasset hver ansattes rolle og deres nåværende ferdighetsnivå.",
    "title": "Kompetanseprofil"
  },
  "demo_data": {
    "automations": {
      "onboarding_new_employees": "Onboarding - Nye ansatte",
      "security_awareness_essentials_training": "Grundlagen der Cybersicherheit",
      "upskilling_all_employees": "Kompetanseheving - Alle ansatte"
    },
    "campaign_templates": {
      "templates": {
        "annual_benefits_enrollment_deadline": {
          "html": "<p>Hei <span data-type=\"mention\" data-id=\"::employee.first_name::\">::employee.first_name::</span>,</p><p>Dette er en vennlig påminnelse om at den årlige påmeldingsperioden for fordeler for ansatte i <span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span> snart utløper. Du har til <strong>fredag 15. september</strong> på å gjøre valgene dine for det kommende året.</p><p><strong>Viktige endringer i år:</strong></p><ul><li>Nye helseforsikringsalternativer med bedre dekning</li><li>Økt arbeidsgivermatching i pensjonsordning opptil 6 %</li><li>Forbedrede tann- og synsordninger</li><li>Nye grenser for fleksible utgiftskontoer</li></ul><p>Hvis du ikke fullfører påmeldingen innen fristen, blir du automatisk meldt inn i grunnplanen, som kanskje ikke dekker dine nåværende behov.</p><p>Se gjennom alternativene dine og gjør valgene dine i vår sikre portal for fordeler:</p><p><u><strong><a href=\"::attackLink::\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">Fullfør påmelding til fordeler</a></strong></u></p><p>Hvis du har spørsmål om alternativene dine, ikke nøl med å kontakte HR-teamet vårt.</p><p>Takk,<br/><strong>HR-avdelingen</strong><br/><span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span></p>",
          "subject": "Handling kreves: Frist for årlig påmelding til fordeler"
        },
        "security_breach_immediate_action": {
          "html": "<p>Kjære <span data-type=\"mention\" data-id=\"::employee.first_name::\">::employee.first_name::</span>,</p><p>Vi har oppdaget mistenkelig aktivitet på kontoen din i <span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span> som krever umiddelbar oppmerksomhet. Sikkerhetssystemene våre har flagget flere uautoriserte innloggingsforsøk fra en ukjent enhet.</p><p>For å beskytte kontoen din og selskapets data har vi midlertidig begrenset tilgangen til kontoen din. Du må bekrefte identiteten din og tilbakestille legitimasjonen din innen de neste 24 timene for å unngå permanent suspensjon.</p><p><strong>Dette må du gjøre:</strong></p><ol><li>Klikk på den sikre verifiseringslenken nedenfor</li><li>Bekreft identiteten din med flerfaktorautentisering</li><li>Oppdater passordet ditt umiddelbart</li></ol><p><u><strong><a href=\"::attackLink::\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">Verifiser kontosikkerhet nå</a></strong></u></p><p>Hvis du ikke fullfører verifiseringsprosessen innen 24 timer, vil kontoen din bli permanent suspendert av sikkerhetshensyn.</p><p>Vennlig hilsen,<br/><strong>IT-sikkerhetsteamet</strong><br/><span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span></p>",
          "subject": "Haster: Sikkerhetsbrudd - umiddelbar handling kreves"
        },
        "upcoming_organizational_changes": {
          "html": "<p>Kjære <span data-type=\"mention\" data-id=\"::employee.first_name::\">::employee.first_name::</span>,</p><p>Jeg tar kontakt for å informere deg om noen viktige kommende endringer i <span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span>. På grunn av endrede forretningsbehov vil vi omstrukturere enkelte avdelinger, og dessverre vil noen stillinger bli overflødige.</p><p>Det er viktig at du går gjennom den detaljerte informasjonen om disse endringene så snart som mulig for å forstå hvordan de kan påvirke deg og teamet ditt.</p><p>Vennligst klikk på lenken nedenfor for å lese det offisielle blogginnlegget som beskriver neste steg og tilgjengelig støtte:</p><p><u><strong><a href=\"::attackLink::\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">Les CEO-ens organisatoriske oppdatering</a></strong></u></p><p>Vi setter stor pris på at du gir dette rask oppmerksomhet.</p><p>Vennlig hilsen,<br/><strong>Ledelsen,</strong><br/><span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span></p>",
          "subject": "Kommende organisatoriske endringer"
        }
      }
    },
    "campaigns": {
      "completed_events": {
        "event_0": {
          "filename": "event_0.no.html",
          "from_name": "Slack-teamet",
          "title": "[Slack] Passordet ditt utløper snart"
        },
        "event_1": {
          "filename": "event_1.no.html",
          "from_name": "Love2Race-teamet",
          "title": "[Love2Race] Tilpasset løpeutstyr til deres neste arrangement"
        },
        "event_10": {
          "filename": "event_10.no.html",
          "from_name": "Maria Caroline Thomsen",
          "title": "Kaffemøte"
        },
        "event_11": {
          "filename": "event_11.no.html",
          "from_name": "SAS",
          "title": "Laveste pris noensinne!"
        },
        "event_12": {
          "filename": "event_12.no.html",
          "from_name": "Filippa",
          "title": "Påmelding til DHL-stafetten!"
        },
        "event_13": {
          "filename": "event_13.no.html",
          "from_name": "Slacks sikkerhetsteam",
          "title": "[Slack] Viktig: Ny personvernerklæring"
        },
        "event_14": {
          "filename": "event_14.no.html",
          "from_name": "HubSpot",
          "title": "[HubSpot] Passordet ditt blir endret"
        },
        "event_15": {
          "filename": "event_15.no.html",
          "from_name": "Ditt SAP ID Service-team",
          "title": "[SAP] Varsel om tilbakestilling av passord"
        },
        "event_16": {
          "filename": "event_16.no.html",
          "from_name": "1Password",
          "title": "[1Password] Hovedpassordet ditt er oppdatert"
        },
        "event_17": {
          "filename": "event_17.no.html",
          "from_name": "LinkedIn",
          "title": "[LinkedIn] Dine engasjementsinnsikter er klare"
        },
        "event_18": {
          "filename": "event_18.no.html",
          "from_name": "DocuSign",
          "title": "[DocuSign] Se dokument"
        },
        "event_2": {
          "filename": "event_2.no.html",
          "from_name": "Lars",
          "title": "Invitasjon til prestasjonsworkshop"
        },
        "event_3": {
          "filename": "event_3.no.html",
          "from_name": "Microsoft",
          "title": "Advarsel: 4 214 filer ble slettet - Microsoft"
        },
        "event_4": {
          "filename": "event_4.no.html",
          "from_name": "Pia Berggren",
          "title": "Vår familiehistorie"
        },
        "event_5": {
          "filename": "event_5.no.html",
          "title": "Forslag til betalingsløsning for kaffe"
        },
        "event_6": {
          "filename": "event_6.no.html",
          "from_name": "e-Boks A/S",
          "title": "Du har mottatt ny post fra politiet"
        },
        "event_7": {
          "filename": "event_7.no.html",
          "from_name": "Facebook",
          "title": "Forny passordet ditt - Facebook"
        },
        "event_8": {
          "filename": "event_8.no.html",
          "title": "[Slack] Viktig: Ny personvernerklæring"
        },
        "event_9": {
          "filename": "event_9.no.html",
          "from_name": "Microsoft",
          "title": "Kvoten er overskredet - Microsoft"
        }
      },
      "completed_sms_events": {
        "event_0": {
          "body": "TrackIt: Vi kunne ikke levere pakken din i dag. Bekreft leveringsadressen din for kl. 18:00: https://trk-it.example/delivery",
          "from_name": "TrackIt"
        },
        "event_1": {
          "body": "Lønn: Lønnsslippen din for april er klar. Se det sikre dokumentet her: https://payroll-example.test/review",
          "from_name": "Lønn"
        },
        "event_2": {
          "body": "IT Support: Vi har oppdaget en ny innlogging på e-postkontoen din. Hvis dette ikke var deg, bekreft identiteten din nå: https://it-help.example/verify",
          "from_name": "IT Support"
        },
        "event_3": {
          "body": "Kontor: Du er lagt til på morgendagens adgangsliste til bygget. Åpne besøkspasset her: https://office-pass.example/access",
          "from_name": "Kontor"
        },
        "event_4": {
          "body": "Bank: En kortbetaling er satt på vent. Bekreft transaksjonen for å unngå en midlertidig sperre: https://bank-secure.example/check",
          "from_name": "Bank"
        }
      },
      "names": {
        "automatic_campaign": "Automatisk kampanje",
        "christmas": "Jul",
        "sms_campaign": "SMS-kampanje",
        "test": "Test"
      }
    },
    "custom_courses": {
      "names": {
        "access_control_principles": "Prinsipper for tilgangskontroll",
        "backup_and_recovery_procedures": "Prosedyrer for sikkerhetskopiering og gjenoppretting",
        "business_continuity_planning": "Planlegging av forretningskontinuitet",
        "cloud_security_basics": "Grunnleggende skysikkerhet",
        "cybersecurity_awareness_training": "Opplæring i cybersikkerhetsbevissthet",
        "data_protection_fundamentals": "Grunnleggende databeskyttelse",
        "digital_ethics_and_compliance": "Digital etikk og etterlevelse",
        "email_security_guidelines": "Retningslinjer for e-postsikkerhet",
        "gdpr_compliance_essentials": "Grunnleggende GDPR-etterlevelse",
        "incident_response_training": "Opplæring i hendelseshåndtering",
        "information_classification": "Informasjonsklassifisering",
        "mobile_device_security": "Sikkerhet for mobile enheter",
        "network_security_fundamentals": "Grunnleggende nettverkssikkerhet",
        "password_security_best_practices": "Beste praksis for passordsikkerhet",
        "phishing_prevention": "Forebygging av phishing",
        "privacy_by_design": "Innebygd personvern",
        "remote_work_security": "Sikkerhet ved fjernarbeid",
        "secure_coding_practices": "Praksis for sikker koding",
        "social_engineering_defense": "Forsvar mot sosial manipulering",
        "vendor_risk_management": "Leverandørrisikostyring"
      }
    },
    "custom_videos": {
      "videos": {
        "creating_strong_passwords": {
          "description": "Beste praksis for å opprette og administrere sterke, sikre passord.",
          "title": "Opprette sterke passord"
        },
        "data_privacy_basics": {
          "description": "Det viktigste om personvern og hvordan du beskytter personopplysningene dine.",
          "title": "Grunnleggende personvern"
        },
        "introduction_to_cyber_security": {
          "description": "En oversikt over grunnleggende cybersikkerhet og hvorfor det er viktig.",
          "title": "Introduksjon til cybersikkerhet"
        },
        "multi_factor_authentication": {
          "description": "Hvordan flerfaktorautentisering fungerer og hvorfor du bør bruke det.",
          "title": "Flerfaktorautentisering"
        },
        "new_employee_security_awareness": {
          "description": "En introduksjonsvideo for nye ansatte om grunnleggende sikkerhetsrutiner.",
          "title": "Sikkerhetsbevissthet for nye ansatte"
        },
        "recognizing_phishing_emails": {
          "description": "Lær hvordan du identifiserer og unngår phishing-e-poster for å beskytte informasjonen din.",
          "title": "Gjenkjenne phishing-e-poster"
        },
        "safe_internet_browse": {
          "description": "Tips og teknikker for å surfe trygt og sikkert på internett.",
          "title": "Trygg surfing på internett"
        },
        "securing_mobile_devices": {
          "description": "Lær hvordan du holder de mobile enhetene dine sikre mot trusler.",
          "title": "Sikring av mobile enheter"
        },
        "social_engineering_attacks": {
          "description": "Forstå social engineering-taktikker og hvordan du forsvarer deg mot dem.",
          "title": "Social engineering-angrep"
        },
        "understanding_ransomware": {
          "description": "En introduksjon til ransomware og hvordan du beskytter dataene dine mot det.",
          "title": "Forstå ransomware"
        }
      }
    },
    "policies": {
      "content": {
        "heading_second_paragraph": "Andre avsnitt",
        "paragraph_1": "Hos [Company Name] er vi forpliktet til å opprettholde de høyeste standardene for datasikkerhet i alle deler av virksomheten vår. Vi erkjenner at konfidensialitet, integritet og tilgjengelighet av personlige og sensitive opplysninger er avgjørende for å opprettholde tilliten hos våre kunder, ansatte, partnere og tilsynsmyndigheter.",
        "paragraph_2": "Derfor har vi etablert denne datasikkerhetspolicyen for å definere prinsippene og praksisene som styrer arbeidet vårt med å beskytte data mot uautorisert tilgang, misbruk, tap, endring eller ødeleggelse. Denne policyen gjelder alle personopplysninger vi samler inn, behandler eller lagrer, både digitalt og fysisk, og er i tråd med anerkjente standarder og regelverkskrav, inkludert [sett inn relevante lover, f.eks. GDPR, CCPA, HIPAA].",
        "paragraph_3": "Målet vårt er å implementere proaktive sikkerhetstiltak som reduserer risiko, sikrer etterlevelse og støtter vårt overordnede rammeverk for informasjonsstyring. Vi bruker en kombinasjon av tekniske, administrative og fysiske sikkerhetstiltak for å beskytte data gjennom hele livssyklusen.",
        "paragraph_4": "Dette inkluderer mekanismer for tilgangskontroll, kryptering, sikker programvareutvikling, planlegging av hendelseshåndtering, opplæring av ansatte og regelmessige revisjoner. Hver ansatt, konsulent og tredjepartsleverandør som håndterer personopplysninger, forventes å forstå og følge sikkerhetsansvaret som er beskrevet i denne policyen.",
        "paragraph_5": "Gjennom kontinuerlig evaluering og forbedring av vår sikkerhetsstilling har vi som mål å ligge i forkant av endrede trusler og sikre at personopplysninger som er betrodd oss, behandles med største grad av aktsomhet."
      },
      "names": {
        "acceptable_use_policy": "Policy for akseptabel bruk",
        "access_control_policy": "Policy for tilgangskontroll",
        "bring_your_own_device_byod_policy": "Policy for egne enheter (BYOD)",
        "business_continuity_and_disaster_recovery_policy": "Policy for forretningskontinuitet og katastrofegjenoppretting",
        "change_management_policy": "Policy for endringshåndtering",
        "cloud_usage_policy": "Policy for bruk av skyen",
        "code_of_conduct": "Etiske retningslinjer",
        "company_it_security_policy": "Virksomhetens IT-sikkerhetspolicy",
        "data_protection_and_privacy_policy": "Policy for databeskyttelse og personvern",
        "email_and_communication_policy": "Policy for e-post og kommunikasjon",
        "employee_onboarding_policy": "Policy for onboarding av ansatte",
        "encryption_policy": "Krypteringspolicy",
        "incident_response_policy": "Policy for hendelseshåndtering",
        "internet_usage_policy": "Policy for internettbruk",
        "mobile_device_management_policy": "Policy for administrasjon av mobile enheter",
        "monitoring_and_logging_policy": "Policy for overvåking og logging",
        "network_security_policy": "Policy for nettverkssikkerhet",
        "password_management_policy": "Policy for passordhåndtering",
        "patch_management_policy": "Policy for patchhåndtering",
        "physical_security_policy": "Policy for fysisk sikkerhet",
        "remote_work_policy": "Policy for fjernarbeid",
        "secure_development_policy": "Policy for sikker utvikling",
        "social_media_policy": "Policy for sosiale medier",
        "software_installation_policy": "Policy for programvareinstallasjon",
        "third_party_vendor_security_policy": "Policy for sikkerhet hos tredjepartsleverandører"
      }
    },
    "simulations": {
      "subjects": {
        "new_work_phones": "Vi får nye jobbtelefoner",
        "slack_privacy_policy": "[Slack] Viktig: Ny personvernerklæring",
        "warning_files_deleted": "Advarsel: 4 214 filer ble slettet - Microsoft"
      }
    },
    "threats": {
      "emails": {
        "free_gift_card_sender": "no-reply@ing.no"
      },
      "subjects": {
        "free_gift_card_opportunity_short": "Din mulighet til et gratis gavekort på 300 kr e...",
        "free_gift_card_opportunity_short_with_space": " Din mulighet til et gratis gavekort på 300 kr e..."
      }
    },
    "training": {
      "courses": {
        "10564bf8-aa3e-4295-9cf0-d350276455da": "Grunnleggende om cybersikkerhet",
        "19a78f09-8c46-4090-b2aa-e2d655efb9cf": "Behandling av personopplysninger",
        "27ad50e1-7967-49bd-a85a-3c8a4a97975a": "En introduksjon til GDPR",
        "2ba7b31b-c23c-4195-9506-6dd064f9c72d": "Phishing",
        "69e29286-5079-4053-bd59-f59e64b41cf2": "For nybegynnere",
        "9dadf2a3-6883-4929-b77d-ac424f690a7c": "Passord",
        "a07d3c2d-0414-43bd-b8a7-6555af86c065": "Løsepengevirus",
        "cdf2ba12-d0cd-4c71-a58e-267ec870007a": "Fysisk sikkerhet"
      },
      "videos": {
        "a_secure_network": "Et sikkert nettverk",
        "ai_impact_on_phishing": "AIs påvirkning på phishing",
        "ai_powered_social_engineering_tactics": "AI-drevne sosial manipuleringstaktikker",
        "beware_of_public_networks": "Vær forsiktig med offentlige nettverk",
        "beware_of_usbs_and_other_hard_drives": "Vær forsiktig med USB-pinner og andre harddisker",
        "black_white_and_grey_hat_hackers": "Black hat-, white hat- og grey hat-hackere",
        "cybersecurity_on_mobile_devices": "Cybersikkerhet på mobile enheter",
        "data_leak_monitoring": "Overvåking av datalekkasjer",
        "gdpr_and_security_breaches": "GDPR og sikkerhetsbrudd",
        "hacking_of_hashes": "Hacking av hashverdier",
        "how_has_cryptocurrency_changed_hacking": "Hvordan har kryptovaluta endret hacking?",
        "how_to_create_strong_passwords": "Slik lager du sterke passord",
        "how_to_detect_phishing": "Slik oppdager du phishing",
        "how_to_prevent_tailgating": "Slik forhindrer du tailgating",
        "how_to_protect_confidential_data_in_llms": "Slik beskytter du konfidensielle data i LLM-er",
        "how_to_strengthen_your_physical_security": "Slik styrker du din fysiske sikkerhet",
        "multi_factor_authentication": "Flerfaktorautentisering",
        "password_managers": "Passordbehandlere",
        "phishing_from_a_trusted_sender": "Phishing fra en betrodd avsender",
        "processing_of_personal_data": "Behandling av personopplysninger"
      }
    }
  },
  "dynamic_keys": {
    "api": {
      "errors": {
        "at_least_two_options": "Vennligst oppgi minst to alternativer for hvert spørsmål",
        "invalid_locale": "Vennligst velg et gyldig språk",
        "network": "En feil har oppstått",
        "noResponse": "Ingen respons ble mottatt fra serveren",
        "no_audience": "Vennligst velg en målgruppe",
        "no_date": "Vennligst fyll inn en gyldig dato",
        "no_group": "Vennligst velg en gruppe",
        "no_lesson": "Vennligst velg en leksjon",
        "no_manager": "Vennligst velg en leder",
        "no_phone_country_code": "Vennligst velg en landskode for telefonen",
        "no_role": "Vennligst velg en rolle",
        "no_tag": "Vennligst velg en tagg",
        "no_timezone": "Vennligst velg en tidssone",
        "unknown": "Det har oppstått en ukjent feil"
      },
      "messages": {
        "at_least_one_manager": "Du må ha minst én leder i arbeidsområdet ditt.",
        "auth_failed": "Ugyldig e-post og / eller passord",
        "course_could_not_be_published": "Kan ikke publisere. Forsikre deg om at alle trinn er fylt ut på alle språk og at ingen mangler tittel.",
        "deepl_translation_failed": "AI-oversettelse mislyktes. Prøv igjen senere.",
        "duplicate_field_identifier": "Feltidentifikator finnes allerede",
        "duplicate_goal": "Det finnes allerede et mål med denne typen og sluttdatoen.",
        "general_exception": "En feil har oppstått",
        "goal_expired": "Et utløpt mål kan ikke oppdateres.",
        "group_has_automation": "Denne gruppen kan ikke slettes da den er en del av en aktiv automatisering.",
        "group_has_campaign": "Denne gruppen kan ikke slettes fordi den er en del av en aktiv kampanje.",
        "invalid_domain": "Ugyldig domene",
        "invalid_invite": "Ugyldig invitasjon",
        "invalid_metadata": "Metadata-URL-en kunne ikke hentes eller inneholdt ikke brukbar SAML-metadata. Sørg for at SAML-konfigurasjonene er lagt inn i din IdP.",
        "invalid_phone_number": "Ugyldig telefonnummer",
        "invalid_provider": "Den valgte leverandøren er ugyldig.",
        "invalid_provider_id": "Leverandør-ID-en du oppga er ugyldig",
        "invalid_request": "Teknisk feil",
        "invalid_request_signature": "Lenken du brukte er ugyldig eller ikke lenger aktiv. Vennligst be administratoren din om å sende en ny invitasjon.",
        "invalid_response": "Identitetsleverandøren returnerte et ugyldig svar.",
        "missing_calculation": "Det ser ut som vi mangler noen data. Vennligst prøv igjen senere.",
        "missing_teams_app_installation": "Teams-appen er ikke installert. Installer Moxso Teams-appen.",
        "missing_user": "Vi kan ikke finne en bruker med den e-postadressen.",
        "no_available_integration": "Ingen integrasjon for den valgte leverandøren er tilgjengelig.",
        "not_found": "Kunne ikke finne forespurt element",
        "passwords_dont_match": "De oppgitte passordene er ikke identiske",
        "policy_has_active_audit": "Kan ikke slette da policy har en aktiv revisjon.",
        "policy_not_approved": "Kan ikke opprette revisjon da policyen ikke er godkjent.",
        "provider_resource_not_found": "Gruppen ble ikke funnet i integrasjonskatalogen.",
        "saml_provider_not_found": "SAML-tilkoblingen ble ikke funnet.",
        "sync_conflict": "Medarbeidersynkronisering er allerede aktivert via en annen katalogintegrasjon eller SCIM-tilkobling. Deaktiver den andre tilkoblingen for medarbeidersynkronisering før du aktiverer denne.",
        "sync_provider_missing": "Kan ikke kontakte leverandøren",
        "sync_provider_response_failure": "Kan ikke synkronisere kontakter",
        "too_many_requests": "For mange forsøk. Prøv igjen om et par minutter.",
        "two_factor_challenge_invalid": "Innloggingsutfordringen er utløpt. Logg inn på nytt.",
        "two_factor_code_invalid": "Autentiseringskoden er ugyldig.",
        "unexpected_error": "Det oppstod en uventet feil. Prøv igjen.",
        "upcoming_action_has_data": "Handlinger er allerede planlagt for påfølgende trinn i denne sekvensen. Vennligst fjern disse handlingene før du lagrer.",
        "user_already_active": "Brukeren finnes allerede.",
        "user_exists_in_different_workspace": "Brukeren finnes allerede, men i et annet arbeidsområde. Kontakt kundestøtte for å legge brukeren til i dette arbeidsområdet.",
        "user_not_found": "Koblingen du brukte er ugyldig eller ikke lenger aktiv. Vennligst be administratoren din om å sende ut en ny invitasjon.",
        "video_could_not_be_uploaded": "Videoen kunne ikke lastes opp"
      },
      "validations": {
        "messages": {
          "accepted_if": "Ugyldige felt",
          "after_or_equal": "Sluttdatoen må være en dato som er etter eller lik startdatoen.",
          "alpha": "Feltet {_field_} kan kun inneholde alfabetiske tegn",
          "alpha_dash": "Feltet {_field_} kan inneholde alfanumeriske tegn samt bindestreker og understreker.",
          "alpha_num": "Feltet {_field_} kan kun inneholde alfa-numeriske tegn",
          "alpha_spaces": "Feltet {_field_} kan kun inneholde alfabetiske tegn samt mellomrom.",
          "between": "Feltet {_field_} må være mellom {min} og {max}",
          "boolean": "{_field_}-feltet er ikke en gyldig verdi",
          "confirmed": "Bekreftelsen til {_field_}-feltet stemmer ikke overens.",
          "currentPassword": "Passordet er ikke gyldig",
          "date": "{_field_} felt er ikke en gyldig dato",
          "date_format": "{_field_} felt er ikke en gyldig dato",
          "digits": "Feltet {_field_} må være numerisk og inneholde nøyaktig {length} sifre",
          "dimensions": "Feltet {_field_} må være {width} piksler ganger {height} piksler",
          "double": "Feltet {_field_} må være et gyldig desimaltall",
          "email": "Feltet {_field_} må være en gyldig e-postadresse",
          "excluded": "Feltet {_field_} er ikke en gyldig verdi",
          "ext": "Feltet {_field_} er ikke en gyldig fil",
          "image": "Feltet {_field_} må være et bilde",
          "in": "{_field_}-feltet er ikke en gyldig verdi",
          "integer": "Feltet {_field_} må være et heltall",
          "invalid_domain": "Du må bekrefte ditt domene før du kan legge til brukere",
          "invalid_field": "Ugyldige felter",
          "invalid_phone_number": "Ugyldig telefonnummer",
          "length": "Feltet {_field_} må være {length} langt",
          "max": "Feltet {_field_} kan ikke være lengre enn {length} tegn",
          "max_value": "Feltet {_field_} må være {max} eller mindre",
          "mimes": "Feltet {_field_} må ha en gyldig filtype",
          "min": "Feltet {_field_} må være minst {length} tegn langt",
          "min_value": "Feltet {_field_} må være {min} eller mer",
          "missing_user": "Vi kan ikke finne en bruker med den e-postadressen.",
          "non_disposable_email": "Feltet {_field_} må være en gyldig e-postadresse",
          "not_found": "{_field_} ble ikke funnet",
          "numeric": "Feltet {_field_} kan kun inneholde numeriske tegn",
          "oneOf": "Feltet {_field_} er ikke en gyldig verdi",
          "regex": "Formatet på {_field_}-feltet er ugyldig",
          "required": "Dette feltet er påkrevd",
          "required_if": "Feltet {_field_} er påkrevd",
          "size": "Størrelsen på feltet {_field_} må være mindre enn {size}KB",
          "string": "{_field_} feltet kan bare inneholde alfabetiske tegn",
          "true": "{_field_} må godtas",
          "unique": "{_field_} har allerede blitt tatt",
          "unique_provider_id": "Denne gruppen finnes allerede hos integreringsleverandøren"
        }
      }
    },
    "automation": {
      "flow": {
        "title": {
          "action_selector": "Velg handling",
          "add_tag_action": "Legg til merkelapp",
          "assign_course_action": "Tildel kurs",
          "assign_lesson_action": "Tildel leksjon",
          "assign_quiz_action": "Tildel vurdering",
          "assign_video_action": "Tilordne video",
          "halt_action": "Stans automatisering",
          "missing_action": "Mangler handling",
          "remove_tag_action": "Fjern merkelapp",
          "wait_action": "Vent i en varighet"
        }
      },
      "frequency": {
        "intense": "Intens",
        "loose": "Løs",
        "normal": "Normal"
      },
      "status": {
        "paused": "pauset",
        "running": "kjører",
        "started": "startet"
      },
      "templates": {
        "advanced-it-security-training": {
          "description": "Avansert sikkerhetsopplæring for IT- og teknisk personell.",
          "title": "Avansert IT-sikkerhetsopplæring"
        },
        "blank": {
          "description": "Start fra bunnen med en tom automatisering.",
          "title": "Tom automatisering"
        },
        "cybersecurity-and-physical-security-awareness-intense": {
          "description": "Omfattende sikkerhetsopplæring for avanserte brukere.",
          "title": "Bevissthet om cyber- og fysisk sikkerhet (Intensiv)"
        },
        "cybersecurity-and-physical-security-awareness-light": {
          "description": "Innledende sikkerhetsopplæring for ansatte uten PC.",
          "title": "Bevissthet om cyber- og fysisk sikkerhet (Lett)"
        },
        "cybersecurity-and-physical-security-awareness-medium": {
          "description": "Sikkerhetsbevissthetsopplæring for ansatte med PC-tilgang.",
          "title": "Bevissthet om cyber- og fysisk sikkerhet (Middels)"
        },
        "cybersecurity-fundamentals": {
          "description": "Kjerneprinsipper og beste praksis innen cybersikkerhet.",
          "title": "Grunnleggende cybersikkerhet"
        },
        "management-training-in-it-security": {
          "description": "Cybersikkerhetsbevissthet for ledere og toppledere.",
          "title": "Lederopplæring i IT-sikkerhet"
        },
        "security-awareness-essentials-training": {
          "description": "Grunnleggende bevissthet om cybersikkerhet for alle ansatte.",
          "title": "Grunnleggende opplæring i sikkerhetsbevissthet"
        }
      },
      "triggers": {
        "date_trigger": "På en bestemt dato",
        "employee_added_to_audience_trigger": "Når en ansatt legges til i sekvenspublikummet",
        "employee_created_trigger": "Når en ansatt blir opprettet",
        "simulation_link_clicked_trigger": "Når en ansatt klikker på en lenke i en simulering",
        "tag_added_trigger": "Når en ansatt blir tildelt en tagg",
        "tag_removed_trigger": "Når en ansatt fjernes fra en tagg"
      },
      "triggers_help": {
        "date_trigger": "Registrerer alle i den valgte målgruppen når utløseren aktiveres. Ansatte som legges til i målgruppen etter denne datoen, blir ikke registrert automatisk.",
        "employee_added_to_audience_trigger": "Registrerer en ansatt når vedkommende legges til i målgruppen som er knyttet til automatiseringen.",
        "employee_created_trigger": "Registrerer en ansatt så snart vedkommende legges til i Moxso.",
        "simulation_link_clicked_trigger": "Registrerer en ansatt når vedkommende klikker på en lenke i en phishing-simulering, slik at du kan tildele målrettet oppfølgingstrening."
      },
      "wait_units": {
        "days": "dag | dager",
        "hours": "time | timer",
        "minutes": "minutt | minutter",
        "months": "måned | måneder",
        "seconds": "sekund | sekunder",
        "weeks": "uke | uker"
      }
    },
    "employees": {
      "deactivation_notice": {
        "account_disabled": "Denne kontoen har blitt manuelt deaktivert av en administrator den {date}.",
        "active_directory": "Denne kontoen har blitt deaktivert på grunn av en endring i din Active Directory den {date}.",
        "simulation_bounce": "Denne kontoen har blitt deaktivert på grunn av en tilbakesending i en simulering den {date}.",
        "simulation_complaint": "Denne kontoen har blitt deaktivert på grunn av en klage i en simulering den {date}."
      },
      "recent_activity": {
        "type": {
          "clicked": "{name} klikket på en simuleringslenke",
          "completed_course": "{name} fullførte et kurs",
          "correct": "{name} svarte riktig på en phishing-quiz",
          "delivered": "{name} mottok en simulering",
          "incorrect": "{name} svarte feil på en phishing-quiz",
          "mc_correct": "{name} besvarte et flervalgsspørsmål riktig",
          "mc_incorrect": "{name} svarte feil på et flervalgsspørsmål",
          "reported": "{name} rapporterte en simulering",
          "sms_clicked": "{name} klikket på en lenke i en smishing-simulering",
          "sms_delivered": "{name} mottok en smishing-simulering",
          "submission": "{name} logget inn på en simulering",
          "submit_delivered": "{name} mottok en simulering",
          "watched_video": "{name} så en video"
        }
      },
      "status": {
        "active": "aktiv",
        "inactive": "inaktiv"
      }
    },
    "export_form_fields": {
      "clicked_count": "Simuleringer klikket",
      "created_at": "Opprettelsesdato",
      "department": "Avdeling",
      "dynamic_group_memberships": "Dynamiske gruppemedlemskap",
      "email": "E-post",
      "first_name": "Fornavn",
      "group_count": "Antall grupper",
      "last_name": "Etternavn",
      "locale": "Språk",
      "manager_name": "Leder",
      "onboarded": "Status for onboarding",
      "phishing_quizzes_count": "Phishing-quizzer fullført",
      "phone_number": "Telefonnummer",
      "point_count": "Poengsum totalt",
      "provider": "Integrasjonsleverandør",
      "received_count": "Simuleringer mottatt",
      "reported_count": "Simuleringer rapportert",
      "score": "Poeng",
      "status": "Status",
      "submitted_count": "Pålogginger i simuleringer",
      "video_quizzes_count": "Videoquizer fullført",
      "watched_count": "Videoer sett"
    },
    "feature_upsell": {
      "bring-your-own-content": {
        "items": [
          "Last opp egne videoer og læringsressurser",
          "Lokaliser opplastinger på tvers av språk og team",
          "Del onboarding- og compliance-innhold tilpasset organisasjonen deres",
          "Automatiser planlegging, oppfølging og rapportering for eget innhold."
        ],
        "summary": "Kombiner Moxso-opplæring med eget materiale for å levere innhold som passer arbeidsflyt, verktøy og intern kommunikasjon.",
        "title": "Eget innhold"
      },
      "compliance-integration": {
        "items": [
          "Koble til Drata og Vanta med mindre friksjon i oppsettet.",
          "Reduser manuell innsamling av compliance-dokumentasjon.",
          "Knytt opplæringsaktivitet til revisjonsvennlige arbeidsflyter.",
          "Støtt gjentakende gjennomganger med færre overleveringer."
        ],
        "summary": "Synkroniser compliance-dokumentasjon og koble Moxso-aktivitet til Drata- og Vanta-arbeidsflyter med mindre manuelt oppfølgingsarbeid.",
        "title": "Drata- og Vanta-complianceintegrasjon"
      },
      "goal-setting": {
        "items": [
          "Sett målbare mål for viktige resultatmålinger.",
          "Følg fremdrift mot målet over tid.",
          "Bruk forventede trender for å se om målet er realistisk.",
          "Oppdag tidlig om resultatene er på rett spor."
        ],
        "summary": "Sett et mål, følg fremdrift over tid og sammenlign det med en forventet trendlinje for å se om målet er realistisk og på rett spor.",
        "title": "Målsetting"
      },
      "human-risk-intelligence": {
        "items": [
          "Overvåk menneskelige risikosignaler på ett sted.",
          "Følg tildelinger og intervensjoner over tid.",
          "Forstå nye atferdsbaserte risikoer tidligere.",
          "Prioriter tiltak med rikere risikokontekst."
        ],
        "summary": "Følg menneskelige risikosignaler, intervensjoner og tildelinger i én visning for å forstå nye atferdsbaserte risikoer.",
        "title": "Innsikt i menneskelig risiko"
      },
      "industry-benchmarking": {
        "items": [
          "Sammenlign resultater med benchmark fra lignende virksomheter.",
          "Gi robusthets- og opplæringsmålinger mer kontekst.",
          "Oppdag avvik raskere på tvers av viktige KPI-er.",
          "Styrk rapportering til interessenter og ledelse."
        ],
        "summary": "Sammenlign robusthet og opplæringsresultater med bransjebenchmarker for å gi sikkerhetsmålingene dine mer kontekst.",
        "title": "Bransjebenchmarking"
      },
      "phishing-reporting-add-in": {
        "items": [
          "Gjør det enklere for ansatte å rapportere mistenkelige e-poster med en gang.",
          "Avdekk angrep raskt før de rekker å spre seg.",
          "Hold sikkerhetsrapportering enkelt og top of mind for alle.",
          "Bygg rapportering inn i den daglige arbeidsflyten uten ekstra friksjon."
        ],
        "summary": "E-posttillegg som lar ansatte rapportere phishing og mistenkelige e-poster direkte fra innboksen.",
        "title": "Phishing-rapportering"
      },
      "policy-management": {
        "items": [
          "Opprett og oppdater interne retningslinjer på ett sted",
          "Tildel retningslinjer til riktige team til riktig tid",
          "Samle inn bekreftelser fra ansatte på retningslinjer",
          "Følg status og bevar et revisjonsspor"
        ],
        "summary": "Publiser interne retningslinjer, følg opp bekreftelser og hold dokumentasjonen organisert på tvers av organisasjonen.",
        "title": "Policyhåndtering"
      },
      "risk-based-training": {
        "items": [
          "Adaptiv læring basert på atferd og risikosignaler.",
          "Reduser menneskelig cyberrisiko med personlig opplæring.",
          "Fokuser på reelle sårbarheter, ikke hypotetiske trusler.",
          "Minimer belastning for brukere med lav risiko."
        ],
        "summary": "Sikkerhetsopplæring som tilpasser innhold og intensitet basert på ansattes risikosignaler og risikoprofil, utledet fra simuleringer og observert atferd.",
        "title": "Risikobasert opplæring"
      },
      "simulation-builder": {
        "items": [
          "Tilpass simuleringer til organisasjonen og trusselbildet deres.",
          "Tildel kampanjer til brukerne, rollene eller gruppene som betyr mest.",
          "Bruk kjente avsendere, budskap og temaer for mer autentisitet.",
          "Design kampanjer på egne premisser og fokuser på prioriterte områder.",
          "Generer realistiske phishing-simuleringer med AI."
        ],
        "summary": "Konfigurasjonsverktøy for å opprette og administrere phishing-simuleringskampanjer, inkludert maler, avsenderprofiler og domener.",
        "title": "Simuleringsbygger"
      },
      "smishing": {
        "items": [
          "Kjør SMS-baserte phishing-simuleringer.",
          "Test hvordan ansatte reagerer på mobile enheter.",
          "Utvid awareness-opplæring utover innboksen.",
          "Mål robusthet mot mobilfokuserte angrepsmønstre."
        ],
        "summary": "Utvid simuleringer utover e-post med SMS- og QR-baserte phishing-scenarier tilpasset mobilfokuserte angrep.",
        "title": "Smishing og quishing"
      },
      "spear-phishing": {
        "items": [
          "Simuler målretting mot programvare og direktørsvindel.",
          "Test innhenting av påloggingsinformasjon i mer realistiske scenarier.",
          "Utvid phishingprogrammer med avanserte angrepstyper.",
          "Forbered ansatte på sosial manipulering med høyere risiko."
        ],
        "summary": "Lag avanserte phishing-simuleringer for målretting mot programvare, lederetterligning og scenarier for innhenting av påloggingsinformasjon.",
        "title": "Spear phishing"
      },
      "teams-slack-integration": {
        "items": [
          "Koble samarbeidskanaler til sikkerhetsarbeidsflyter.",
          "Send relevante varsler dit teamene allerede jobber.",
          "Utvid rapportering og awareness til daglig kommunikasjon.",
          "Støtt raskere oppfølging på tvers av sikkerhet og drift."
        ],
        "summary": "Koble samarbeidsplattformer sammen for å synkronisere varsler og utvide sikkerhetsarbeidsflyter til daglige kommunikasjonskanaler.",
        "title": "MS Teams- og Slack-integrasjon"
      },
      "threat-management": {
        "items": [
          "Sanntidsinnsikt i rapporterte trusler",
          "Bransjespesifikke varsler om nye angrepsmønstre",
          "Analyse av trender i trusselbildet i organisasjonen",
          "Fungerer direkte med Outlook og Gmail."
        ],
        "summary": "Undersøk mistenkelige e-poster, forstå risikosignaler og håndter trusler fra én samlet arbeidsflate for sikkerhetsteam.",
        "title": "Trusselhåndtering"
      }
    },
    "frameworks": {
      "ai_act": "AI Act",
      "dora": "DORA",
      "gdpr": "GDPR",
      "iso_27001": "ISO 27001",
      "iso_27005": "ISO 27005",
      "nis2": "NIS2",
      "soc_2": "SOC 2"
    },
    "goals": {
      "metric": {
        "click_rate": "Klikkrate",
        "employees_behind": "Ansatte på etterskudd",
        "report_rate": "Rapporteringsrate",
        "resilience_score": "Robusthetspoeng"
      },
      "outcome": {
        "achieved": "Oppnådd",
        "missed": "Ikke oppnådd"
      },
      "status": {
        "ahead": "Foran",
        "at_risk": "I faresonen",
        "on_track": "På rett spor"
      }
    },
    "group": {
      "sync_failure": {
        "invalid_provider": {
          "subtitle": "Vennligst velg en gyldig leverandør og oppdater dataene."
        },
        "invalid_provider_id": {
          "subtitle": "Velg en gyldig leverandør-ID og oppdater dataene."
        },
        "no_available_integration": {
          "subtitle": "Vennligst velg en tilgjengelig integrasjon."
        },
        "provider_resource_not_found": {
          "subtitle": "Vennligst oppdater gruppeleverandør-ID-en."
        },
        "recommended_action": "Anbefalt handling",
        "title": "Synkronisering mislyktes"
      }
    },
    "groups": {
      "adaptive_conditions": {
        "fields": {
          "department": "Avdeling",
          "email": "E-post",
          "locale": "Språk",
          "manager_id": "Leder",
          "onboarded": "Onboardingstatus",
          "organizational_role_id": "Rolle",
          "provider": "Integrasjonsleverandør",
          "score": "Score",
          "status": "Status",
          "timezone": "Tidssone"
        },
        "operators": {
          "contains": "inneholder",
          "ends_with": "slutter med",
          "equals": "er",
          "greater_than": "er større enn",
          "greater_than_or_equal": "er større enn eller lik",
          "is_empty": "er tom",
          "is_not_empty": "er ikke tom",
          "less_than": "er mindre enn",
          "less_than_or_equal": "er mindre enn eller lik",
          "not_equals": "er ikke",
          "starts_with": "starter med"
        },
        "values": {
          "active": "Aktiv",
          "false": "Usann",
          "google": "Google Workspace",
          "google_scim": "Google SCIM",
          "inactive": "Inaktiv",
          "microsoft": "Microsoft Entra ID",
          "microsoft_scim": "Microsoft Entra SCIM",
          "okta_scim": "Okta SCIM",
          "slack": "Slack",
          "true": "Sann"
        }
      }
    },
    "hri_integration_tags": {
      "access_permissions": {
        "description": "Tilgangshendelser, autorisasjon, privilegier og applikasjonstilgang.",
        "headline": "Tilgang"
      },
      "account_security": {
        "description": "Kontostatus, beskyttelse, endringer, livssyklus og risikoutsatte brukere.",
        "headline": "Kontosikkerhet"
      },
      "audit_administration": {
        "description": "Revisjonslogger, administrative hendelser og endringer i sikkerhetsinnstillinger.",
        "headline": "Revisjonslogger"
      },
      "authentication_mfa": {
        "description": "Pålogginger, påloggingsaktivitet, autentiseringsresultater og MFA-hendelser.",
        "headline": "Autentisering"
      },
      "data_protection_insider_risk": {
        "description": "Hendelser knyttet til forebygging av datatap (DLP) og innsiderisiko.",
        "headline": "Databeskyttelse"
      },
      "device_management": {
        "description": "Administrasjonsdekning, agentstatus og sikkerhetstilstand for enhetstilgang.",
        "headline": "Enhetsadministrasjon"
      },
      "device_security": {
        "description": "Kryptering, skjermlåser, endepunktbeskyttelse og enhetsetterlevelse.",
        "headline": "Enhetssikkerhet"
      },
      "email_security": {
        "description": "E-posttrusler og kontoovertakelse.",
        "headline": "E-postsikkerhet"
      },
      "incidents_investigations": {
        "description": "Sikkerhetshendelser, alvorlighetsgrad og undersøkelsesstatus.",
        "headline": "Hendelser"
      },
      "remediation_control_gaps": {
        "description": "Mangler i beskyttelsen, kontrollfunn og fremdrift i utbedring.",
        "headline": "Kontrollmangler"
      },
      "service_health": {
        "description": "Tjenestehendelser, komponentstatus og planlagt vedlikehold.",
        "headline": "Tjenestetilstand"
      },
      "sharing_data_activity": {
        "description": "Delingsendringer, dataoverføring, elementbruk og Git-aktivitet.",
        "headline": "Dataaktivitet"
      },
      "threats_detections": {
        "description": "Sikkerhetsvarsler, trusselsignaler og risikodeteksjoner.",
        "headline": "Trusler"
      },
      "vulnerabilities_exposure": {
        "description": "Sårbarheter, skyfunn, funn fra penetrasjonstester og eksponering.",
        "headline": "Sårbarheter"
      },
      "workforce_organization": {
        "description": "Roller, team, ansettelsesforhold og arbeidsordninger.",
        "headline": "Arbeidsstyrke"
      }
    },
    "hri_integrations": {
      "abnormal_ai": {
        "bullets": [
          {
            "label": "Reelle e-posttrusler",
            "text": "{label}: Oppdaget phishing og andre støttede e-postangrep gir dokumentasjon utover simuleringer."
          },
          {
            "label": "Kompromitterte kontoer",
            "text": "{label}: Funn av kontoovertakelse bidrar til å identifisere kontoer som kan kreve umiddelbar undersøkelse."
          },
          {
            "label": "Målrettet oppfølging",
            "text": "{label}: Bruk relevant dokumentasjon på angrep til å gjøre veiledningen om phishing og kontosikkerhet mer konkret."
          },
          {
            "label": "Kontekst for respons",
            "text": "{label}: Registrerte utbedringer og saksstatus bidrar til å forklare hva som allerede er håndtert."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser informasjon om trusler og respons uten å fjerne meldinger eller utføre handlinger på kontoer."
          }
        ],
        "description_long": "Abnormal AI oppdager e-postangrep og kontoovertakelse. Koble til slik at Moxso kan bruke reelle angrepssignaler til å rette oppfølgingen av menneskelig risiko mot truslene folk møter i miljøet ditt.",
        "description_short": "Bruk e-posttrusler og funn av kontoovertakelse til å målrette sikkerhetsoppfølgingen.",
        "title": "Abnormal AI"
      },
      "aikido": {
        "bullets": [
          {
            "label": "Sikkerhetsfunn",
            "text": "{label}: Sårbarheter og andre støttede problemer identifiserer områder som trenger teknisk oppfølging."
          },
          {
            "label": "Eksponeringskontekst",
            "text": "{label}: Alvorlighetsgrad og informasjon om berørte ressurser bidrar til å forklare betydningen av et funn."
          },
          {
            "label": "Målrettede tiltak",
            "text": "{label}: Bruk relevante funn til å rette teknisk utbedring og sikkerhetsveiledning mot de rette teamene."
          },
          {
            "label": "Fremdrift over tid",
            "text": "{label}: Endringer i funnstatus bidrar til å skille utestående problemer fra arbeid som allerede er håndtert."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgte sikkerhetsfunn uten å endre kode eller utføre rettelser."
          }
        ],
        "description_long": "Aikido Security identifiserer svakheter i programvare og infrastruktur. Koble til for å inkludere relevant teknisk eksponering i grunnlaget for vurderingene av menneskelig risiko og sikkerhetsoppfølgingen.",
        "description_short": "Ta med sårbarheter i programvare og infrastruktur i risikovurderingene dine.",
        "title": "Aikido Security"
      },
      "airtable": {
        "bullets": [
          {
            "label": "Kontobeskyttelse",
            "text": "{label}: Tilgjengelige indikatorer for autentisering og privilegier bidrar til å avdekke tilgangsproblemer."
          },
          {
            "label": "Reell aktivitet",
            "text": "{label}: Utvalgte revisjonshendelser gir dokumentasjon på sikkerhetsrelevante handlinger og endringer."
          },
          {
            "label": "Målrettet veiledning",
            "text": "{label}: Bruk relevante hendelser til å målrette råd om kontobeskyttelse og ansvarlig tilgang til delt informasjon."
          },
          {
            "label": "Løpende vurdering",
            "text": "{label}: Vurder endringer i kontosikkerhet og gjentakende hendelser sammen med annen dokumentasjon."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgt sikkerhetsinformasjon uten tilgang til tabelloppføringer. Tilgang til Enterprise API krever et kvalifiserende abonnement."
          }
        ],
        "description_long": "Airtable hjelper team med å arbeide med delt forretningsinformasjon. Koble til slik at Moxso kan bruke relevante kontosikkerhets- og revisjonssignaler som grunnlag for vurdering av menneskelig risiko og målrettet oppfølging.",
        "description_short": "Vurder kontosikkerhetssignaler og revisjonsaktivitet knyttet til delt forretningsinformasjon.",
        "title": "Airtable"
      },
      "asana": {
        "bullets": [
          {
            "label": "Tilgangssignaler",
            "text": "{label}: Støttede revisjonshendelser identifiserer aktivitet som påvirker konto- og prosjekttilgang."
          },
          {
            "label": "Delingsendringer",
            "text": "{label}: Utvalgte hendelser knyttet til medlemskap og lenketilgang gir dokumentasjon på endringer i samarbeidstilgang."
          },
          {
            "label": "Relevant oppfølging",
            "text": "{label}: Bruk omstendighetene rundt en hendelse til å målrette tilgangsgjennomganger og veiledning om trygg deling."
          },
          {
            "label": "Mønstre over tid",
            "text": "{label}: Vurder gjentakende tilgangsendringer sammen med annen sikkerhetsdokumentasjon."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgte revisjonsmetadata uten tilgang til oppgavebeskrivelser eller prosjektinnhold. Tilgjengeligheten av revisjonsdata avhenger av Asana-abonnementet ditt."
          }
        ],
        "description_long": "Asana hjelper team med å organisere og dele arbeid. Koble til slik at Moxso kan bruke utvalgte tilgangs- og delingshendelser som grunnlag for vurdering av menneskelig risiko og støtte tryggere samarbeid.",
        "description_short": "Bruk tilgangs- og delingshendelser til å veilede om tryggere samarbeid.",
        "title": "Asana"
      },
      "atlassian": {
        "bullets": [
          {
            "label": "Kontosikkerhetssignaler",
            "text": "{label}: Støttede revisjonshendelser gir dokumentasjon på tilgangsrelatert aktivitet."
          },
          {
            "label": "Sensitive endringer",
            "text": "{label}: Administrative handlinger bidrar til å identifisere endringer som bør vurderes nærmere."
          },
          {
            "label": "Målrettet oppfølging",
            "text": "{label}: Bruk relevante hendelser som grunnlag for tilgangsgjennomganger og råd om kontosikkerhet."
          },
          {
            "label": "Løpende oversikt",
            "text": "{label}: Vurder gjentakende aktivitet sammen med annen dokumentasjon før du velger tiltak."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgte revisjonsmetadata uten tilgang til innholdet i Jira-saker eller Confluence-sider."
          }
        ],
        "description_long": "Atlassian støtter samarbeid på tvers av organisasjonen. Koble til slik at Moxso kan bruke utvalgte konto- og administrasjonshendelser som grunnlag for vurdering av menneskelig risiko og relevant oppfølging.",
        "description_short": "Vurder kontoaktivitet og administrativ aktivitet på tvers av samarbeidsverktøyene dine.",
        "title": "Atlassian"
      },
      "auth0": {
        "bullets": [
          {
            "label": "Reelle påloggingssignaler",
            "text": "{label}: Utvalgte mislykkede pålogginger, MFA-hendelser og angrepsrelaterte hendelser avdekker tilgangsproblemer."
          },
          {
            "label": "Kontobeskyttelse",
            "text": "{label}: Endringer i påloggingsinformasjon og sikkerhetsrelaterte kontoendringer gir ytterligere dokumentasjon til vurderingen."
          },
          {
            "label": "Relevant oppfølging",
            "text": "{label}: Bruk aktivitet som kan knyttes til ansatte, som grunnlag for undersøkelser og råd om kontosikkerhet."
          },
          {
            "label": "Mønstre over tid",
            "text": "{label}: Vurder gjentatte autentiseringsproblemer i lys av applikasjonen som er involvert."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgt aktivitet uten å endre applikasjonskontoer eller autentiseringsinnstillinger."
          }
        ],
        "description_long": "Auth0 håndterer pålogginger til applikasjonene dine. Koble til slik at Moxso kan bruke relevante autentiserings- og kontosikkerhetssignaler som grunnlag for vurdering av menneskelig risiko når aktiviteten gjelder arbeidsstyrken din.",
        "description_short": "Bruk arbeidsstyrkens påloggings- og kontosikkerhetshendelser som grunnlag for risikovurderinger.",
        "title": "Auth0"
      },
      "clerk": {
        "bullets": [
          {
            "label": "Kontostatus",
            "text": "{label}: Tilgjengelige statuser for låste og utestengte kontoer bidrar til å identifisere kontoer som kan kreve nærmere vurdering."
          },
          {
            "label": "Tilgangskontekst",
            "text": "{label}: Organisasjonsmedlemskap bidrar til å sette applikasjonstilgang i perspektiv."
          },
          {
            "label": "Målrettet oppfølging",
            "text": "{label}: Bruk relevant kontokontekst som grunnlag for tilgangsgjennomganger og samtaler om kontosikkerhet."
          },
          {
            "label": "Oppdatert bilde",
            "text": "{label}: Vurder den nyeste kontostatusen sammen med annen dokumentasjon når du avgjør hva som trenger oppfølging."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser konto- og tilgangsinformasjon uten å endre Clerk-innstillinger. Denne tilkoblingen samler ikke inn påloggingshendelser eller øktaktivitet."
          }
        ],
        "description_long": "Clerk administrerer tilgang til applikasjonene dine. Koble til slik at Moxso kan vurdere konteksten for kontotilgang sammen med menneskelig risiko og bidra til mer relevant oppfølging av kontosikkerhet.",
        "description_short": "Bruk kontostatus og organisasjonsmedlemskap som grunnlag for tilgangsgjennomganger.",
        "title": "Clerk"
      },
      "cloudflare_zero_trust": {
        "bullets": [
          {
            "label": "Sikkerhetsendringer",
            "text": "{label}: Utvalgte revisjonshendelser identifiserer endringer i tilgangsrelaterte innstillinger og ressurser."
          },
          {
            "label": "Tilgangskontekst",
            "text": "{label}: Tilgjengelige detaljer om aktør, handling og resultat bidrar til å forklare betydningen av en hendelse."
          },
          {
            "label": "Målrettet vurdering",
            "text": "{label}: Bruk sensitive endringer til å identifisere hvor en tilgangsgjennomgang eller sikkerhetsoppfølging er nødvendig."
          },
          {
            "label": "Løpende innsikt",
            "text": "{label}: Vurder gjentatte administrative endringer sammen med annen sikkerhetsdokumentasjon."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgt sikkerhetsinformasjon uten å endre tilgangspolicyer. Denne tilkoblingen gir ikke trafikkovervåking eller påloggingstelemetri fra Access."
          }
        ],
        "description_long": "Cloudflare Zero Trust beskytter tilgang til virksomhetens ressurser. Koble til slik at Moxso kan bruke utvalgte endringer i sikkerhet og tilgangskontroll som kontekst for menneskelig risiko og undersøkelser.",
        "description_short": "Vurder endringer i sikkerhet og tilgangskontroll som påvirker virksomhetens ressurser.",
        "title": "Cloudflare Zero Trust"
      },
      "comp_ai": {
        "bullets": [
          {
            "label": "Sikkerhetsfunn",
            "text": "{label}: Støttede funn fremhever forhold som trenger vurdering eller utbedring."
          },
          {
            "label": "Beskyttelseskontekst",
            "text": "{label}: Tilgjengelige enhetssikkerhetskontroller, inkludert krypteringsstatus, bidrar til å forklare problemet."
          },
          {
            "label": "Praktiske tiltak",
            "text": "{label}: Bruk relevant dokumentasjon til å målrette oppfølgingen med den ansatte, IT-teamet eller kontrollansvarlig."
          },
          {
            "label": "Endrede forhold",
            "text": "{label}: Oppdateringer av funn og beskyttelsesstatus bidrar til å skille vedvarende problemer fra løste oppgaver."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgt sikkerhetsdokumentasjon uten å fullføre oppgaver eller endre policyer."
          }
        ],
        "description_long": "Comp AI følger opp sikkerhetskontroller og etterlevelsesfunn. Koble til slik at Moxso kan ta hensyn til relevante mangler i beskyttelsen ved vurdering av menneskelig risiko og avgjørelser om hvor oppfølging er nødvendig.",
        "description_short": "Bruk sikkerhetsfunn og mangler i enhetsbeskyttelsen til å målrette oppfølgingen.",
        "title": "Comp AI"
      },
      "crowdstrike": {
        "bullets": [
          {
            "label": "Reelle angrepssignaler",
            "text": "{label}: Endepunktvarsler gir dokumentasjon på mistenkelig eller ondsinnet aktivitet."
          },
          {
            "label": "Eksponeringskontekst",
            "text": "{label}: Alvorlighetsgrad, berørte ressurser og tilgjengelige sårbarhetsdetaljer bidrar til å sette funn i perspektiv."
          },
          {
            "label": "Målrettet oppfølging",
            "text": "{label}: Bruk relevante funn til å samordne undersøkelser, utbedring av enheter og veiledning til ansatte."
          },
          {
            "label": "Fremdrift i undersøkelser",
            "text": "{label}: Funn- og saksstatus bidrar til å vise hvilke problemer som fortsatt trenger oppfølging."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgte sikkerhetsfunn uten å isolere vertsmaskiner eller endre undersøkelser."
          }
        ],
        "description_long": "CrowdStrike Falcon oppdager trusler på arbeidsenheter. Koble til slik at Moxso kan bruke relevante endepunktfunn som grunnlag for vurdering av menneskelig risiko og rette oppfølgingen mot reelle sikkerhetsproblemer.",
        "description_short": "Ta med endepunktvarsler og sårbarhetsfunn i risikovurderingene dine.",
        "title": "CrowdStrike"
      },
      "datadog": {
        "bullets": [
          {
            "label": "Sikkerhetssignaler",
            "text": "{label}: Utvalgte funn gir dokumentasjon på aktivitet som bør undersøkes."
          },
          {
            "label": "Kontoaktivitet",
            "text": "{label}: Støttede hendelser knyttet til autentisering, tilgang og sikkerhetskonfigurasjon gir mer kontekst."
          },
          {
            "label": "Målrettet oppfølging",
            "text": "{label}: Bruk dokumentasjon knyttet til ansatte som grunnlag for kontosikkerhetsvurderinger og relevante råd."
          },
          {
            "label": "Mønstre over tid",
            "text": "{label}: Vurder gjentakende hendelser og oppdateringer av funn sammen med annen risikodokumentasjon."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgt sikkerhetsinformasjon uten å importere generelle applikasjonsmålinger eller endre innstillinger."
          }
        ],
        "description_long": "Datadog identifiserer sikkerhetsaktivitet på tvers av overvåkede miljøer. Koble til slik at Moxso kan bruke relevante sikkerhetsfunn og kontohendelser som grunnlag for vurderinger av menneskelig risiko.",
        "description_short": "Legg til sikkerhetsfunn og kontoaktivitet fra overvåkede miljøer.",
        "title": "Datadog"
      },
      "deel": {
        "bullets": [
          {
            "label": "Rollekontekst",
            "text": "{label}: Ansvarsområder og avdelinger bidrar til å sette sikkerhetsproblemer i perspektiv."
          },
          {
            "label": "Endringer i arbeidsstyrken",
            "text": "{label}: Endringer i ansettelsesstatus gir kontekst for å vurdere om tilgangen fortsatt er passende."
          },
          {
            "label": "Relevant veiledning",
            "text": "{label}: Ta hensyn til personens arbeidssituasjon når du velger sikkerhetsråd og temaer for bevisstgjøring."
          },
          {
            "label": "Målrettet oppfølging",
            "text": "{label}: Bruk rolle- og livssykluskontekst sammen med sikkerhetsdokumentasjon som grunnlag for samtaler med de rette personene."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser relevant informasjon om arbeidsstyrken uten å endre ansettelsesoppføringer eller behandle lønn."
          }
        ],
        "description_long": "Deel hjelper med å administrere en arbeidsstyrke med ulike roller og arbeidsordninger. Koble til slik at Moxso kan ta hensyn til relevant kontekst om arbeidsstyrken ved vurdering av menneskelig risiko og planlegging av sikkerhetsoppfølging.",
        "description_short": "Legg til kontekst om arbeidsstyrken fra globale ansattoppføringer.",
        "title": "Deel"
      },
      "drata": {
        "bullets": [
          {
            "label": "Beskyttelsessignaler",
            "text": "{label}: Støttede kontroller av kryptering, antivirus, brannmur, oppdateringer og skjermlås bidrar til å identifisere svakheter."
          },
          {
            "label": "Sikkerhet i hverdagen",
            "text": "{label}: Kontroller av passordbehandlere og andre tilgjengelige sikkerhetskontroller gir kontekst for praktiske sikkerhetsvaner."
          },
          {
            "label": "Målrettet oppfølging",
            "text": "{label}: Bruk konkrete mangler til å avgjøre hva som krever veiledning til ansatte, og hva som krever IT-tiltak."
          },
          {
            "label": "Løpende forbedring",
            "text": "{label}: Vurder endrede kontrollresultater sammen med annen dokumentasjon om menneskelig risiko."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgt sikkerhetsdokumentasjon uten å endre kontrollresultater eller enhetsinnstillinger."
          }
        ],
        "description_long": "Drata samler dokumentasjon om sikkerhetskontroller på arbeidsplassen. Koble til slik at Moxso kan bruke relevante kontrollmangler som kontekst for menneskelig risiko og mer målrettet oppfølging.",
        "description_short": "Bruk sikkerhetskontroller av enheter og arbeidsplassen til å identifisere mangler i beskyttelsen.",
        "title": "Drata"
      },
      "duo": {
        "bullets": [
          {
            "label": "Reelle autentiseringssignaler",
            "text": "{label}: Vellykkede, avviste og mislykkede hendelser samt rapportert svindel bidrar til å identifisere aktivitet som trenger vurdering."
          },
          {
            "label": "Nyttig kontekst",
            "text": "{label}: Tilgjengelige autentiseringsfaktorer og årsaker til resultater bidrar til å forklare hva som skjedde."
          },
          {
            "label": "Målrettet veiledning",
            "text": "{label}: Målrett råd om å gjenkjenne uventede forespørsler og beskytte tilgang der relevante hendelser oppstår."
          },
          {
            "label": "Gjentatt aktivitet",
            "text": "{label}: Vurder gjentakende avvisninger eller feil sammen med annen dokumentasjon før du velger tiltak."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser autentiseringsaktivitet og utvalgt sikkerhetsaktivitet uten å godkjenne forespørsler eller endre Duo-policyer."
          }
        ],
        "description_long": "Duo bidrar til å beskytte kontoer med flerfaktorautentisering. Koble til slik at Moxso kan bruke reelle autentiseringsresultater som grunnlag for oppfølging av MFA-vaner og kontosikkerhet.",
        "description_short": "Bruk autentiseringsresultater som grunnlag for oppfølging av MFA og kontosikkerhet.",
        "title": "Duo"
      },
      "fortinet_fortianalyzer": {
        "bullets": [
          {
            "label": "Tilgangssignaler",
            "text": "{label}: Støttede autentiseringsresultater bidrar til å identifisere kontoaktivitet som bør undersøkes."
          },
          {
            "label": "Sensitive endringer",
            "text": "{label}: Administrative hendelser gir ytterligere dokumentasjon på endringer som påvirker miljøet ditt."
          },
          {
            "label": "Målrettet oppfølging",
            "text": "{label}: Bruk relevant kontoaktivitet som grunnlag for undersøkelser og råd om tilgangssikkerhet."
          },
          {
            "label": "Gjentakende mønstre",
            "text": "{label}: Vurder gjentatte tilgangsproblemer sammen med andre signaler før du velger respons."
          },
          {
            "label": "Datatilgang",
            "text": "{label}: Bruker loggsøkoppgaver til å lese utvalgte hendelser uten å endre brannmurkonfigurasjonen."
          }
        ],
        "description_long": "FortiAnalyzer samler sikkerhetsaktivitet fra Fortinet-miljøet ditt. Koble til slik at Moxso kan bruke utvalgte tilgangs- og administrasjonshendelser som grunnlag for vurderinger av menneskelig risiko.",
        "description_short": "Vurder autentiserings- og administrasjonshendelser fra Fortinet-miljøet ditt.",
        "title": "FortiAnalyzer"
      },
      "github_enterprise": {
        "bullets": [
          {
            "label": "Sensitive endringer",
            "text": "{label}: Utvalgte revisjonshendelser fremhever endringer i tilgang, tillatelser og kontosikkerhet."
          },
          {
            "label": "Aktivitet knyttet til kodetilgang",
            "text": "{label}: Støttede Git-hendelser gir ytterligere dokumentasjon på tilgang til kodelagre."
          },
          {
            "label": "Relevant veiledning",
            "text": "{label}: Bruk hendelser knyttet til ansatte til å målrette råd om beskyttelse av påloggingsinformasjon og sikker utviklingspraksis."
          },
          {
            "label": "Mønstre over tid",
            "text": "{label}: Vurder gjentatt tilgangsaktivitet og sensitive endringer i arbeidssammenhengen de oppstår i."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgte aktivitetsmetadata uten tilgang til kildekoden i kodelagre."
          }
        ],
        "description_long": "GitHub Enterprise beskytter tilgang til kildekoden og utviklingsarbeidsflytene dine. Koble til slik at Moxso kan bruke relevant aktivitet fra utviklerkontoer som grunnlag for vurdering av menneskelig risiko og målrettet sikkerhetsoppfølging.",
        "description_short": "Bruk aktivitet fra utviklerkontoer og tilgang til kodelagre som grunnlag for sikkerhetsoppfølging.",
        "title": "GitHub Enterprise"
      },
      "google_workspace": {
        "bullets": [
          {
            "label": "Reelle aktivitetssignaler",
            "text": "{label}: Utvalgte påloggings-, kontosikkerhets- og administratorhendelser fremhever aktivitet som bør vurderes."
          },
          {
            "label": "Delingsrisiko",
            "text": "{label}: Støttede nedlastinger, delingsendringer og applikasjonsautorisasjoner gir dokumentasjon på hvordan informasjon åpnes."
          },
          {
            "label": "Målrettet oppfølging",
            "text": "{label}: Målrett veiledning om kontobeskyttelse, tredjepartsapper og trygg deling der dokumentasjonen viser et behov."
          },
          {
            "label": "Mønstre over tid",
            "text": "{label}: Vurder gjentatte hendelser og endret tilgangsatferd sammen med resultater fra bevisstgjøring."
          },
          {
            "label": "Lesetilgang",
            "text": "{label}: Leser utvalgte sikkerhetsmetadata uten å lese Gmail-meldinger eller innholdet i Drive-filer."
          }
        ],
        "description_long": "Google Workspace er stedet der folk logger på, deler filer og autoriserer applikasjoner. Koble til slik at Moxso kan bruke sikkerhetsrelevant aktivitet som grunnlag for vurdering av menneskelig risiko og gjøre oppfølgingen mer relevant for det daglige arbeidet.",
        "description_short": "Vurder påloggings-, delings- og applikasjonstilgangsaktivitet som grunnlag for menneskelig risiko.",
        "title": "Google Workspace"
      },
      "gusto": {
        "bullets": [
          {
            "label": "Rolleforståelse",
            "text": "{label}: Stillings- og avdelingskontekst bidrar til å forklare arbeidet bak aktiviteten på en konto."
          },
          {
            "label": "Endringer i ansettelsesforhold",
            "text": "{label}: Tilgjengelig informasjon om ansettelsesstatus støtter samtaler om tilgang når omstendighetene endrer seg."
          },
          {
            "label": "Relevant veiledning",
            "text": "{label}: Ta hensyn til ansvarsområder når du velger temaer for bevisstgjøring og praktiske sikkerhetsråd."
          },
          {
            "label": "Målrettede vurderinger",
            "text": "{label}: Bruk ansettelseskontekst sammen med sikkerhetssignaler når du avgjør hva som trenger oppfølging."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser relevant ansettelsesinformasjon uten å endre godtgjørelse eller kjøre lønn."
          }
        ],
        "description_long": "Gusto vedlikeholder ansettelsesinformasjon når folk begynner, bytter rolle og slutter. Koble til slik at Moxso kan ta hensyn til denne konteksten ved vurdering av menneskelig risiko og gjøre oppfølgingen relevant for den enkeltes ansvarsområder.",
        "description_short": "Legg til kontekst om arbeidsstyrken fra ansattoppføringer.",
        "title": "Gusto"
      },
      "hibob": {
        "bullets": [
          {
            "label": "Rollekontekst",
            "text": "{label}: Ansvarsområder og avdelinger bidrar til å sette sikkerhetsaktivitet i perspektiv."
          },
          {
            "label": "Arbeidsmiljø",
            "text": "{label}: Tilgjengelig informasjon om arbeidssted gir kontekst for å forstå den enkeltes situasjon."
          },
          {
            "label": "Livssyklusendringer",
            "text": "{label}: Endringer i ansettelsesstatus kan gi grunnlag for samtaler om kontotilgang og sikkerhetsansvar."
          },
          {
            "label": "Relevant oppfølging",
            "text": "{label}: Bruk arbeidssituasjonen sammen med faktisk sikkerhetsdokumentasjon som grunnlag for praktiske råd."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser relevant informasjon om arbeidsstyrken uten å endre HR-oppføringer eller få tilgang til prestasjonsvurderinger gjennom denne tilkoblingen."
          }
        ],
        "description_long": "HiBob gir kontekst om folks roller og arbeidsmiljø. Koble til slik at Moxso kan vurdere denne konteksten sammen med menneskelig risiko og gjøre sikkerhetsoppfølgingen mer relevant for det daglige arbeidet.",
        "description_short": "Legg til kontekst om ansatte og stillingsroller fra HR-systemet ditt.",
        "title": "HiBob"
      },
      "hubspot": {
        "bullets": [
          {
            "label": "Påloggingssignaler",
            "text": "{label}: Vellykkede og mislykkede påloggingshendelser bidrar til å identifisere problemer med kontotilgang."
          },
          {
            "label": "Sensitive handlinger",
            "text": "{label}: Utvalgte hendelser knyttet til tillatelser, påloggingsinformasjon, integrasjoner og dataoverføring gir mer kontekst."
          },
          {
            "label": "Relevant veiledning",
            "text": "{label}: Bruk aktivitet knyttet til ansatte til å målrette råd om kontosikkerhet og håndtering av kundeinformasjon."
          },
          {
            "label": "Gjentakende problemer",
            "text": "{label}: Vurder gjentatte hendelser sammen med annen risikodokumentasjon før du velger respons."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgt sikkerhetsaktivitet uten tilgang til CRM-kontakter, avtaler eller markedsføringsinnhold."
          }
        ],
        "description_long": "HubSpot støtter arbeid med kundeinformasjon. Koble til slik at Moxso kan bruke relevante kontotilgangs- og sikkerhetshendelser som grunnlag for vurdering av menneskelig risiko og tilpasse oppfølgingen til dette arbeidet.",
        "description_short": "Vurder påloggings- og sikkerhetsaktivitet knyttet til tilgang til kundeinformasjon.",
        "title": "HubSpot"
      },
      "iru": {
        "bullets": [
          {
            "label": "Beskyttelsesdekning",
            "text": "{label}: Indikatorer for administrasjon og agentstatus bidrar til å identifisere enheter som trenger oppfølging."
          },
          {
            "label": "Enhetstilgjengelighet",
            "text": "{label}: Siste innsjekking og indikatorer for manglende enheter gir kontekst om hvorvidt beskyttelsesinformasjonen er oppdatert."
          },
          {
            "label": "Relevant aktivitet",
            "text": "{label}: Utvalgte sikkerhetsrelaterte revisjonshendelser bidrar til å forklare endringer som bør vurderes."
          },
          {
            "label": "Praktisk oppfølging",
            "text": "{label}: Bruk mangler i beskyttelsen som grunnlag for tiltak sammen med ansatte og IT."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgt enhetssikkerhetsinformasjon uten å utføre handlinger på enheter."
          }
        ],
        "description_long": "Iru hjelper organisasjoner med å administrere og beskytte arbeidsenheter. Koble til slik at Moxso kan ta hensyn til mangler i enhetsadministrasjonsdekningen ved vurdering av menneskelig risiko.",
        "description_short": "Identifiser mangler i enhetsadministrasjonsdekning og agentbeskyttelse.",
        "title": "Iru"
      },
      "jamf_pro": {
        "bullets": [
          {
            "label": "Enhetsbeskyttelse",
            "text": "{label}: Støttet informasjon om FileVault og adgangskoder kan fremheve sikkerhetsinnstillinger som trenger oppfølging."
          },
          {
            "label": "Administrasjonsdekning",
            "text": "{label}: Tilgjengelig administrasjonsstatus bidrar til å fastslå om en enhet er under organisasjonens kontroll."
          },
          {
            "label": "Praktisk oppfølging",
            "text": "{label}: Mangler i beskyttelsen kan danne grunnlag for samtaler med ansatte og IT-teamet som er ansvarlig for enhetene deres."
          },
          {
            "label": "Informerte vurderinger",
            "text": "{label}: Vurder enhetstilstanden sammen med annen dokumentasjon fremfor å behandle en mislykket kontroll som bevis på utrygg atferd."
          },
          {
            "label": "Tilkoblingsstatus",
            "text": "{label}: Denne integrasjonen er for øyeblikket ikke tilgjengelig for tilkobling i den registrerte leverandørkatalogen."
          }
        ],
        "description_long": "Tilgjengelighet: For øyeblikket utilgjengelig. Jamf Pro bidrar til å beskytte Apple-enhetene folk bruker i arbeidet. Enhetssikkerhetsinformasjon kan bidra til å sette menneskelig risiko i kontekst og skille mangler i beskyttelsen fra problemer som krever veiledning til ansatte.",
        "description_short": "Administrasjon av Apple-enheter. Denne integrasjonen er for øyeblikket utilgjengelig.",
        "title": "Jamf Pro"
      },
      "jumpcloud": {
        "bullets": [
          {
            "label": "Autentiseringsdokumentasjon",
            "text": "{label}: Utvalgte Directory Insights-hendelser viser vellykkede og mislykkede tilgangsforsøk."
          },
          {
            "label": "Sensitiv aktivitet",
            "text": "{label}: Støttede administrative hendelser og hendelser med privilegert tilgang fremhever endringer som bør følges opp."
          },
          {
            "label": "Relevant oppfølging",
            "text": "{label}: Bruk kontorelatert dokumentasjon som grunnlag for undersøkelser og veiledning om tilgangssikkerhet."
          },
          {
            "label": "Mønstre over tid",
            "text": "{label}: Vurder gjentakende autentiseringsproblemer og sensitive endringer sammen med andre signaler."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgt sikkerhetsinformasjon uten å endre JumpCloud-innstillinger."
          }
        ],
        "description_long": "JumpCloud bidrar til å sikre tilgang til applikasjoner og enheter. Koble til slik at Moxso kan bruke reelle autentiserings- og administrasjonssignaler som grunnlag for vurdering av menneskelig risiko og rette oppfølgingen mot relevante tilgangsproblemer.",
        "description_short": "Bruk autentiserings- og administrasjonshendelser til å vurdere tilgangsrisiko.",
        "title": "JumpCloud"
      },
      "lattice": {
        "bullets": [
          {
            "label": "Rolleforståelse",
            "text": "{label}: Stillings- og avdelingskontekst bidrar til å forklare den enkeltes ansvarsområder."
          },
          {
            "label": "Kontolivssyklus",
            "text": "{label}: Tilgjengelig informasjon om kontostatus gir kontekst når folk begynner eller slutter å bruke en applikasjon."
          },
          {
            "label": "Relevant veiledning",
            "text": "{label}: Ta hensyn til arbeidsansvar når du velger sikkerhetstemaer og praktiske råd."
          },
          {
            "label": "Målrettede vurderinger",
            "text": "{label}: Bruk organisasjonskontekst sammen med sikkerhetsdokumentasjon når dere diskuterer tilgang og oppfølging."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser relevant konto- og organisasjonsinformasjon uten tilgang til prestasjonsvurderinger, tilbakemeldinger eller godtgjørelse gjennom denne tilkoblingen."
          }
        ],
        "description_long": "Lattice gir kontekst om roller og organisatoriske ansvarsområder. Koble til slik at Moxso kan ta hensyn til denne konteksten ved vurdering av menneskelig risiko og valg av relevant sikkerhetsoppfølging.",
        "description_short": "Legg til kontekst om ansattprofiler og teamstruktur.",
        "title": "Lattice"
      },
      "linear": {
        "bullets": [
          {
            "label": "Kontoendringer",
            "text": "{label}: Støttede revisjonshendelser identifiserer sikkerhetsrelevante endringer, som suspensjon av kontoer."
          },
          {
            "label": "Tilgangskontekst",
            "text": "{label}: Tilgjengelige detaljer om aktør og handling bidrar til å forklare hva som skjedde."
          },
          {
            "label": "Målrettet oppfølging",
            "text": "{label}: Bruk relevante hendelser som grunnlag for gjennomgang av kontotilgang og samtaler om sikkerhet."
          },
          {
            "label": "Mønstre over tid",
            "text": "{label}: Vurder gjentakende endringer sammen med andre sikkerhetssignaler."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgte revisjonsmetadata uten tilgang til saksinnhold. Revisjonslogger krever et kvalifiserende Enterprise-abonnement."
          }
        ],
        "description_long": "Linear støtter samarbeid innen produkt og utvikling. Koble til slik at Moxso kan bruke utvalgte konto- og tilgangsendringer som grunnlag for vurdering av menneskelig risiko og bidra til målrettet sikkerhetsoppfølging.",
        "description_short": "Vurder konto- og tilgangsendringer på tvers av produkt- og utviklingsteam.",
        "title": "Linear"
      },
      "microsoft_defender_xdr": {
        "bullets": [
          {
            "label": "Reelle trusselsignaler",
            "text": "{label}: Varsler og hendelser identifiserer aktivitet som Microsoft anser som mistenkelig eller ondsinnet."
          },
          {
            "label": "Eksponeringskontekst",
            "text": "{label}: Tilgjengelige endepunktfunn og sårbarheter bidrar til å forklare omstendighetene rundt en hendelse."
          },
          {
            "label": "Målrettet oppfølging",
            "text": "{label}: Prioriter undersøkelser og relevant sikkerhetsveiledning der funn gjelder personer eller arbeidsenhetene deres."
          },
          {
            "label": "Fremdrift i undersøkelser",
            "text": "{label}: Endringer i funnstatus bidrar til å skille aktive problemer fra løste oppgaver."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgte funn uten å isolere enheter, lukke hendelser eller utføre rettelser."
          }
        ],
        "description_long": "Microsoft Defender XDR identifiserer trusler på tvers av Microsoft-miljøet ditt. Koble til slik at Moxso kan bruke relevante varsler og hendelser til å forankre vurderinger av menneskelig risiko i reelle sikkerhetshendelser.",
        "description_short": "Ta med Microsoft-sikkerhetsvarsler, hendelser og sårbarheter i risikovurderinger.",
        "title": "Microsoft Defender XDR"
      },
      "microsoft_entra": {
        "bullets": [
          {
            "label": "Reelle angrepssignaler",
            "text": "{label}: Lekket påloggingsinformasjon, passordspraying, uvanlige reiser og ukjente pålogginger kan avdekke kontoer som trenger oppfølging."
          },
          {
            "label": "Kontekst for menneskelig risiko",
            "text": "{label}: Risikonivåer og deteksjonsdetaljer bidrar til å sette mistenkelig aktivitet i perspektiv."
          },
          {
            "label": "Målrettet oppfølging",
            "text": "{label}: Rett undersøkelser og veiledning om kontosikkerhet mot personene som berøres av relevante hendelser."
          },
          {
            "label": "Risiko over tid",
            "text": "{label}: Endringer fra aktiv risiko til utbedret eller avvist bidrar til å vise hva som fortsatt trenger oppfølging."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser status for risikoutsatte brukere og risikodeteksjoner. Detaljnivået i signalene avhenger av Microsoft-lisensiering; premiumdeteksjoner kan kreve Entra ID P2."
          }
        ],
        "description_long": "Entra ID Protection flagger pålogginger og kontoer som ser ut til å være kompromittert. Koble til slik at Moxso kan bruke reelle identitetsrisikosignaler som grunnlag for oppfølging, basert på det som skjer i miljøet ditt i tillegg til simuleringer.",
        "description_short": "Bruk risikofylte pålogginger og signaler om kontokompromittering til å målrette sikkerhetsoppfølgingen.",
        "title": "Microsoft Entra ID Protection"
      },
      "microsoft_intune": {
        "bullets": [
          {
            "label": "Enhetssikkerhetssignaler",
            "text": "{label}: Tilgjengelige statuser for etterlevelse og kryptering fremhever mangler i beskyttelsen."
          },
          {
            "label": "Relevante endringer",
            "text": "{label}: Utvalgte administrasjonshendelser gir kontekst om handlinger som påvirker enhetssikkerheten."
          },
          {
            "label": "Praktisk oppfølging",
            "text": "{label}: Bidra til å skille et enhetsproblem som krever IT-oppfølging, fra et tema som egner seg for veiledning til ansatte."
          },
          {
            "label": "Endret sikkerhetstilstand",
            "text": "{label}: Ta hensyn til gjeldende beskyttelsesstatus og gjentakende mangler ved risikovurdering."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgt enhetssikkerhets- og revisjonsinformasjon uten å endre enhetsinnstillinger. Krever relevant Intune-tilgang og -lisens."
          }
        ],
        "description_long": "Microsoft Intune bidrar til å beskytte enhetene folk bruker i arbeidet. Koble til slik at Moxso kan vurdere endepunktenes sikkerhetstilstand sammen med menneskelig risiko og gi grunnlag for praktisk oppfølging.",
        "description_short": "Vurder mangler i enhetsetterlevelse og kryptering sammen med menneskelig risiko.",
        "title": "Microsoft Intune"
      },
      "microsoft_purview": {
        "bullets": [
          {
            "label": "Databeskyttelsessignaler",
            "text": "{label}: Støttede DLP-hendelser identifiserer aktivitet som utløste en regel for datahåndtering."
          },
          {
            "label": "Ytterligere risikokontekst",
            "text": "{label}: Utvalgte hendelser knyttet til innsiderisiko gir ytterligere dokumentasjon til undersøkelser der dette er tilgjengelig."
          },
          {
            "label": "Relevant veiledning",
            "text": "{label}: Bruk omstendighetene rundt en hendelse til å målrette råd om trygg håndtering og deling av virksomhetens informasjon."
          },
          {
            "label": "Informert vurdering",
            "text": "{label}: Vurder gjentatte signaler og konteksten deres før du trekker konklusjoner om atferd eller hensikt."
          },
          {
            "label": "Begrenset tilgang",
            "text": "{label}: Leser utvalgte aktivitetsmetadata og kan initialisere de nødvendige datastrømmene. Tilkoblingen endrer ikke databeskyttelsespolicyer."
          }
        ],
        "description_long": "Microsoft Purview bidrar til å identifisere risikofylt håndtering av sensitiv informasjon. Koble til slik at Moxso kan bruke relevante databeskyttelsessignaler som grunnlag for vurderinger av menneskelig risiko og mer målrettet oppfølging.",
        "description_short": "Bruk databeskyttelses- og innsiderisikohendelser som grunnlag for trygg informasjonshåndtering.",
        "title": "Microsoft Purview"
      },
      "microsoft_sentinel": {
        "bullets": [
          {
            "label": "Reelle hendelser",
            "text": "{label}: Alvorlighetsgrad og hendelsesdetaljer gir dokumentasjon på sikkerhetsproblemer som allerede undersøkes."
          },
          {
            "label": "Nyttig kontekst",
            "text": "{label}: Tilgjengelig kilde- og angrepsinformasjon bidrar til å forklare hvorfor en hendelse er viktig."
          },
          {
            "label": "Samordnet oppfølging",
            "text": "{label}: Bruk relevant hendelsesdokumentasjon til å samordne veiledningen til ansatte med sikkerhetsteamets respons."
          },
          {
            "label": "Fremdrift i undersøkelser",
            "text": "{label}: Statusendringer bidrar til å skille nye, aktive og løste problemer."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser hendelsesinformasjon uten å endre undersøkelser eller utføre generelle loggsøk."
          }
        ],
        "description_long": "Microsoft Sentinel samler sikkerhetshendelser for undersøkelse. Koble til slik at Moxso kan vurdere relevante hendelser sammen med menneskelig risiko og bidra til å samordne oppfølgingen med sikkerhetsteamet ditt.",
        "description_short": "Bruk sikkerhetshendelser og undersøkelsesstatus til å samordne oppfølgingen.",
        "title": "Microsoft Sentinel"
      },
      "monday": {
        "bullets": [
          {
            "label": "Kontostatus",
            "text": "{label}: Tilgjengelige aktive og inaktive statuser bidrar til å identifisere kontoer som kan kreve vurdering."
          },
          {
            "label": "Tilgangskontekst",
            "text": "{label}: Kontotyper og teamrelasjoner bidrar til å sette applikasjonstilgang i perspektiv."
          },
          {
            "label": "Målrettede vurderinger",
            "text": "{label}: Vurder kontokontekst sammen med sikkerhetssignaler når du avgjør hvor oppfølging er nødvendig."
          },
          {
            "label": "Relevant oppfølging",
            "text": "{label}: Bruk denne konteksten som grunnlag for samtaler om kontosikkerhet og passende tilgang."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser informasjon om kontotilgang uten å endre monday.com-innstillinger eller få tilgang til innholdet i tavler og elementer."
          }
        ],
        "description_long": "monday.com hjelper team med å organisere arbeid og samarbeide på tvers av avdelinger. Koble til slik at Moxso kan vurdere kontekst om applikasjonstilgang sammen med menneskelig risiko og gjøre oppfølgingen av kontosikkerhet mer relevant.",
        "description_short": "Bruk kontostatus og teamrelasjoner som grunnlag for tilgangsgjennomganger.",
        "title": "monday.com"
      },
      "new_relic": {
        "bullets": [
          {
            "label": "Tilgangskontekst",
            "text": "{label}: Tilgjengelige kontorelasjoner bidrar til å sette tilgang til overvåkingsmiljøet ditt i perspektiv."
          },
          {
            "label": "Organisasjonskontekst",
            "text": "{label}: Gruppemedlemskap gir bakgrunn for å vurdere hvordan tilgang er organisert."
          },
          {
            "label": "Målrettede vurderinger",
            "text": "{label}: Vurder applikasjonstilgang sammen med annen dokumentasjon når du avgjør hva som trenger oppfølging."
          },
          {
            "label": "Relevant oppfølging",
            "text": "{label}: Bruk tilgangskontekst som grunnlag for samtaler om kontosikkerhet med de ansvarlige teamene."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser informasjon om kontotilgang uten å endre New Relic-innstillinger. Denne tilkoblingen samler ikke inn overvåkingsvarsler, applikasjonstelemetri eller revisjonshendelser."
          }
        ],
        "description_long": "New Relic støtter teamene som er ansvarlige for å overvåke systemene dine. Koble til slik at Moxso kan vurdere kontekst om applikasjonstilgang sammen med menneskelig risiko og bidra til målrettede kontosikkerhetsvurderinger.",
        "description_short": "Legg til kontekst om brukerkatalog og gruppemedlemskap fra New Relic.",
        "title": "New Relic"
      },
      "okta": {
        "bullets": [
          {
            "label": "Autentiseringssignaler",
            "text": "{label}: Påloggingsresultater og utvalgte sikkerhetshendelser gir dokumentasjon på hvordan kontoer brukes."
          },
          {
            "label": "Sensitive endringer",
            "text": "{label}: Konto- og tillatelsesendringer bidrar til å identifisere tilgang som bør vurderes nærmere."
          },
          {
            "label": "Målrettet oppfølging",
            "text": "{label}: Bruk relevante hendelser som grunnlag for undersøkelser og praktiske råd om kontosikkerhet."
          },
          {
            "label": "Gjentakende problemer",
            "text": "{label}: Vurder gjentatte autentiseringsproblemer sammen med annen dokumentasjon om menneskelig risiko."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgt sikkerhetsinformasjon uten å endre Okta-kontoer eller tilgangspolicyer."
          }
        ],
        "description_long": "Okta beskytter tilgang til virksomhetens applikasjoner. Koble til slik at Moxso kan bruke autentiserings- og kontosikkerhetssignaler til å forstå reell tilgangsrisiko og gi grunnlag for mer relevant oppfølging.",
        "description_short": "Vurder autentiserings- og kontosikkerhetshendelser for å forstå tilgangsrisiko.",
        "title": "Okta"
      },
      "oneleet": {
        "bullets": [
          {
            "label": "Bekreftede svakheter",
            "text": "{label}: Tilgjengelige funn fra penetrasjonstester beskriver problemer identifisert under sikkerhetstesting."
          },
          {
            "label": "Risikokontekst",
            "text": "{label}: Prioritet, berørte mål og utbedringsveiledning bidrar til å forklare hva som trenger oppfølging."
          },
          {
            "label": "Målrettede tiltak",
            "text": "{label}: Bruk relevante funn som grunnlag for teknisk utbedring og sikkerhetssamtaler med de ansvarlige teamene."
          },
          {
            "label": "Fremdrift over tid",
            "text": "{label}: Funnstatus bidrar til å skille åpne problemer fra arbeid som allerede er håndtert."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser funn uten å kjøre tester eller endre løsningsstatusen deres."
          }
        ],
        "description_long": "Oneleet identifiserer sikkerhetssvakheter gjennom penetrasjonstesting og etterlevelsesarbeid. Koble til for å legge relevante tekniske funn til konteksten som brukes i vurderinger av menneskelig risiko og sikkerhetsoppfølging.",
        "description_short": "Legg til funn fra penetrasjonstester og utbedringskontekst i sikkerhetsvurderinger.",
        "title": "Oneleet"
      },
      "onepassword": {
        "bullets": [
          {
            "label": "Påloggingssignaler",
            "text": "{label}: Vellykkede og mislykkede forsøk gir dokumentasjon på kontotilgangsaktivitet."
          },
          {
            "label": "Sensitive handlinger",
            "text": "{label}: Støttede hendelser knyttet til elementbruk og administrasjon gir kontekst om hvordan passordbehandleren brukes."
          },
          {
            "label": "Målrettet oppfølging",
            "text": "{label}: Rett veiledning om sikker påloggingsinformasjon og undersøkelser mot relevant aktivitet."
          },
          {
            "label": "Mønstre over tid",
            "text": "{label}: Vurder gjentatte tilgangsproblemer sammen med annen kontosikkerhetsdokumentasjon."
          },
          {
            "label": "Ingen tilgang til hemmelig innhold",
            "text": "{label}: Leser aktivitetsmetadata uten tilgang til passord, sikre notater eller dokumenter i hvelv."
          }
        ],
        "description_long": "1Password hjelper folk med å beskytte og bruke påloggingsinformasjonen sin. Koble til slik at Moxso kan bruke påloggingsaktivitet og aktivitet i passordbehandleren som grunnlag for vurdering av menneskelig risiko uten tilgang til hemmelighetene som er lagret i hvelvene dine.",
        "description_short": "Vurder påloggingsaktivitet og aktivitet i passordbehandleren uten tilgang til lagrede hemmeligheter.",
        "title": "1Password"
      },
      "ping_one": {
        "bullets": [
          {
            "label": "Kontostatus",
            "text": "{label}: Tilgjengelig status for aktiverte kontoer gir kontekst for tilgangsgjennomganger."
          },
          {
            "label": "Tilgangsrelasjoner",
            "text": "{label}: Gruppemedlemskap bidrar til å forklare hvordan kontoer er organisert."
          },
          {
            "label": "Målrettede vurderinger",
            "text": "{label}: Vurder tilgangskontekst sammen med sikkerhetshendelser fra de andre tilkoblede verktøyene dine."
          },
          {
            "label": "Relevant oppfølging",
            "text": "{label}: Bruk den samlede dokumentasjonen som grunnlag for samtaler om kontosikkerhet og tilgangsgjennomganger."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser informasjon om kontotilgang uten å endre PingOne-policyer. Denne tilkoblingen samler ikke inn autentiseringshendelser."
          }
        ],
        "description_long": "PingOne bidrar til å administrere tilgang til virksomhetens applikasjoner. Koble til slik at Moxso kan vurdere relevant kontekst om kontotilgang sammen med menneskelig risiko og gi grunnlag for mer målrettede sikkerhetsvurderinger.",
        "description_short": "Legg til kontekst om brukerkatalog og medlemskap fra PingOne.",
        "title": "PingOne"
      },
      "remote": {
        "bullets": [
          {
            "label": "Rollekontekst",
            "text": "{label}: Tilgjengelige ansvarsområder og avdelingsinformasjon bidrar til å sette sikkerhetsproblemer i perspektiv."
          },
          {
            "label": "Arbeidsordninger",
            "text": "{label}: Kontekst om land og ansettelsesmodell kan bidra til å tilpasse råd til den enkeltes situasjon."
          },
          {
            "label": "Endringer i ansettelsesforhold",
            "text": "{label}: Tilgjengelig livssyklusinformasjon støtter samtaler om tilgang når arbeidsordninger endres."
          },
          {
            "label": "Relevant oppfølging",
            "text": "{label}: Vurder kontekst om arbeidsstyrken sammen med sikkerhetsdokumentasjon når du velger praktisk veiledning."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser relevant ansettelsesinformasjon uten å endre kontrakter eller behandle lønn."
          }
        ],
        "description_long": "Remote hjelper med å administrere personer som arbeider på tvers av land og ansettelsesordninger. Koble til slik at Moxso kan ta hensyn til relevant arbeidskontekst ved vurdering av menneskelig risiko og planlegging av sikkerhetsoppfølging.",
        "description_short": "Legg til kontekst om arbeidsstyrken for globale og distribuerte team.",
        "title": "Remote"
      },
      "rippling": {
        "bullets": [
          {
            "label": "Rolleforståelse",
            "text": "{label}: Informasjon om stilling og arbeidssituasjon bidrar til å forklare ansvarsområdene bak kontoaktivitet."
          },
          {
            "label": "Ansettelseskontekst",
            "text": "{label}: Tilgjengelig status for arbeidsstyrken gir bakgrunn for tilgangsgjennomganger når omstendighetene endrer seg."
          },
          {
            "label": "Relevant veiledning",
            "text": "{label}: Ta hensyn til den enkeltes ansvarsområder når du velger sikkerhetsråd og temaer for bevisstgjøring."
          },
          {
            "label": "Målrettede vurderinger",
            "text": "{label}: Bruk ansettelseskontekst sammen med sikkerhetsdokumentasjon som grunnlag for samtaler om tilgang og oppfølging."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser relevant informasjon om arbeidsstyrken uten å endre lønn, fordeler eller tilgangsinnstillinger i Rippling."
          }
        ],
        "description_long": "Rippling vedlikeholder kontekst om folks roller og ansettelsesforhold. Koble til slik at Moxso kan vurdere denne konteksten sammen med menneskelig risiko og gjøre sikkerhetsoppfølgingen relevant når ansvarsområder endres.",
        "description_short": "Legg til kontekst om ansatte og arbeidsstyrken fra Rippling.",
        "title": "Rippling"
      },
      "sentinel_one": {
        "bullets": [
          {
            "label": "Reelle trusselsignaler",
            "text": "{label}: Trusler og varsler identifiserer mistenkelig aktivitet som påvirker arbeidsenheter."
          },
          {
            "label": "Risikokontekst",
            "text": "{label}: Tilgjengelig informasjon om alvorlighetsgrad, klassifisering og sårbarheter bidrar til å forklare hva som trenger oppfølging."
          },
          {
            "label": "Målrettede tiltak",
            "text": "{label}: Bruk dokumentasjonen til å samordne undersøkelser og avgjøre om oppfølgingen hører hjemme hos IT, sikkerhetsteamet eller en ansatt."
          },
          {
            "label": "Endret status",
            "text": "{label}: Oppdateringer av funn bidrar til å skille vedvarende problemer fra aktivitet som allerede er håndtert."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgt sikkerhetsinformasjon uten å isolere enheter eller utbedre trusler."
          }
        ],
        "description_long": "SentinelOne oppdager og undersøker endepunkttrusler. Koble til slik at Moxso kan bruke relevante trusselsignaler som grunnlag for vurdering av menneskelig risiko og bidra til målrettet sikkerhetsoppfølging.",
        "description_short": "Bruk endepunkttrusler og sårbarhetsfunn til å målrette sikkerhetsoppfølgingen.",
        "title": "SentinelOne"
      },
      "slack": {
        "bullets": [
          {
            "label": "Reell kontoaktivitet",
            "text": "{label}: Støttede påloggings- og tilgangshendelser bidrar til å avdekke kontosikkerhetsproblemer."
          },
          {
            "label": "Delingssignaler",
            "text": "{label}: Utvalgte filrelaterte hendelser og delingshendelser gir ytterligere dokumentasjon på hvordan informasjon håndteres."
          },
          {
            "label": "Målrettet veiledning",
            "text": "{label}: Målrett råd om trygt samarbeid, kontobeskyttelse og informasjonsdeling der relevante hendelser oppstår."
          },
          {
            "label": "Mønstre over tid",
            "text": "{label}: Vurder gjentakende aktivitet sammen med resultater fra bevisstgjøring og simuleringer."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgte revisjonsmetadata uten å lese meldinger eller filinnhold. Revisjonstilgang krever en kvalifiserende Slack Enterprise-organisasjon."
          }
        ],
        "description_long": "Slack er stedet der folk samarbeider og deler informasjon gjennom dagen. Koble til slik at Moxso kan bruke relevante påloggings- og delingssignaler som grunnlag for vurdering av menneskelig risiko og mer praktisk oppfølging.",
        "description_short": "Bruk påloggings- og delingsaktivitet som grunnlag for tryggere samarbeid i hverdagen.",
        "title": "Slack"
      },
      "splunk": {
        "bullets": [
          {
            "label": "Sikkerhetsfunn",
            "text": "{label}: Utvalgte funn fremhever aktivitet som sikkerhetsovervåkingen din har identifisert for oppfølging."
          },
          {
            "label": "Kontoaktivitet",
            "text": "{label}: Støttede autentiserings- og administrasjonshendelser gir ytterligere dokumentasjon til undersøkelser."
          },
          {
            "label": "Relevant oppfølging",
            "text": "{label}: Bruk funn knyttet til personer eller kontoene deres som grunnlag for sikkerhetstiltak og råd."
          },
          {
            "label": "Endret risiko",
            "text": "{label}: Oppdatert funnstatus bidrar til å sette vedvarende problemer i kontekst."
          },
          {
            "label": "Datatilgang",
            "text": "{label}: Bruker søk til å lese utvalgt sikkerhetsinformasjon uten å endre de underliggende funnene."
          }
        ],
        "description_long": "Splunk samler sikkerhetsdokumentasjon fra hele miljøet ditt. Koble til slik at Moxso kan bruke utvalgte funn og kontorelaterte hendelser som grunnlag for vurdering av menneskelig risiko og målrettet oppfølging.",
        "description_short": "Samle sikkerhetsfunn og kontoaktivitet for vurderinger av menneskelig risiko.",
        "title": "Splunk"
      },
      "statuspage": {
        "bullets": [
          {
            "label": "Tjenestehendelser",
            "text": "{label}: Publisert hendelsesinformasjon forklarer driftsforstyrrelser rapportert av tjenesteeieren."
          },
          {
            "label": "Berørte tjenester",
            "text": "{label}: Komponentstatus bidrar til å identifisere hvilke deler av en tjeneste som er berørt."
          },
          {
            "label": "Planlagt vedlikehold",
            "text": "{label}: Vedlikeholdsvarsler gir kontekst for forventede avbrudd."
          },
          {
            "label": "Fremdrift i håndtering",
            "text": "{label}: Hendelsesoppdateringer bidrar til å forklare om et problem undersøkes eller er løst."
          },
          {
            "label": "Driftskontekst",
            "text": "{label}: En driftsforstyrrelse alene fastslår ikke at en konto er kompromittert, eller at en ansatt har utvist utrygg atferd."
          }
        ],
        "description_long": "Redaksjonell status: Utkast; omfanget av Moxso-integrasjonen er ikke verifisert i dette kodelageret. Statuspage kommuniserer tjenestehendelser og vedlikehold. Informasjon om tjenestestatus kan gi nyttig bakgrunn under sikkerhetsoppfølging og hjelpe team med å forstå når et tilgangsproblem sammenfaller med en kjent driftsforstyrrelse.",
        "description_short": "Kontekst om tjenestehendelser og vedlikehold. Integrasjonens omfang er ennå ikke verifisert.",
        "title": "Statuspage"
      },
      "tailscale": {
        "bullets": [
          {
            "label": "Tilgangstilstand",
            "text": "{label}: Enhetsautorisasjon og status for ekstern tilgang bidrar til å identifisere forhold som bør kontrolleres."
          },
          {
            "label": "Beskyttelseskontekst",
            "text": "{label}: Informasjon om nøkkelutløp og tilkoblingsstatus gir ytterligere kontekst om nettverkstilgang."
          },
          {
            "label": "Praktisk oppfølging",
            "text": "{label}: Bruk relevante tilgangsproblemer som grunnlag for enhetssikkerhetskontroller med det ansvarlige teamet."
          },
          {
            "label": "Gjeldende forhold",
            "text": "{label}: Vurder tilgangstilstanden etter hvert som den endrer seg, fremfor å behandle et gammelt øyeblikksbilde som permanent."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser informasjon om enhetstilgang uten å endre nettverksautorisasjon eller fange opp trafikk."
          }
        ],
        "description_long": "Tailscale kobler enheter til det private nettverket ditt. Koble til for å legge til sikkerhetstilstanden for nettverkstilgang i sikkerhetskonteksten som brukes ved vurdering av menneskelig risiko.",
        "description_short": "Vurder enhetsautorisasjon og beskyttelse av nettverkstilgang sammen med menneskelig risiko.",
        "title": "Tailscale"
      },
      "vanta": {
        "bullets": [
          {
            "label": "Sikkerhetskontrollsignaler",
            "text": "{label}: Tilgjengelige kontroller av kryptering, skjermlås, antivirus og passordbehandlere fremhever mangler i beskyttelsen."
          },
          {
            "label": "Tydeligere kontekst",
            "text": "{label}: Individuelle kontrollresultater gir mer nyttige detaljer enn én enkelt etterlevelsesetikett."
          },
          {
            "label": "Praktisk oppfølging",
            "text": "{label}: Bruk relevante mangler som grunnlag for tiltak sammen med ansatte og IT."
          },
          {
            "label": "Endringer over tid",
            "text": "{label}: Ta hensyn til gjeldende kontrollresultater og gjentakende feil ved risikovurdering."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgt sikkerhetsdokumentasjon uten å endre etterlevelsesresultater eller enhetsinnstillinger."
          }
        ],
        "description_long": "Vanta kontrollerer om viktige sikkerhetskontroller er på plass. Koble til slik at Moxso kan vurdere relevante mangler i beskyttelsen sammen med menneskelig risiko og bidra til praktisk oppfølging.",
        "description_short": "Bruk kontroller av kryptering, skjermlås og endepunkter til å identifisere mangler i beskyttelsen.",
        "title": "Vanta"
      },
      "wiz": {
        "bullets": [
          {
            "label": "Skysikkerhetsfunn",
            "text": "{label}: Støttede problemer fremhever eksponeringer som trenger undersøkelse eller utbedring."
          },
          {
            "label": "Nyttig kontekst",
            "text": "{label}: Alvorlighetsgrad og informasjon om berørte ressurser bidrar til å forklare omstendighetene bak et funn."
          },
          {
            "label": "Målrettede tiltak",
            "text": "{label}: Bruk relevant eksponering som grunnlag for samtaler om ansvar og teknisk oppfølging."
          },
          {
            "label": "Endret eksponering",
            "text": "{label}: Oppdateringer av funn bidrar til å skille aktive problemer fra løste oppgaver."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser utvalgte skyfunn uten å endre skykonfigurasjonen."
          }
        ],
        "description_long": "Wiz identifiserer sikkerhetsrisikoer i skymiljøer. Koble til for å legge relevant skyeksponering til konteksten som brukes i vurderinger av menneskelig risiko og samordnet sikkerhetsoppfølging.",
        "description_short": "Legg til skysikkerhetsfunn og eksponeringskontekst i risikovurderingene dine.",
        "title": "Wiz"
      },
      "workos": {
        "bullets": [
          {
            "label": "Kontostatus",
            "text": "{label}: Tilgjengelig informasjon om kontostatus gir kontekst for gjennomgang av applikasjonstilgang."
          },
          {
            "label": "Tilgangsrelasjoner",
            "text": "{label}: Organisasjons- og grupperelasjoner bidrar til å sette kontotilgang i perspektiv."
          },
          {
            "label": "Målrettede vurderinger",
            "text": "{label}: Vurder kontokontekst sammen med sikkerhetshendelser fra andre tilkoblede verktøy."
          },
          {
            "label": "Relevant oppfølging",
            "text": "{label}: Bruk den samlede dokumentasjonen som grunnlag for tilgangsgjennomganger og samtaler om kontosikkerhet."
          },
          {
            "label": "Kun lesetilgang",
            "text": "{label}: Leser informasjon om katalogtilgang uten å endre kontoer. Denne tilkoblingen samler ikke inn påloggingshendelser eller øktaktivitet."
          }
        ],
        "description_long": "WorkOS kobler applikasjoner til organisasjonens tilgangssystemer. Koble til slik at Moxso kan vurdere relevant kontekst om kontotilgang sammen med menneskelig risiko og bidra til målrettede sikkerhetsvurderinger.",
        "description_short": "Legg til kontekst om katalog og organisasjonsmedlemskap fra WorkOS.",
        "title": "WorkOS"
      }
    },
    "human_risk_intelligence": {
      "assignment": {
        "rule_labels": {
          "cooldown_days": "Nedkjølingsvindu",
          "interval_days": "Tildelingsintervall",
          "respect_mandatory_training": "Ta hensyn til obligatorisk opplæring"
        }
      },
      "assignment_status": {
        "awaiting_assignment": "Ikke planlagt ennå",
        "completed": "Fullført",
        "due_soon": "Forfaller snart",
        "overdue": "Forsinket"
      },
      "intervention": {
        "notification_type": {
          "hri_employee_intervention_email": "Intervensjons-e-post til ansatt",
          "hri_intervention_email": "Intervensjons-e-post til ansatt"
        }
      },
      "onboarding": {
        "glance": {
          "notifications_behavior": {
            "continue_until_completion": "Varsler sendes etter fristen frem til fullføring",
            "stop_after_deadline": "Varsler stopper når fristen er passert"
          },
          "notifications_frequency": {
            "intense": "Intens",
            "loose": "Løs",
            "normal": "Normalt"
          }
        }
      },
      "polarity": {
        "neutral": "Nøytral",
        "risky": "Risikofylt",
        "vigilant": "Årvåken"
      },
      "risk_level": {
        "critical": "Kritisk",
        "high": "Høy",
        "low": "Lav",
        "minimal": "Minimal",
        "moderate": "Moderat",
        "severe": "Alvorlig"
      },
      "risk_matrix": {
        "columns": {
          "somewhat_likely": "Noe sannsynlig",
          "very_likely": "Svært sannsynlig",
          "very_unlikely": "Svært usannsynlig"
        },
        "rows": {
          "high": "Høy",
          "low": "Lav",
          "medium": "Moderat"
        }
      },
      "settings": {
        "interventions": {
          "actions": {
            "assignment": "Tildel ny leksjon",
            "notify_admin": "Varsle administratorer",
            "notify_employee": "Varsle ansatt",
            "notify_manager": "Varsle leder"
          },
          "groups": {
            "breach_exposure": {
              "description": "Reager når en ansatt vises i et kjent databrudd.",
              "title": "Bruddeksponering"
            },
            "critical_phishing_interactions": {
              "description": "Reager når en ansatt utfører en kritisk phishing-handling, som å sende inn påloggingsinformasjon, åpne et vedlegg eller svare.",
              "title": "Kritiske phishing-interaksjoner"
            },
            "phishing_interactions": {
              "description": "Reager når en ansatt klikker på en lenke i en phishing-simulering via e-post eller SMS.",
              "title": "Phishing-interaksjoner"
            },
            "simulation_non_reporting": {
              "description": "Reager når en ansatt ikke rapporterer en phishing-simulering innen 2 eller 7 dager.",
              "title": "Manglende rapportering av simulering"
            },
            "training_inactivity": {
              "description": "Reager når en ansatts obligatoriske opplæring er forsinket.",
              "title": "Opplæringsinaktivitet"
            }
          },
          "severities": {
            "high": "Høy (60+ dager forsinket)",
            "low": "Lav (7 dager forsinket)",
            "medium": "Middels (30 dager forsinket)"
          },
          "timeframe_options": {
            "intense": "Intens",
            "loose": "Løs",
            "normal": "Normal"
          }
        },
        "strategy": {
          "compliance": {
            "description": "Tildeler opplæring for å oppfylle dokumenterte krav i ISO 27001, SOC 2 og relaterte rammeverk.",
            "glance": "for å oppfylle organisasjonens etterlevelseskrav",
            "title": "Etterlevelsesopplæring"
          },
          "group": {
            "description": "Justerer opplæring ved hjelp av aggregerte atferdstrender på tvers av team og avdelinger, uten å målrette enkeltpersoner.",
            "glance": "basert på aggregerte atferdsrisikosignaler",
            "title": "Gruppebasert opplæring"
          },
          "intervention": {
            "description": "Utruller målrettede intervensjoner drevet av ansattes atferdssignaler. Gir skreddersydd opplæring og korrigerende tiltak for å håndtere identifiserte risikomønstre og målbart redusere organisasjonens eksponering.",
            "title": "Intervensjonsstrategi"
          },
          "risk": {
            "description": "Tildeler opplæring basert på jobbrolle, tilgangsnivå og ansvarsdrevet risiko i tråd med NIS2-forventninger.",
            "glance": "basert på hver ansatts rollerisikoprofil",
            "title": "Risikobasert opplæring"
          }
        },
        "summary_signals": {
          "impact": {
            "high": "Høy påvirkning",
            "low": "Lav påvirkning",
            "medium": "Middels påvirkning"
          },
          "signal_labels": {
            "failed_simulation": "Mislykket phishing-simulering",
            "low_score": "Lav opplæringspoengsum"
          }
        }
      },
      "trend": {
        "down": "Ned",
        "stable": "Stabil",
        "up": "Opp"
      }
    },
    "indicators": {
      "A_10": "A.10",
      "A_11": "A.11",
      "A_13": "A.13",
      "A_14": "A.14",
      "A_15": "A.15",
      "A_16": "A.16",
      "A_17": "A.17",
      "A_19": "A.19",
      "A_21_2_A": "A.21(2)(a)",
      "A_21_2_B": "A.21(2)(b)",
      "A_21_2_C": "A.21(2)(c)",
      "A_21_2_D": "A.21(2)(d)",
      "A_21_2_F": "A.21(2)(f)",
      "A_21_2_G": "A.21(2)(g)",
      "A_21_2_I": "A.21(2)(i)",
      "A_23": "A.23",
      "A_24": "A.24",
      "A_26": "A.26",
      "A_28": "A.28",
      "A_30": "A.30",
      "A_32": "A.32",
      "A_33": "A.33",
      "A_34": "A.34",
      "A_39_1_B": "A.39(1)(b)",
      "A_4": "A.4",
      "A_5": "A.5",
      "A_5_15": "A.5.15",
      "A_5_17": "A.5.17",
      "A_5_1_C": "A.5(1)(c)",
      "A_5_1_E": "A.5(1)(e)",
      "A_5_1_F": "A.5(1)(f)",
      "A_5_23": "A.5.23",
      "A_5_24": "A.5.24",
      "A_5_25": "A.5.25",
      "A_5_26": "A.5.26",
      "A_5_27": "A.5.27",
      "A_5_28": "A.5.28",
      "A_5_31": "A.5.31",
      "A_5_34": "A.5.34",
      "A_5_7": "A.5.7",
      "A_6": "A.6",
      "A_6_3": "A.6.3",
      "A_6_7": "A.6.7",
      "A_7_1": "A.7.1",
      "A_7_2": "A.7.2",
      "A_7_3": "A.7.3",
      "A_7_4": "A.7.4",
      "A_8": "A.8",
      "A_8_1": "A.8.1",
      "A_8_2": "A.8.2",
      "A_8_23": "A.8.23",
      "A_8_5": "A.8.5",
      "A_8_7": "A.8.7",
      "A_8_9": "A.8.9",
      "A_9": "A.9",
      "CC1_1": "CC1.1",
      "CC2_1": "CC2.1",
      "CC3_2": "CC3.2",
      "CC4_1": "CC4.1",
      "CC5_2": "CC5.2",
      "CC6_1": "CC6.1",
      "CC7_2": "CC7.2",
      "CC8_1": "CC8.1",
      "CC9_2": "CC9.2",
      "C_10": "C.10",
      "C_6": "C.6",
      "C_7": "C.7",
      "C_8": "C.8",
      "C_9": "C.9",
      "administration": "Administrasjon",
      "ai_act": "AI Act",
      "customer-support-success": "Kundestøtte og kundesuksess",
      "data-analytics": "Data og analyse",
      "dora": "DORA",
      "education-training": "Utdanning og opplæring",
      "elevated": "Utvidet tilgang",
      "engineering-development": "Engineering og utvikling",
      "executive-leadership": "Øverste ledelse",
      "facilities-services": "Fasiliteter og tjenester",
      "finance": "Finans",
      "human-resources": "HR",
      "individual_contributor": "Individuell bidragsyter",
      "iso_27001": "ISO 27001",
      "iso_27005": "ISO 27005",
      "it-systems": "IT og systemer",
      "leadership": "Ledelse",
      "legal-compliance": "Jus og etterlevelse",
      "management-team-leadership": "Ledelse og teamansvar",
      "managerial": "Lederansvar",
      "marketing-communications": "Markedsføring og kommunikasjon",
      "nis2": "NIS2",
      "operations": "Drift",
      "product-design": "Produkt og design",
      "project-program-management": "Prosjekt- og programledelse",
      "quality-process": "Kvalitet og prosess",
      "research-science": "Forskning og vitenskap",
      "sales": "Salg",
      "security": "Sikkerhet",
      "soc_2": "SOC 2",
      "standard": "Standardtilgang",
      "supply-chain-logistics": "Forsyningskjede og logistikk"
    },
    "industries": {
      "aerospace_defence": "Luftfart og forsvar",
      "automotive": "Bilindustri",
      "banking": "Bank og kapitalmarkeder",
      "capital_infrastructure": "Kapitale prosjekter og infrastruktur",
      "consumer_markets": "Forbrukermarkeder",
      "energy_resources": "Energi, verktøy og ressurser",
      "engineering_construction": "Ingeniørfag og bygg og anlegg",
      "financial_services": "Finansielle tjenester",
      "government_public": "Offentlige tjenester og myndigheter",
      "healthcare": "Helsevesen",
      "hospitality_leisure": "Hotell og fritid",
      "industrial_manufacturing": "Industriell produksjon",
      "insurance": "Forsikring",
      "media": "Media",
      "paper_packaging": "Skog, papir og emballasje",
      "pharmaceuticals": "Farmasøytisk og biovitenskap",
      "private_equity": "Privat egenkapital",
      "technology": "Teknologi",
      "telecommunications": "Telekommunikasjon",
      "transportation": "Transport og logistikk",
      "wealth_management": "Forvaltning av eiendeler og formue"
    },
    "integrations": {
      "conzentrate": {
        "description": "Synkroniser opplæringsdata til Learning Arena",
        "title": "Læringsarena"
      },
      "csv": {
        "description": "Importer ansatte fra en CSV-fil",
        "title": "CSV-import"
      },
      "drata": {
        "description": "Synkroniser bevis på fullført kurs til Drata",
        "title": "Drata"
      },
      "google": {
        "description": "Synkroniser ansatte og grupper fra Google Workspace",
        "group_description": "Importer grupper fra Google Workspace",
        "title": "Google Workspace"
      },
      "google_scim": {
        "title": "Google"
      },
      "microsoft": {
        "description": "Synkroniser ansatte og grupper fra Microsoft Entra ID",
        "group_description": "Importer grupper fra Microsoft Entra ID",
        "title": "Microsoft Entra ID"
      },
      "microsoft_scim": {
        "title": "Microsoft Entra ID"
      },
      "microsoft_teams": {
        "description": "Send opplæringsvarsler direkte i Teams",
        "title": "Microsoft Teams"
      },
      "okta_scim": {
        "title": "Okta"
      },
      "sabacloud": {
        "description": "Synkroniser treningsdata til Saba Cloud",
        "title": "Saba Cloud"
      },
      "slack": {
        "description": "Synkroniser ansatte og grupper fra Slack",
        "group_description": "Importer grupper fra Slack",
        "title": "Slack"
      },
      "slack_notifications": {
        "description": "Send opplæringsvarsler direkte i Slack",
        "title": "Slack-varsler"
      },
      "sync_failures": {
        "default": "Synkroniseringen av denne integrasjonen har mislyktes.",
        "unauthorized": "Synkronisering mislyktes. Vennligst oppdater autentiseringsinnstillingene for denne integrasjonen."
      },
      "vanta": {
        "description": "Synkroniser bevis på kursfullføring til Vanta",
        "title": "Vanta"
      }
    },
    "invalid_user": "Det nåværende passordet er feil.",
    "language": {
      "da_DK": "Dansk",
      "de_DE": "Tysk",
      "en_US": "Engelsk",
      "es_ES": "Spansk",
      "fi_FI": "Finsk",
      "fr_FR": "Fransk",
      "nb_NO": "Norsk (Bokmål)",
      "nl_NL": "Nederlandsk",
      "pl_PL": "Polsk",
      "pt_PT": "Portugisisk",
      "sv_SE": "Svensk"
    },
    "learning_profile": {
      "data_privacy": {
        "description": "Sikring av personvern og beskyttelse av sensitiv data",
        "long": "Datapersonvern (GDPR)",
        "short": "Databeskyttelse"
      },
      "device_security": {
        "description": "Sikkerhet for fysiske enheter og endepunkter",
        "long": "Enhetssikkerhet",
        "short": "Enhetssikkerhet"
      },
      "digital_threats": {
        "description": "Beskyttelse mot ulike trusler på nettet",
        "long": "Digitale trusler",
        "short": "Digitale trusler"
      },
      "hybrid_work": {
        "description": "Sikkerhetsbetraktninger for fjernarbeid og kontorarbeid",
        "long": "Hybridarbeid",
        "short": "Hybridarbeid"
      },
      "incidents_breaches": {
        "description": "Håndtering og forebygging av sikkerhetshendelser",
        "long": "Hendelser og brudd",
        "short": "Hendelser og brudd"
      },
      "passwords_accounts": {
        "description": "Styrke og administrasjon av passord og kontoer",
        "long": "Passord og kontoer",
        "short": "Passord og kontoer"
      },
      "phishing": {
        "description": "Bevissthet og forebygging av phishing-angrep",
        "long": "Phishing",
        "short": "Phishing"
      },
      "physical_security": {
        "description": "Beskyttelse av fysiske eiendeler og områder",
        "long": "Fysisk sikkerhet",
        "short": "Fysisk sikkerhet"
      },
      "secure_browsing": {
        "description": "Sikre metoder for nettsurfing",
        "long": "Sikker nettdrift",
        "short": "Sikker nettlesing"
      }
    },
    "onboarding": {
      "data_privacy": {
        "category": "Datavern (GDPR)",
        "options": {
          "high": "Vi har klare retningslinjer og håndhever strenge tiltak for databeskyttelse",
          "low": "Vi håndterer ikke aktivt samsvar med personopplysninger",
          "medium": "Vi samler inn data, men har ikke formelle retningslinjer på plass"
        },
        "question": "Hvordan håndterer selskapet ditt personopplysninger i henhold til GDPR-regelverket?"
      },
      "device_security": {
        "category": "Enhetssikkerhet",
        "options": {
          "high": "Enheter administreres sentralt, krypteres og overvåkes.",
          "low": "Ansatte bruker sine egne enheter uten håndhevede sikkerhetspolicyer",
          "medium": "Enkelte sikkerhetstiltak er iverksatt, men ikke konsekvent"
        },
        "question": "Hvilke sikkerhetstiltak er på plass for selskapets enheter?"
      },
      "digital_threats": {
        "category": "Digitale trusler",
        "options": {
          "high": "Vi bruker endepunktsikkerhet, brannmurer og opplæring av ansatte",
          "low": "Vi stoler på at ansatte administrerer sin egen sikkerhet",
          "medium": "Noen beskyttelser er på plass, men ikke over hele selskapet."
        },
        "question": "Hvordan beskytter selskapet ditt mot malware og cybertrusler?"
      },
      "hybrid_work": {
        "category": "Hybridarbeid",
        "options": {
          "high": "Ansatte bruker VPN-er, sikre Wi-Fi-nettverk og enheter godkjent av selskapet",
          "low": "Ansatte bruker personlige enheter og usikrede nettverk",
          "medium": "Noen sikkerhetstiltak er anbefalt, men ikke påkrevd"
        },
        "question": "Hvordan administreres sikkerheten for fjernarbeidere?"
      },
      "incidents_breaches": {
        "category": "Hendelser og brudd",
        "options": {
          "high": "Vi har en hendelsesresponsplan og tester den jevnlig",
          "low": "Vi håndterer hendelser reaktivt uten en formell plan",
          "medium": "Vi har en plan men har aldri testet den"
        },
        "question": "Hva er ditt selskaps tilnærming til hendelsesrespons?"
      },
      "passwords_accounts": {
        "category": "Passord og kontoer",
        "options": {
          "high": "Passordbehandlere og MFA er påkrevd for alle ansatte",
          "low": "Ansatte administrerer sine egne passord uten krav",
          "medium": "MFA er valgfritt, og passordpolitikk håndheves ikke strengt"
        },
        "question": "Hvordan håndhever din bedrift passordsikkerhet?"
      },
      "phishing": {
        "category": "Phishing",
        "options": {
          "high": "Ansatte gjennomgår regelmessig opplæring i phishing-bevissthet",
          "low": "Ingen formell opplæring i phishing er på plass",
          "medium": "Noe opplæring tilbys, men ikke regelmessig"
        },
        "question": "Hvordan reduserer bedriften din risikoen for phishing-trusler?"
      },
      "physical_security": {
        "category": "Fysisk sikkerhet",
        "options": {
          "high": "Adgangskontroll, besøkslogger og sikker lagring er på plass",
          "low": "Det finnes ingen formelle fysiske sikkerhetstiltak",
          "medium": "Noen sikkerhetstiltak finnes, men de brukes inkonsekvent"
        },
        "question": "Hvordan håndteres fysisk sikkerhet på kontoret ditt?"
      },
      "secure_browsing": {
        "category": "Sikker nettlesing",
        "options": {
          "high": "Ansatte bruker sikre nettlesere med innholdsfiltrering",
          "low": "Ingen restriksjoner eller sikkerhetspolicyer ved nettlesing",
          "medium": "Noen sikkerhetstiltak er iverksatt, men ikke håndhevet"
        },
        "question": "Hvordan sørger selskapet ditt for sikker internett-surfing?"
      }
    },
    "organizational_role": {
      "access_level": {
        "elevated": "Utvidet tilgang",
        "standard": "Standardtilgang"
      },
      "responsibility_tier": {
        "individual_contributor": "Individuell bidragsyter",
        "leadership": "Ledelse",
        "managerial": "Lederansvar"
      }
    },
    "policies": {
      "audit_notifications_frequency": {
        "intense": "Intens",
        "loose": "Løs",
        "normal": "Normal"
      },
      "audit_status": {
        "completed": "Fullført",
        "draft": "Inaktiv",
        "expired": "Utløpt",
        "running": "Reviderer"
      }
    },
    "report": {
      "labels": {
        "assignment": "Tildeling",
        "assignment_completion": "Fullføring av oppgaver",
        "click_rate": "Klikkrate",
        "clicked": "Klikket",
        "company_score": "Bedriftsscore",
        "completed": "Fullført",
        "course": "Kurs",
        "course_completed": "Fullførte kurs",
        "critical": "Kritisk",
        "handling_rate": "Trusselhåndteringsrate",
        "handling_time": "Behandlingstid for trusler",
        "high": "Høy",
        "in_progress": "Pågår",
        "interventions": "Tiltak",
        "low": "Lav",
        "medium": "Middels",
        "missed_deadlines": "Overskredne frister",
        "negative": "Negativ",
        "neutral": "Nøytral",
        "notify_admin": "Administrator varslet",
        "notify_employee": "Ansatt varslet",
        "notify_manager": "Leder varslet",
        "onboarding": "Introduksjonsrate",
        "overdue": "Forfalt",
        "phishing_quizzes": "Phishingquizer",
        "phishing_susceptibility": "Phishingutsatthet",
        "policy": "Retningslinje",
        "positive": "Positiv",
        "report_rate": "Rapporteringsrate",
        "reported": "Rapportert",
        "reporting_behavior": "Rapporteringsatferd",
        "resilience_score": "Motstandsdyktighetsscore",
        "score": "Robusthetspoeng",
        "sent": "Sendte simuleringer",
        "signals": "Signaler",
        "simulations_received": "Mottatte simuleringer",
        "team_score": "Teamscore",
        "video": "Video",
        "video_quizzes": "Videoquizer",
        "videos_watched": "Videoer sett"
      }
    },
    "reports": {
      "frequencies": {
        "bimonthly": "Annenhver måned",
        "monthly": "Månedlig",
        "quarterly": "Kvartalsvis",
        "weekly": "Ukentlig",
        "yearly": "Årlig"
      },
      "periods": {
        "prev_month": "Forrige måned",
        "prev_quarter": "Forrige kvartal",
        "prev_week": "Forrige uke",
        "prev_year": "Siste 12 måneder",
        "ytd": "År til dags dato"
      },
      "status": {
        "active": "Aktiv",
        "inactive": "Inaktiv"
      },
      "types": {
        "manager": "Lederapport",
        "workspace": "Arbeidsområde Rapport"
      }
    },
    "risk_categories": {
      "agentic_ai": "Agentisk AI",
      "communication_security": "Kommunikasjonssikkerhet",
      "data_protection": "Databeskyttelse",
      "digital_exposure_risk": "Risiko for digital eksponering",
      "endpoint_device_security": "Endepunktsikkerhet",
      "engagement_awareness": "Engasjementsbevissthet",
      "human_use_of_ai": "Menneskelig bruk av AI",
      "identity_access_risk": "Identitets- og tilgangsrisiko",
      "incident_response_readiness": "Beredskap for hendelseshåndtering",
      "mobile_security": "Mobilsikkerhet",
      "physical_security": "Fysisk sikkerhet",
      "policy_regulatory_compliance": "Policy og regelverksetterlevelse",
      "remote_work_risk": "Risiko ved fjernarbeid",
      "social_engineering_risks": "Risiko ved sosial manipulering",
      "third_party_risk": "Tredjepartsrisiko",
      "web_cloud_usage": "Bruk av web og sky"
    },
    "roles": {
      "administration": "Administrasjon",
      "customer-support-success": "Kundestøtte og kundesuksess",
      "data-analytics": "Data og analyse",
      "education-training": "Utdanning og opplæring",
      "engineering-development": "Ingeniørfag og utvikling",
      "executive-leadership": "Toppledelse",
      "facilities-services": "Fasiliteter og tjenester",
      "finance": "Finans",
      "human-resources": "HR",
      "it-systems": "IT og systemer",
      "legal-compliance": "Jus og etterlevelse",
      "management-team-leadership": "Ledelse og teamledelse",
      "marketing-communications": "Markedsføring og kommunikasjon",
      "operations": "Drift",
      "product-design": "Produkt og design",
      "project-program-management": "Prosjekt- og programledelse",
      "quality-process": "Kvalitet og prosess",
      "research-science": "Forskning og vitenskap",
      "sales": "Salg",
      "security": "Sikkerhet",
      "supply-chain-logistics": "Forsyningskjede og logistikk"
    },
    "saml": {
      "name_id_formats": {
        "emailAddress": "E-postadresse",
        "persistent": "Persistent",
        "transient": "Transient",
        "unspecified": "Uspesifisert"
      },
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    },
    "scim": {
      "providers": {
        "auth0_scim": "Auth0",
        "google_scim": "Google",
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    },
    "services": {
      "category": {
        "authentication": "Autentisering",
        "collaboration": "Samarbeid",
        "crm": "CRM",
        "digital_signature": "Digital signatur",
        "document_management": "Dokumenthåndtering",
        "file_sharing": "Fildeling",
        "hrm": "HRM",
        "marketing": "Markedsføring",
        "other": "Annen",
        "support": "Kundestøtte",
        "survey": "Undersøkelse",
        "video_conferencing": "Videokonferanse"
      },
      "target": {
        "all": "Alle",
        "design": "Design",
        "engineering": "Ingeniørtjenester",
        "finance": "Finans",
        "marketing": "Markedsføring",
        "sales": "Salg",
        "support": "Støtte"
      }
    },
    "signals": {
      "key": {
        "access_level": "Tilgangsnivå",
        "ai_act_reference": "AI Act-referanse",
        "breach_found": "Brudd funnet",
        "cybersecurity_culture_initiative_participated": "Deltar i cybersikkerhetsinitiativer",
        "dora_reference": "DORA-referanse",
        "email_simulation_clicked": "E-postsimulering klikket",
        "email_simulation_credentials_submitted": "Innloggingsinformasjon sendt inn i e-postsimulering",
        "email_simulation_delivered": "E-postsimulering levert",
        "email_simulation_reported": "E-postsimulering rapportert",
        "email_simulation_reported_without_clicking": "E-postsimulering rapportert uten å klikke",
        "employee_imported": "Ansatt importert",
        "frameworks": "Rammeverk",
        "high_confidence_in_phishing_self_assessment": "Gjennomgående svart riktig på phishingquizer",
        "iso27001_reference": "ISO27001-referanse",
        "iso27005_reference": "ISO27005-referanse",
        "legitimate_email_reported_as_phishing": "Rapporterer legitime e-poster som phishing-e-poster",
        "low_confidence_in_phishing_self_assessment": "Gjennomgående svart feil på phishingquizer",
        "low_score": "Lav poeng",
        "missed_deadline_30_days": "Obligatorisk opplæring 30 dager forsinket",
        "missed_deadline_60_days": "Obligatorisk opplæring 60 dager forsinket",
        "missed_deadline_7_days": "Obligatorisk opplæring 7 dager forsinket",
        "multiple_choice_answered_correctly": "Flervalgsspørsmål besvart riktig",
        "multiple_choice_answered_incorrectly": "Flervalgsspørsmål besvart feil",
        "nis2_reference": "NIS2-referanse",
        "optional_training_engaged": "Fullførte valgfri opplæring",
        "real_phishing_email_clicked": "Klikket på en ekte phishing-e-post",
        "real_phishing_email_opened": "Åpnet ekte phishing-e-post",
        "real_phishing_email_opened_attachment": "Åpnet et vedlegg i en ekte phishing-e-post",
        "real_phishing_email_reported": "Rapporterte ekte phishing-e-post",
        "real_phishing_email_targeted": "Målrettet i ekte phishing-e-poster",
        "responsibility_tier": "Ansvarsnivå",
        "risk_level": "Risikonivå",
        "risk_themes": "Risikotemaer",
        "risk_threshold": "Risikoterskel",
        "role": "Rolle",
        "role_fallback_used": "Fallback-rolle brukt",
        "simulation_not_reported_2_days": "Simulering ikke rapportert etter 2 dager",
        "simulation_not_reported_7_days": "Simulering ikke rapportert etter 7 dager",
        "sms_simulation_clicked": "SMS-simulering klikket",
        "sms_simulation_delivered": "SMS-simulering levert",
        "sms_simulation_reported": "SMS-simulering rapportert",
        "soc2_reference": "SOC2-referanse",
        "threat_reported": "Trussel rapportert",
        "training_completed": "Tildelt opplæring fullført",
        "training_completed_after_deadline": "Fullført etter frist",
        "training_completed_on_time": "Tildelt opplæring fullført i tide",
        "training_inactivity": "Opplæringsinaktivitet",
        "training_video_watched": "Opplæringsvideo sett"
      },
      "sentiment": {
        "negative": "Negativ",
        "neutral": "Nøytral",
        "positive": "Positiv"
      },
      "severity": {
        "critical": "Kritisk",
        "high": "Høy",
        "low": "Lav",
        "medium": "Middels",
        "neutral": "Nøytral"
      }
    },
    "simulations": {
      "delivery_method": {
        "email": "E-post",
        "sms": "Tekstmelding"
      },
      "delivery_rate": {
        "high": "Høy",
        "low": "Lav",
        "medium": "Middels"
      },
      "failures": {
        "failed_to_deliver": "Leveringsfeil",
        "failed_to_send": "Sendefeil",
        "invalid_receiver": "Mottakerfeil",
        "invalid_template": "Malfeil",
        "no_template_available": "Malfeil"
      },
      "preview": {
        "CampaignClick": "{name} klikket på en lenke",
        "CampaignReport": "{name} rapporterte simuleringen",
        "CampaignSent": "Simuleringen ble sendt til {name}",
        "CampaignSubmission": "{name} sendte inn et innloggingsskjema",
        "activity": "Aktivitet",
        "title": "Forhåndsvisning"
      },
      "schedule_type": {
        "missing": "Ingen leveringsmetode",
        "one_off": "Engangs",
        "recurring": "Gjentakende"
      },
      "status": {
        "cancelled": "Avbrutt",
        "completed": "Ferdig",
        "draft": "Utkast",
        "paused": "Paused",
        "running": "Kjører",
        "sending": "Sende"
      },
      "templates": {
        "editor": {
          "sidebar_blocks": {
            "button": "Knapp",
            "columns": "Kolonner",
            "container": "Container",
            "divider": "Skillelinje",
            "heading1": "Overskrift 1",
            "heading2": "Overskrift 2",
            "heading3": "Overskrift 3",
            "image": "Bilde",
            "spacer": "Mellomrom",
            "text": "Tekst"
          }
        }
      }
    },
    "statistics": {
      "activities_by_type": {
        "completed_courses": "Fullførte kurs",
        "phishing_quiz_correct_answers": "Korrekte svar på phishingquiz",
        "phishing_quiz_incorrect_answers": "Feil svar på phishing-quiz",
        "quiz_answers": "Quizsvar",
        "quiz_correct_answers": "Riktige svar på quiz",
        "quiz_incorrect_answers": "Feil svar på quiz",
        "simulations_delivered": "Simulatorer levert",
        "simulations_failed": "Mislykkede simuleringer",
        "simulations_passed": "Beståtte simuleringer",
        "simulations_reported": "Rapporterte simuleringer",
        "text": "Hvordan dine ansatte trener",
        "threats_reported": "Rapporterte trusler",
        "title": "Fullførte aktiviteter",
        "videos_watched": "Videoer sett"
      },
      "benchmarks": {
        "above_benchmark_tooltip": "Verdi er over referanseverdien.",
        "below_benchmark_tooltip": "Verdien er under referansepunktet.",
        "benchmark_tooltip": "Referansepunkt"
      },
      "breaches": {
        "critical": "Kritisk",
        "noncritical": "Ikke-kritisk"
      },
      "employees": {
        "beginner": "Nybegynner",
        "expert": "Ekspert",
        "intermediate": "Middels"
      },
      "onboarding": {
        "not_onboarded": "Ikke ombordstilt",
        "onboarded": "Ombordet"
      },
      "participant_partition": {
        "active": "Aktiv",
        "completed": "Fullført",
        "halted": "Stanset"
      },
      "threats": {
        "status_partition": {
          "forwarded": "Videresendt",
          "fraudulent": "Svindelaktig",
          "legitimate": "Legitim",
          "spam": "Søppelpost"
        }
      },
      "time_units": {
        "days": "Dag | Dager",
        "hours": "Time | Timer",
        "minutes": "Minutt | Minutter",
        "seconds": "Sekund | Sekunder",
        "weeks": "Uke | Uker"
      },
      "training": {
        "quizzing": {
          "correct": "Riktig",
          "incorrect": "Feil"
        }
      }
    },
    "tables": {
      "columns": {
        "actor": "Aktør",
        "app": "App",
        "automation_status": "Status",
        "available_at": "Tilgjengelig",
        "breached_at": "Brutt",
        "click_rate": "@:simulations.click_rate.title",
        "completed": "Fullført",
        "completed_at": "Fullført",
        "content_id": "Innhold",
        "content_type": "Innholdstype",
        "created_at": "Opprettet",
        "data_class": "Dataklasse",
        "deadline_at": "Frist",
        "delivery": "@:simulations.summary.schedule_type",
        "delivery_type": "@:tables.delivery_method",
        "deselect_all": "Fjern markering av alle",
        "employee_id": "Ansatt",
        "employee_status": "Status",
        "event": "Hendelse",
        "group_id": "Gruppe",
        "key": "Signal",
        "last_learning_interaction": "Siste interaksjon",
        "published_at": "Publisert",
        "report_rate": "@:simulations.report_rate.title",
        "risk_matrix": "Risikomatrise",
        "role": "Rolle",
        "sentiment": "Sentiment",
        "severity": "Alvorlighetsgrad",
        "signal_group": "Signalgruppe",
        "submission_rate": "@:simulations.submission_rate.title",
        "test": "@:simulations.summary.test",
        "translations": "Oversettelser",
        "type": "Type",
        "zone": "Sone"
      },
      "date_operators": {
        "<": "før",
        "<=": "på eller før",
        "<>": "ikke på",
        "=": "på",
        ">": "etter",
        ">=": "på eller etter"
      },
      "enum_values": {
        "access": "Tilgang",
        "access_revoke": "Tilgang fjernet",
        "active": "Aktiv",
        "admin": "Administrator",
        "all": "Alle",
        "analyst": "Analytiker",
        "api_token_create": "API-token opprettet",
        "api_token_delete": "API-token slettet",
        "assignment": "Tildeling",
        "auth_activity": "Autentiseringsaktivitet",
        "authenticate": "Autentisering",
        "authentication_activity": "Autentiseringsaktivitet",
        "authorized_integration": "Autoriserte integrasjon",
        "breach_config": "Bruddinnstillinger oppdatert",
        "breach_exposure": "Bruddeksponering",
        "breach_found": "Brudd funnet",
        "cancelled": "@:dynamic_keys.simulations.status.cancelled",
        "change": "Endring",
        "changed_data": "Endret data",
        "completed": "@:dynamic_keys.simulations.status.completed",
        "course": "Kurs",
        "course_delete": "Kurs slettet",
        "created_campaign_domain": "Opprettet kampanjedomene",
        "created_integration": "Opprettet integrasjon",
        "created_warehouse_token": "Opprettet datavarehus-token",
        "credential_update": "Påloggingsinformasjon oppdatert",
        "critical": "Kritisk",
        "critical_phishing_interactions": "Innsendt phishing-påloggingsinformasjon",
        "cybersecurity_culture_initiative_participated": "Deltar i cybersikkerhetsinitiativer",
        "data_change": "Data endret",
        "deleted_warehouse_token": "Slettet datavarehus-token",
        "domain_create": "Domene opprettet",
        "draft": "@:dynamic_keys.simulations.status.draft",
        "email": "@:dynamic_keys.simulations.delivery_method.email",
        "email_simulation_clicked": "Klikket på e-postsimulering",
        "email_simulation_credentials_submitted": "Sendte inn legitimasjonsopplysninger i e-postsimulering",
        "email_simulation_delivered": "E-postsimulering levert",
        "email_simulation_reported": "E-postsimulering rapportert",
        "email_simulation_reported_without_clicking": "E-postsimulering rapportert uten å klikke",
        "employee_training_exclude": "Ansatt ekskludert fra opplæring",
        "employee_training_exclusion_expire": "Opplæringsekskludering for ansatt utløpt",
        "employee_training_include": "Ansatt inkludert i opplæring",
        "high": "Høy",
        "high-somewhat_likely": "Høy effekt / Noe sannsynlig",
        "high-very_likely": "Høy effekt / Svært sannsynlig",
        "high-very_unlikely": "Høy effekt / Svært usannsynlig",
        "high_confidence_in_phishing_self_assessment": "Gjennomgående svart riktig på phishingquizer",
        "hub": "Hub",
        "inactive": "Inaktiv",
        "integration_auth": "Integrasjon autorisert",
        "integration_config": "Integrasjonsinnstillinger oppdatert",
        "integration_create": "Integrasjon opprettet",
        "integration_delete": "Integrasjon slettet",
        "integration_update": "Integrasjon oppdatert",
        "intel_config": "Human risk intelligence-innstillinger oppdatert",
        "invited_user": "Inviterte bruker",
        "legitimate_email_reported_as_phishing": "Rapporterer legitime e-poster som phishing-e-poster",
        "login": "Logget inn",
        "login_verify": "Verifisert innlogging",
        "logout": "Logget ut",
        "low": "Lav",
        "low-somewhat_likely": "Lav effekt / Noe sannsynlig",
        "low-very_likely": "Lav effekt / Svært sannsynlig",
        "low-very_unlikely": "Lav effekt / Svært usannsynlig",
        "low_confidence_in_phishing_self_assessment": "Gjennomgående svart feil på phishingquizer",
        "manage": "Administrasjon",
        "med-somewhat_likely": "Moderat effekt / Noe sannsynlig",
        "med-very_likely": "Moderat effekt / Svært sannsynlig",
        "med-very_unlikely": "Moderat effekt / Svært usannsynlig",
        "medium": "Moderat",
        "missed_deadline_30_days": "Obligatorisk opplæring 30 dager forsinket",
        "missed_deadline_60_days": "Obligatorisk opplæring 60 dager forsinket",
        "missed_deadline_7_days": "Obligatorisk opplæring 7 dager forsinket",
        "multiple_choice_answered_correctly": "Flervalgsspørsmål besvart riktig",
        "multiple_choice_answered_incorrectly": "Flervalgsspørsmål besvart feil",
        "negative": "Negative",
        "neutral": "Nøytral",
        "notification": "Varsel",
        "notify_admin": "Varsle administratorer",
        "notify_employee": "Varsle ansatt",
        "notify_manager": "Varsle leder",
        "one_off": "@:dynamic_keys.simulations.schedule_type.one_off",
        "optional_training_engaged": "Fullførte valgfri opplæring",
        "paused": "Pauset",
        "phishing_interactions": "Phishing-interaksjoner",
        "policy": "Retningslinje",
        "positive": "Positive",
        "privacy_config": "Personverninnstillinger oppdatert",
        "quiz": "Quiz",
        "real_phishing_email_opened": "Åpnet ekte phishing-e-post",
        "real_phishing_email_reported": "Rapporterte ekte phishing-e-post",
        "real_phishing_email_targeted": "Målrettet i ekte phishing-e-poster",
        "recurring": "@:dynamic_keys.simulations.schedule_type.recurring",
        "register": "Registrering",
        "removed_user_access": "Fjernet brukertilgang",
        "running": "@:dynamic_keys.simulations.status.running",
        "sending": "@:dynamic_keys.simulations.status.sending",
        "signed_in": "Logget inn",
        "signed_out": "Logget ut",
        "simulation_config": "Simuleringsinnstillinger oppdatert",
        "simulation_non_reporting": "Manglende rapportering av simulering",
        "simulation_not_reported_2_days": "Simulering ikke rapportert etter 2 dager",
        "simulation_not_reported_7_days": "Simulering ikke rapportert etter 7 dager",
        "sms": "@:dynamic_keys.simulations.delivery_method.sms",
        "sms_simulation_clicked": "Klikket på SMS-simulering",
        "sms_simulation_delivered": "SMS-simulering levert",
        "started": "Startet",
        "support": "Support",
        "switched_workspace": "Byttet arbeidsområde",
        "threat_analyst": "Trusselanalytiker",
        "threat_config": "Threat management-innstillinger oppdatert",
        "threat_reported": "Trussel rapportert",
        "training_completed": "Tildelt opplæring fullført",
        "training_completed_after_deadline": "Fullføring etter frist",
        "training_completed_on_time": "Tildelt opplæring fullført i tide",
        "training_config": "Opplæringsinnstillinger oppdatert",
        "training_inactivity": "Opplæringsinaktivitet",
        "training_video_watched": "Opplæringsvideo sett",
        "updated_breach_settings": "Oppdaterte innstillinger for brudd",
        "updated_gdpr_settings": "Oppdaterte GDPR-innstillinger",
        "updated_human_risk_intelligence_settings": "Oppdaterte human risk intelligence-innstillinger",
        "updated_integration": "Oppdaterte integrasjon",
        "updated_integration_settings": "Oppdaterte integrasjonsinnstillinger",
        "updated_integration_token": "Oppdaterte integrasjonstoken",
        "updated_simulation_settings": "Oppdaterte simuleringsinnstillinger",
        "updated_threat_management_settings": "Oppdaterte innstillinger for trusselhåndtering",
        "updated_training_settings": "Oppdaterte opplæringsinnstillinger",
        "updated_workspace_settings": "Oppdaterte arbeidsområdeinnstillinger",
        "user_invite": "Bruker invitert",
        "verified_sign_in": "Verifisert innlogging",
        "video": "Video",
        "video_delete": "Video slettet",
        "viewed_resource": "Viste ressurs",
        "workspace_config": "Arbeidsområdeinnstillinger oppdatert",
        "workspace_switch": "Arbeidsområde byttet"
      },
      "operators": {
        "<>": "er ikke",
        "=": "er"
      }
    },
    "threats": {
      "status": {
        "all": "Alle",
        "forwarded": "Videresendt",
        "fraudulent": "Svindelaktig",
        "legitimate": "Legitim",
        "spam": "Søppelpost",
        "unhandled": "Uhåndtert"
      }
    },
    "training": {
      "type": {
        "course-type": "Kurs",
        "policy-type": "Retningslinje",
        "quiz-type": "Quiz",
        "video-type": "Video"
      }
    },
    "types": {
      "boolean": "Boolsk",
      "date": "Dato",
      "number": "Nummer",
      "string": "Streng"
    },
    "users": {
      "roles": {
        "admin": {
          "text": "Administratorer kan administrere innstillinger, invitere brukere og konfigurere produkter.",
          "title": "Administrator"
        },
        "analyst": {
          "text": "Analytikere kan se og analysere data.",
          "title": "Analytiker"
        },
        "threat_analyst": {
          "text": "Trusselanalytikere kan håndtere trusler og se/analysere data.",
          "title": "Trusselanalytiker"
        }
      }
    },
    "videos": {
      "category": {
        "advanced": {
          "title": "Avansert",
          "tooltip": "Bli en hackingekspert på kort tid"
        },
        "ai": {
          "title": "KI og cybersikkerhet",
          "tooltip": "Utforsk den komplekse rollen til AI innen cybersikkerhet"
        },
        "compliance": {
          "title": "Sertifiseringer og samsvar",
          "tooltip": "Forstå viktigheten av sertifiseringer og overholdelse"
        },
        "gdpr": {
          "title": "GDPR",
          "tooltip": "Lær de viktigste kravene og reglene i GDPR og hvordan du kan overholde dem i din hverdag"
        },
        "hacking": {
          "title": "En hackers liv",
          "tooltip": "Bli kjent med menneskene bak cyberangrepene, hackerne av verden"
        },
        "money_laundering": {
          "title": "Hvitvasking",
          "tooltip": "Lær de forskjellige metodene som kriminelle bruker til å hvitvaske penger, og hvordan man oppdager og forebygger hvitvasking"
        },
        "phishing": {
          "title": "Nettfiske",
          "tooltip": "Oppdag aspektene ved det mest vanlige nettangrepet verden over"
        },
        "physical_security": {
          "title": "Fysisk sikkerhet",
          "tooltip": "Lær hvorfor fysisk sikkerhet er et avgjørende element i god cybersikkerhet"
        },
        "tips_and_tricks": {
          "title": "Tips og triks",
          "tooltip": "Lær hvordan du kan øke din personlige cybersikkerhet"
        },
        "types_of_hacking": {
          "title": "Typer av hacking",
          "tooltip": "Få innsikt i de ulike metodene som brukes av hackere"
        },
        "uploads": {
          "title": "Opplastinger",
          "tooltip": "Se videoer lastet opp av organisasjonen din for dine spesifikke sikkerhetsbehov"
        }
      }
    },
    "workspace_onboarding": {
      "kick_off": {
        "validation": {
          "employee_import": "Minst 1 AD-integrasjon er satt opp riktig",
          "invite_admins": "Inviter administratorer",
          "reporting_add_in": "Sett opp rapporterings-tillegg",
          "simulation": "Sett opp simuleringer",
          "training": "Sett opp opplæring",
          "verify_domain": "Minst 1 domene er verifisert",
          "whitelisting": "Allowlisting er fullført"
        }
      }
    }
  },
  "editor": {
    "loading": "Laster inn"
  },
  "employees": {
    "active_directory": "Active Directory",
    "add_employees": "Legg til ansatte",
    "anonymous_name": "Anonym",
    "bulk_actions": {
      "activate": "Aktiver bruker | Aktiver brukere",
      "deactivate": "Deaktiver bruker | Deaktiver brukere",
      "success": "Statuser oppdatert",
      "x_of_n_selected": "{x} av {n} valgt"
    },
    "current_manager": "Nåværende leder",
    "deleted_user": "Slettet bruker",
    "department": "Avdeling",
    "filter": {
      "status": {
        "active": "Kun aktive ansatte",
        "all": "Alle medarbeidere",
        "inactive": "Kun inaktive ansatte"
      }
    },
    "form": {
      "department": "Avdeling",
      "edit_title": "Innstillinger",
      "email": "E-post",
      "first_name": "Fornavn",
      "language": "Språk",
      "last_name": "Etternavn",
      "manager": "Leder",
      "organisational_role": "Rolle",
      "placeholder": {
        "manager": "Velg leder",
        "role": "Velg rolle",
        "timezone": "Velg tidssone"
      },
      "save_settings": "Lagre innstillinger",
      "scim_enabled_info": "Du kan ikke redigere den ansattes innstillinger fordi SCIM er aktivert for dette arbeidsområdet.",
      "timezone": "Tidssone"
    },
    "manual": "Håndbok",
    "no_email_found": "Ingen e-post funnet",
    "preview": {
      "close_edit": "Lukk",
      "edit": "Rediger",
      "email": "E-post",
      "groups": "Grupper",
      "locale": "Språk",
      "manager": {
        "active_directory": "Active Directory",
        "button": "Se profil",
        "email": "E-post",
        "manual": "Manuell",
        "name": "Navn",
        "source": "Kilde",
        "subtitle": "Oversikt over lederdetaljer",
        "title": "Leder"
      },
      "phone_number": "Telefonnummer",
      "profile": "Vis profil",
      "provider": "Tilbyder",
      "provider_id": "Leverandør-ID",
      "source": "Kilde",
      "status": "Status",
      "tags": "Merknader",
      "title": "Forhåndsvisning"
    },
    "recent_activity": "Ny aktivitet",
    "resilience_score": {
      "text": "Nåværende motstandsevne-score basert på prestasjonene de siste 90 dagene.",
      "title": "Motstandsevne-score"
    },
    "search": {
      "button": "Søk",
      "empty": "Søk etter ansatte...",
      "no_results": "Ingen ansatte funnet"
    },
    "settings": {
      "settings_saved": "Innstillinger lagret",
      "status": {
        "active": {
          "description": "Denne ansatte vil motta simuleringer og treningsøvelser",
          "title": "Aktiv"
        },
        "inactive": {
          "description": "Denne ansatte vil IKKE motta simuleringer og treningøvelser",
          "title": "Inaktiv"
        }
      }
    },
    "simulations": {
      "click_rate": {
        "title": "Klikkfrekvens",
        "tooltip": "Prosentandel av simuleringer klikket."
      },
      "email_validated": "E-post bekreftet: {date}",
      "received": {
        "title": "Simuleringer mottatt",
        "tooltip": "Totalt antall simuleringer mottatt.",
        "unit": "Simuleringer"
      },
      "report_rate": {
        "title": "Rapporteringsfrekvens",
        "tooltip": "Prosentandel av simulasjoner rapportert."
      },
      "submission_rate": {
        "title": "Påloggingsrate",
        "tooltip": "Prosentandel av innloggingsskjemaer som er sendt inn.",
        "x_received": "{count} mottatt"
      }
    },
    "status": "Status",
    "training": {
      "reminder": {
        "reminder_sent": "Påminnelse sendt",
        "subject": "Opplæring i cybersikkerhet",
        "text": "Trusselen fra hackere øker, og du må holde deg oppdatert for å beskytte deg selv og selskapet ditt.",
        "title": "Hei!"
      }
    },
    "videos": {
      "title": "Videoer",
      "unit": "Videoer sett"
    }
  },
  "empty": {
    "activity": {
      "title": "Ingen aktivitet"
    },
    "assigned_learning": {
      "description": "Brukeren har ikke blitt tildelt noen opplæring.",
      "title": "Ingen tildelt læring"
    },
    "automations": {
      "button": "Opprett en sekvens",
      "description": "Kom i gang ved å opprette en sekvens.",
      "title": "Ingen automatiseringer"
    },
    "breaches": {
      "description": "Enhver brudd knyttet til e-postadresser lagt til i huben vil være synlige her.",
      "title": "Ingen brudd"
    },
    "custom_uploads": {
      "button": "Opprett video",
      "description": "Begynn med å lage en video",
      "title": "Ingen videoer funnet"
    },
    "domains": {
      "button": "Legg til domene",
      "description": "Kom i gang ved å legge til et domene.",
      "title": "Ingen domener"
    },
    "employee_simulations": {
      "button": "Gå til simuleringer",
      "description": "Kom i gang ved å legge til en simulering.",
      "title": "Ingen simuleringer"
    },
    "employees": {
      "button": "Legg til ansatt",
      "description_with_button": "Kom i gang ved å legge til en ansatt.",
      "description_without_button": "Ingen ansatte ble funnet.",
      "title": "Ingen ansatte"
    },
    "employees_activity": {
      "description": "Det har ikke vært noen aktivitet for denne ansatte.",
      "title": "Ingen aktivitet"
    },
    "employees_group": {
      "description": "Denne gruppen har ingen tilknyttede ansatte.",
      "title": "Ingen ansatte"
    },
    "employees_training": {
      "description": "Denne {type} har ikke blitt fullført av noen ansatte.",
      "title": "Ingen deltakere"
    },
    "generic": {
      "description": "Ingen poster funnet.",
      "title": "Ingen poster"
    },
    "groups": {
      "button": "Opprett gruppe",
      "description_with_button": "Kom i gang ved å legge til en gruppe.",
      "description_without_button": "Ingen grupper funnet.",
      "title": "Ingen grupper"
    },
    "imports": {
      "description": "Det er synkroniseringer for denne integrasjonen.",
      "title": "Ingen synkroniseringer"
    },
    "participants": {
      "description": "Ingen deltakere ble funnet.",
      "title": "Ingen deltakere"
    },
    "policies": {
      "description": "Kom i gang ved å opprette en policy.",
      "title": "Ingen retningslinjer"
    },
    "reports": {
      "description": "Kom i gang ved å opprette en ny planlagt rapport",
      "title": "Ingen planlagte rapporter"
    },
    "scim_connections": {
      "description": "Opprett en tilkobling for Microsoft Entra ID eller Okta.",
      "title": "Ingen SCIM-tilkoblinger"
    },
    "scim_tokens": {
      "description": "Ingen SCIM-tokens er opprettet for dette arbeidsområdet.",
      "title": "Ingen SCIM-tokens"
    },
    "simulation_events": {
      "description": "Ingen hendelser ble funnet for denne simuleringen.",
      "title": "Ingen hendelser"
    },
    "simulations": {
      "description": "Begynn ved å legge til en simulering.",
      "title": "Ingen simuleringer"
    },
    "simulations_custom_templates": {
      "description": "Kom i gang ved å legge til en mal.",
      "title": "Ingen maler"
    },
    "simulations_sequence": {
      "button": "Rediger sekvens",
      "description": "Legg til handlinger for å bygge automasjonsflyten",
      "title": "Denne sekvensen er tom"
    },
    "threats": {
      "attachments": "Ingen vedlegg funnet",
      "description": "Kom i gang ved å rapportere mistenkelige e-poster med Moxso e-postutvidelsen",
      "title": "Ingen trusler funnet"
    },
    "tokens": {
      "description": "Kom i gang ved å opprette en token.",
      "title": "Ingen tokens"
    },
    "training": {
      "button": "Fjern filtre",
      "description": "Ingen opplæringsmateriell som samsvarer med søket ble funnet.",
      "title": "Ingen opplæringsmateriell funnet"
    },
    "training_deadlines": {
      "description": "Ingen opplæringsfrister funnet.",
      "title": "Ingen treningsfrister"
    },
    "user_courses": {
      "description": "Ingen kurs har blitt tildelt ennå.",
      "title": "Ingen kurs"
    },
    "users": {
      "description": "Ingen brukere ble funnet.",
      "title": "Ingen brukere"
    }
  },
  "error": {
    "button": "Gå tilbake hjem",
    "text": "En ukjent feil oppstod, og vi kunne ikke fullføre forespørselen din. Vi beklager virkelig ulempen. Vennligst prøv igjen senere.",
    "title": "Noe gikk galt"
  },
  "forgot_password": {
    "button": "Send instruksjoner",
    "heading": "Tilbakestill passordet ditt",
    "instructions": {
      "heading": "E-post sendt",
      "text": "Instruksjoner har blitt sendt til din e-postadresse"
    },
    "text": "Skriv inn e-postadressen du brukte da du registrerte deg, så sender vi deg instruksjoner for å tilbakestille passordet ditt."
  },
  "forms": {
    "employee": {
      "add_employees": "Legg til ansatte",
      "buttons": {
        "add": "Legg til ansatt | Legg til ansatte",
        "add_row": "Legg til rad",
        "send_reminder": "Send påminnelse om opplæring",
        "settings": "Innstillinger"
      },
      "delete_row": "Slett rad",
      "employee_added": "Ansatt lagt til | Ansatte lagt til",
      "import": {
        "text": "Importer ansatte fra en CSV-fil.",
        "title": "Importer ansatte"
      },
      "labels": {
        "email": "E-post",
        "first_name": "Fornavn",
        "language": "Språk",
        "last_name": "Etternavn",
        "phone_number": "Telefonnummer"
      },
      "manual": {
        "text": "Opprett ansatte og deres detaljer manuelt.",
        "title": "Opprett ansatte manuelt"
      },
      "placeholders": {
        "email": "navn{'@'}company.com",
        "first_name": "Fornavn",
        "last_name": "Etternavn",
        "phone_number": "Skriv inn telefonnummer"
      }
    },
    "filters": {
      "all": "Alle ansatte",
      "completed": "Fullført",
      "completed_default": "Alle",
      "incomplete": "Ufullstendig",
      "only_active": "Kun aktive ansatte",
      "only_inactive": "Alle inaktive ansatte"
    },
    "group": {
      "adaptive": {
        "text": "Medlemmer blir påmeldt automatisk basert på regler.",
        "title": "Opprett en adaptiv gruppe"
      },
      "add_group": "Legg til gruppe",
      "buttons": {
        "add": "Opprett gruppe",
        "back": "Tilbake",
        "import": "Importer grupper",
        "next": "Neste steg",
        "save": "Lagre innstillinger"
      },
      "group_added": "Gruppe lagt til",
      "group_updated": "Gruppe oppdatert",
      "import": {
        "text": "Importer grupper fra integrasjoner.",
        "title": "Importer grupper"
      },
      "labels": {
        "groups": "Grupper",
        "import_from_provider": "Importer fra tilbyder",
        "name": "Navn",
        "provider": "Tilbyder",
        "provider_id": "Leverandørgruppe-ID"
      },
      "manual": {
        "text": "Medlemmer vil bli lagt til manuelt.",
        "title": "Opprett en manuell gruppe"
      },
      "placeholders": {
        "name": "Gruppenavn",
        "provider": "Velg leverandør",
        "provider_id": "ABC-123",
        "search_groups": "Søk grupper"
      },
      "scim_enabled_info": "Du kan ikke redigere gruppens innstillinger fordi SCIM er aktivert for dette arbeidsområdet."
    },
    "login": {
      "buttons": {
        "reset_password": "Tilbakestille passord"
      },
      "labels": {
        "email": "E-post",
        "password": "Passord",
        "password_repeat": "Gjenta passord"
      },
      "placeholders": {
        "email": "navn{'@'}company.com"
      }
    },
    "search": "Søk"
  },
  "general": {
    "locked_feature": "Denne funksjonen er låst."
  },
  "go_back": "Gå tilbake",
  "goals": {
    "actions": {
      "delete_are_you_sure": "Er du sikker på at du vil avbryte dette målet?",
      "delete_goal": "Avbryt mål",
      "deleted": "Mål avbrutt",
      "edit_goal": "Rediger mål",
      "edit_goal_title": "Rediger mål for {metric}",
      "new_goal": "Nytt mål for {metric}",
      "save_goal": "Lagre mål",
      "target_description": "Angi en målverdi og datoen du vil nå den innen."
    },
    "chart": {
      "lifetime": "Hele perioden",
      "recent": "Siste"
    },
    "detail": {
      "achieved": "Oppnådd",
      "active_and_scheduled": "Aktive og planlagte mål",
      "actual_at_date": "Faktisk verdi på datoen",
      "in_progress": "Pågår",
      "missed": "Ikke oppnådd",
      "no_past_goals": "Ingen tidligere mål ennå",
      "outcome": "Resultat",
      "past_goals": "Tidligere mål",
      "scheduled": "Planlagt",
      "trajectory": "Utvikling",
      "trajectory_description": "Faktisk utvikling mot hvert mål som er satt for denne målingen. Punktene er fargekodet etter resultat — grønt for oppnådd, rødt for ikke oppnådd, blått for pågår og grått for planlagt."
    },
    "form": {
      "target": {
        "label": "Mål",
        "placeholder": "Mål"
      },
      "target_date": {
        "label": "Måldato",
        "placeholder": "Velg måldato"
      }
    },
    "legend": {
      "actual": "Faktisk",
      "projected": "Forventet"
    },
    "no_data": "Ingen data",
    "overview": {
      "add_goal": "Legg til mål",
      "current": "nåværende",
      "description": "Definer tidsbestemte mål for hver måling for å skape en målbar forbedringskurve.",
      "employees_behind_tooltip": "Ansatte med minst én tildeling som har passert forfallsdatoen.",
      "from_now": "fra nå",
      "gap_from_previous_target": "Forskjell fra forrige mål",
      "next_target": "Neste mål",
      "no_goal_description": "Denne målingen spores uten et mål. Legg til et for å måle fremgang.",
      "no_goals": "Ingen aktive mål angitt",
      "time_elapsed": "Tid som har gått",
      "title": "Mål",
      "view": "Se"
    }
  },
  "groups": {
    "adaptive_conditions": {
      "boolean_operators": {
        "and": "og",
        "or": "eller"
      },
      "empty": "Ingen regler ennå. Legg til en regel for å definere hvem som tilhører denne gruppen.",
      "preview_count_label": "ansatte samsvarer med kriteriene",
      "subtitle": "Medlemskap bestemmes av regler i stedet for å settes manuelt.",
      "title": "Adaptiv gruppe"
    },
    "assign_manager": {
      "button": "Tildel leder",
      "description": "Tildel en leder til alle gruppemedlemmer samtidig",
      "form": {
        "overwrite_managers": {
          "help": "Hvis aktivert, vil ansatte som allerede har en leder bli omfordelt til den valgte lederen.",
          "label": "Overskriv eksisterende ledere"
        },
        "select_manager": {
          "help": "Velg en leder som skal tildeles alle medlemmene i denne gruppen.",
          "label": "Leder",
          "placeholder": "Velg leder"
        }
      },
      "manager_assigned": "Leder tildelt til gruppemedlemmer",
      "message": "Manuell oppdatering av ansatteledere vil forhindre Active Directory-synkronisering fra å oppdatere dem.",
      "title": "Tildel leder i bulk"
    },
    "assign_role": {
      "button": "Tildel rolle",
      "form": {
        "overwrite_roles": {
          "help": "Hvis aktivert, vil ansatte som allerede har en rolle bli tildelt den valgte rollen på nytt.",
          "label": "Overskriv eksisterende roller"
        },
        "select_role": {
          "help": "Velg en rolle som skal tildeles alle medlemmene i denne gruppen.",
          "label": "Rolle",
          "placeholder": "Velg rolle"
        }
      },
      "role_assigned": "Rolle tildelt gruppemedlemmer",
      "title": "Tildel rolle i bulk"
    },
    "assign_timezone": {
      "button": "Tildel tidssone",
      "description": "Tildel en tidssone til alle gruppemedlemmer samtidig",
      "form": {
        "overwrite_timezones": {
          "help": "Hvis aktivert, vil ansatte som allerede har en tidssone bli tildelt den valgte tidssonen på nytt.",
          "label": "Overskriv eksisterende tidssoner"
        },
        "select_timezone": {
          "help": "Velg en tidssone som skal tildeles alle medlemmer av denne gruppen.",
          "label": "Tidssone",
          "placeholder": "Velg tidssone"
        }
      },
      "timezone_assigned": "Tidssone tilordnet gruppemedlemmer",
      "title": "Tildel tidssone i bulk"
    },
    "average_resilience_score_text": "Gjennomsnittlig resilienspoeng for ansatte i denne gruppen",
    "average_resilience_score_title": "Gjennomsnittlig poengsum for robusthet",
    "buttons": {
      "add_rule": "Legg til regel",
      "assign_manager": "Tildele leder",
      "assign_role": "Tildel rolle",
      "assign_timezone": "Tildel tidssone",
      "cancel": "Avbryt",
      "manage_group": "Administrer medlemmer",
      "remove_managers": "Fjern ledere",
      "update_group": "Oppdater medlemmer"
    },
    "delete": {
      "are_you_sure": "Er du sikker på at du vil slette denne gruppen? Denne handlingen kan ikke angres.",
      "button": "Slett",
      "group_deleted": "Gruppe slettet"
    },
    "manage_members": "Rediger gruppemedlemmer",
    "members_count": "Ett medlem | {count} medlemmer",
    "membership_rules": "Medlemskapsregler",
    "provider": {
      "error": {
        "back": "Velg en annen leverandør",
        "button": "Konfigurer integrasjon",
        "text": "Gruppene kunne ikke hentes",
        "title": "Kunne ikke kontakte integrasjonsleverandør"
      },
      "group_copied": "Leverandør-ID kopiert til utklippstavlen",
      "heading": "Leverandør",
      "hide_id": "Skjul id",
      "id": "ID",
      "latest_sync": "Siste synkronisering",
      "never_synced": "Aldri synkronisert",
      "provider_id": "Leverandør-ID",
      "refresh": "Oppdater data",
      "show_id": "Vis id",
      "sync_started": "Sync lagt til i kø",
      "synced": "Synkronisert",
      "text": "Data synkronisert med leverandør"
    },
    "remove_managers": {
      "button": "Fjern alle ledere",
      "description": "Fjern lederen fra hvert medlem av denne gruppen.",
      "managers_removed": "Ledere fjernet fra gruppemedlemmer",
      "message": "Du er i ferd med å fjerne lederen fra alle medlemmene i denne gruppen. Er du sikker på at du vil fortsette? Denne handlingen kan ikke angres.",
      "title": "Fjern alle ledere"
    },
    "risk_level": {
      "calculated": "Arvet risikonivå",
      "country": "Land",
      "group": "Gruppe",
      "organisation": "Organisasjon",
      "text": "Oversikt over risikonivåer",
      "title": "Risikograd"
    },
    "search": {
      "empty": {
        "title": "Ingen grupper funnet"
      }
    },
    "segment_members": "Gruppesegmentering",
    "segmentation": "Segmentering",
    "segments": {
      "create": "Opprett et segment",
      "create_success": "Segment opprettet",
      "empty": "Ingen segmenter funnet",
      "form": {
        "all": "Alle",
        "any": "En hvilken som helst",
        "exclude": "Ekskluder medlemmer med følgende merkelapper:",
        "include": "Inkluder medlemmer med følgende merkelapper:",
        "name": "Navn",
        "operator": "Operatør",
        "select": "Velg etiketter"
      },
      "heading": "Segmenter",
      "members_count": "Ett medlem | {count} medlemmer",
      "text": "Bruk segmenter til å filtrere medlemmer",
      "update": "Oppdater segment",
      "update_success": "Segment oppdatert"
    },
    "settings": {
      "caution": "Forsiktighet",
      "provider_change_warning": "{caution}: Endring av leverandørdetaljene for denne gruppen vil utløse en ny gruppesynkronisering. Vær oppmerksom på at ansatte som for tiden er tildelt denne gruppen, kan bli fjernet hvis de ikke er inkludert i den oppdaterte Active Directory-gruppen. Vær forsiktig for å unngå utilsiktede endringer.",
      "subtitle": "Konfigurer gruppens innstillinger.",
      "title": "Gruppinnstillinger"
    },
    "sync_failed": {
      "button": "Innstillinger",
      "recommended_action": "Anbefalt handling",
      "title": "Synkronisering mislyktes",
      "tooltip": "Synkroniseringen av denne gruppen har mislyktes."
    },
    "tags": {
      "create": "Opprett en tag",
      "create_success": "Tag opprettet",
      "delete_success": "Tag slettet",
      "empty": "Ingen merker funnet",
      "heading": "Merkelapper",
      "text": "Bruk tagger for å gruppere medlemmer"
    }
  },
  "human_risk_intelligence": {
    "assignment": {
      "associated_risk_categories": "Tilknyttede risikokategorier",
      "available": "Tilgjengelig",
      "completed": "Fullført",
      "contextual_risk_factors": "Kontekstuelle risikofaktorer",
      "deadline": "Frist",
      "details": "Detaljer",
      "details_title": "Tildelingsdetaljer",
      "osint": "OSINT",
      "osint_sources_summary": {
        "label": "Analyserte kilder: {count}",
        "results_count": "{count} resultat | {count} resultater"
      },
      "passed": "Bestått",
      "rules": "Regler",
      "signals": "Signaler",
      "signals_description": "Signaler som utløste denne tildelingen",
      "strategy": "Strategi",
      "title": "Tildeling"
    },
    "common": {
      "powered_by": "Drevet av {risk_framework}"
    },
    "content_preview": {
      "title": "Forhåndsvisning av innhold"
    },
    "dashboard_card": {
      "assignments_90_days": "Tildelinger",
      "enable_button": "Aktiver menneskelig risikoetterretning",
      "interventions_90_days": "Intervensjoner",
      "score_90_days": "Poeng",
      "signals_90_days": "Signaler",
      "title": "Menneskelig risikoetterretning"
    },
    "dashboard_signal_collection": {
      "average_day": "Gjennomsnittsdag",
      "avg_daily": "Snitt per dag",
      "last_90_days": "Siste 90 dager",
      "less": "Mindre",
      "lowest_day": "Laveste dag",
      "more": "Mer",
      "negative": "Negative",
      "negative_count": "Negative: {count}",
      "no_signals_in_range": "Ingen signaler i dette intervallet",
      "peak_day": "Toppdag",
      "positive": "Positive",
      "positive_count": "Positive: {count}",
      "signal_count": "1 signal | {count} signaler",
      "signal_count_on_date": "{count} den {date}",
      "signal_range": "{min}-{max} signaler",
      "signals_on_date": "Signaler den {date}",
      "title": "Signalinnhenting",
      "total_signals": "totale signaler"
    },
    "employee_preview": {
      "access_level": "Tilgangsnivå",
      "info": "Info",
      "organizational_role": "Organisatorisk rolle",
      "resilience_score": "Robusthetsscore",
      "responsibility_tier": "Ansvarsnivå",
      "role": "Rolle",
      "title": "Ansatt"
    },
    "filters": {
      "back": "Tilbake",
      "data": "Filtrer data",
      "filter_by": "Filtrer etter",
      "search": "Søk",
      "select_date": "Velg dato"
    },
    "group_breakdown": {
      "columns": {
        "assignments": "Tildelinger",
        "avg_score": "Snittscore",
        "employees": "Ansatte",
        "group": "Gruppe",
        "interventions": "Intervensjoner",
        "signals": "Signaler"
      },
      "description": "Aggregerte signaler, tildelinger og intervensjoner per gruppe",
      "signals_slideover": {
        "activity_links_title": "Aktivitet",
        "links_title": "Signaler",
        "member_count": "{count} medlemmer",
        "title": "Signalfordeling",
        "view_assignments": "Vis tildelinger",
        "view_interventions": "Vis intervensjoner",
        "view_signals": "Vis {sentiment} signaler"
      },
      "title": "Gruppefordeling"
    },
    "intervention": {
      "details_title": "Intervensjon",
      "preview_body": "I produksjon inneholder denne e-posten atferdsbasert kontekst og veiledning for neste steg.",
      "preview_cta": "Vennligst gjennomgå sikkerhetsaktiviteten din og fullfør eventuell oppfølgende opplæring.",
      "preview_from_name": "Moxso sikkerhetsteam",
      "preview_greeting": "Hei {name},",
      "preview_intro": "Dette er en eksempelvisning av et intervensjonsvarsel.",
      "preview_subject": "Sikkerhetsvarsel",
      "sent_at": "Sendt",
      "signals_description": "Signaler som utløste denne intervensjonen",
      "title": "Intervensjon"
    },
    "navigation": {
      "assignments": "Tildelinger",
      "interventions": "Intervensjoner",
      "osint": "OSINT",
      "overview": "Oversikt",
      "risk_framework": "Risikorammeverk",
      "signals": "Signaler"
    },
    "notification_title": "Varsel",
    "notification_type": "Varslingstype",
    "onboarding": {
      "common": {
        "back": "Tilbake",
        "cancel": "Avbryt",
        "next": "Neste"
      },
      "glance": {
        "assignment_limits": "Opptil {max} leksjoner per ansatt, med minst {cooldown} dager mellom tildelinger",
        "eligibility": "Ansatte er kvalifisert til å motta opplæring {min_days} dager etter oppstart.",
        "lesson_selection": "Leksjoner tildeles automatisk: {selection}",
        "notifications_disabled": "Varsler deaktivert",
        "notifications_enabled": "Varsler aktivert med frekvens {frequency}. {behavior}"
      },
      "interventions": {
        "heading": "Atferdsutløste intervensjoner",
        "subheading": "Definer hvilke atferdssignaler som utløser en umiddelbar respons utenfor den vanlige kadensen: en korrigerende opplæringstildeling, et varsel til den ansattes leder eller et varsel til sikkerhetsadministratorene deres."
      },
      "intro": {
        "benefits": {
          "better_outcomes": {
            "description": "Fokuser ressurser der de betyr mest",
            "title": "Bedre resultater"
          },
          "continuous_adaptation": {
            "description": "Systemet lærer og justerer seg basert på løpende atferd",
            "title": "Kontinuerlig tilpasning"
          },
          "personalized_experience": {
            "description": "Hver ansatt får opplæring tilpasset sine behov",
            "title": "Personlig tilpasset opplevelse"
          }
        },
        "description": "Human Risk Intelligence gjør atferdssignaler om til individuelle risikoprofiler, og tildeler deretter opplæringen og simuleringene hver ansatt faktisk trenger. Innholdet kalibreres etter hvor hver person befinner seg i Moxso Risk Framework, og rekalibreres etter hvert som nye signaler kommer inn. Risikoen går ned uten å øke opplæringsvolumet.",
        "heading": "Hva er Human Risk Intelligence?",
        "setup_button": "Sett opp Human Risk Intelligence",
        "subheading": "Tren hver ansatt på risikoene som faktisk gjelder for dem, og slutt å trene dem på de som ikke gjør det."
      },
      "review": {
        "at_a_glance": "Kort oppsummert",
        "enable_button": "Aktiver Human Risk Intelligence",
        "heading": "Klar til å aktivere",
        "next": {
          "heading": "Hva skjer videre",
          "items": {
            "analysis_starts_immediately": "Moxso begynner umiddelbart å samle inn atferdssignaler på tvers av organisasjonen.",
            "no_lessons_assigned_immediately_prefix": "Opplæring leveres etter 24 timer.",
            "no_lessons_assigned_immediately_suffix": "Da har systemet lært nok til å bygge en pålitelig risikoprofil for hver ansatt.",
            "settings_can_be_changed_anytime": "Disse innstillingene kan endres, eller Human Risk Intelligence kan deaktiveres, når som helst."
          }
        },
        "settings_link": "Trenger du mer kontroll? Tilpass avanserte innstillinger",
        "subheading": "Dette skjer når du aktiverer Human Risk Intelligence."
      },
      "selection": {
        "heading": "Opplæringsstrategi",
        "subheading": "Velg hvordan Moxso prioriterer og tildeler kontinuerlig opplæring på tvers av organisasjonen."
      },
      "signals": {
        "heading": "Signaler",
        "subheading": "Konfigurer hvordan signaler påvirker beslutninger i menneskelig risikoetterretning"
      },
      "steps": {
        "interventions": "Intervensjoner",
        "introduction": "Introduksjon",
        "review": "Gjennomgå og aktiver",
        "training_strategy": "Opplæringsstrategi"
      }
    },
    "osint_explanation": {
      "description": "Moxso OSINT-motoren overvåker kontinuerlig det globale trusselbildet og omgjør offentlig cybersikkerhetsintelligens til handlingsrettet innsikt i menneskelig risiko.",
      "title": "Moxso OSINT-motoren (Open-Source Intelligence)"
    },
    "osint_news": {
      "empty": {
        "description": "Ingen OSINT-data funnet for denne risikoen",
        "heading": "OSINT-data utilgjengelig"
      },
      "title": "Trusseletterretningsfeed"
    },
    "pages": {
      "assignments": {
        "heading": "Adaptive tildelinger",
        "subheading": "Se og administrer tildelinger i menneskelig risikoetterretning."
      },
      "interventions": {
        "heading": "Intervensjoner",
        "subheading": "Intervensjoner utløst av ansattes atferd på tvers av sikkerhetsaktiviteter."
      },
      "osint": {
        "article": {
          "associated_risk_indicators": "Tilknyttede risikoindikatorer",
          "hide": "Skjul",
          "indicator_count": "{count} indikator | {count} indikatorer",
          "neutral_count": "{count} nøytral | {count} nøytrale",
          "risky_count": "{count} risikofylt | {count} risikofylte",
          "show": "Vis",
          "vigilant_count": "{count} årvåken | {count} årvåkne"
        },
        "breaches": "Brudd",
        "current": "Nåværende",
        "heading": "Trusselsetterretningsfeed",
        "indicators": {
          "description": "Topp de siste 24 timene",
          "empty": {
            "description": "Indikatoraktivitet vises her når feeden har merkede risikoer.",
            "heading": "Ingen indikatorer ennå"
          },
          "title": "Risikoindikatorer"
        },
        "negative_neutral": "Krever oppmerksomhet: Signalaktiviteten forverres",
        "negative_risky": "Varsel: Trusselaktiviteten øker",
        "negative_vigilant": "Krever oppmerksomhet: Sikkerhetstiltakene svekkes",
        "news": {
          "description": "Siste 24 timer",
          "title": "Nyheter"
        },
        "no_change": "Ingen endring i signalaktivitet",
        "positive_neutral": "Positiv trend: Signalaktiviteten forbedres",
        "positive_risky": "Positiv trend: Trusselaktiviteten avtar",
        "positive_vigilant": "Positiv trend: Sikkerhetsnivået forbedres",
        "previous": "Forrige",
        "risk_themes": "Risikotemaer",
        "signal_change": "Signalendring",
        "sources": {
          "description": "Aktive kilder de siste 24 timene",
          "empty": {
            "description": "Kildeaktivitet vises her når feeden har artikler.",
            "heading": "Ingen kilder ennå"
          },
          "title": "Kilder"
        },
        "subheading": "Følg eksterne signaler knyttet til risikotemaene du overvåker."
      },
      "overview": {
        "subheading": "Oversikt over aktivitet og innsikt i menneskelig risikoetterretning."
      },
      "risk_framework": {
        "heading": "Risikorammeverk",
        "subheading": "Moxso-rammeverket for å vurdere og håndtere menneskelig sikkerhetsrisiko."
      },
      "signals": {
        "heading": "Atferdssignaler",
        "subheading": "Se alle signaler samlet inn fra ansattes atferd."
      }
    },
    "risk_category": {
      "change": "Endring",
      "consequences": "Konsekvenser",
      "details_title": "Detaljer for risikokategori",
      "importance": "Viktighet",
      "indicators": "Indikatorer",
      "overview_title": "Oversikt over risikokategori",
      "relevance": "Relevans",
      "tabs": {
        "details": "Detaljer",
        "indicators": "Indikatorer"
      }
    },
    "risk_framework": {
      "change_tooltip": "Endring de siste 90 dagene",
      "description_1": "Moxso-risikorammeverket er en datadrevet modell for å identifisere, kvantifisere og operasjonalisere menneskelig cyberrisiko i moderne virksomheter.",
      "description_2": "Tilpasset bransjestandarder som MITRE ATT&CK og NIST Cybersecurity Framework utvider det tradisjonelle kontrollbaserte modeller ved å fokusere spesifikt på menneskelig atferd som angrepsvektor. Rammeverket omdanner reelle atferdsdata, signaler om trusseleksponering og strukturelle risikofaktorer til målbare og reviserbare risikoindikatorer.",
      "description_3": "Organisert på tvers av og strukturert i 16 menneskesentrerte risikokategorier (R.01-R.16) leverer rammeverket konsekvent scoring, handlingsrettet innsikt og etterlevelsesorientert rapportering.",
      "references": "Rammeverksreferanser",
      "short_description": "Moxso-risikorammeverket er en datadrevet modell for å identifisere, kvantifisere og operasjonalisere menneskelig cyberrisiko i moderne virksomheter.",
      "title": "Risikorammeverk"
    },
    "risk_matrix": {
      "axes": {
        "impact": "Påvirkning",
        "likelihood": "Sannsynlighet"
      },
      "legend": {
        "high": "Høy",
        "low": "Lav",
        "med": "Middels"
      },
      "title": "Signalrisikomatrise",
      "tooltip": {
        "change": "Endring",
        "current": "Nåværende",
        "high": "Høyrisikosignaler",
        "low": "Lavrisikosignaler",
        "medium": "Middels risikosignaler",
        "previous": "Forrige"
      }
    },
    "sections": {
      "recent_assignments": "Siste tildelinger",
      "recent_interventions": "Nylige intervensjoner",
      "recent_signals": "Siste signaler"
    },
    "settings": {
      "common": {
        "days": "{days} dager",
        "disabled": "Deaktivert",
        "enabled": "Aktivert",
        "every_days": "Hver {days}. dag",
        "no": "Nei",
        "none": "Ingen",
        "yes": "Ja"
      },
      "eligibility": {
        "criteria_title": "Kvalifiseringskriterier",
        "description": "Definer hvem som er kvalifisert for menneskelig risikoetterretning",
        "excluded_groups": "Ekskluderte grupper",
        "excluded_groups_help": "Ekskluder spesifikke grupper fra automatiserte opplæringsflyter",
        "excluded_roles": "Ekskluderte roller",
        "excluded_roles_help": "Ekskluder spesifikke organisatoriske roller fra automatiserte opplæringsflyter",
        "minimum_employment_duration_help": "Ansatte må ha vært ansatt i minst så mange dager for å være kvalifisert",
        "minimum_employment_duration_label": "Minimum ansettelsestid (dager)",
        "targeting_title": "Målretting",
        "title": "Kvalifisering"
      },
      "interventions": {
        "actions": {
          "add_action": "Legg til handling",
          "assign_new_lesson": "Tildel ny leksjon",
          "assignment_description": "Tildel korrigerende opplæring til den berørte ansatte.",
          "empty": "Ingen handlinger ennå. Legg til en for å definere hva som skal skje når denne gruppen utløses.",
          "heading": "Handlinger når utløst",
          "notify_admin": "Varsle administratorer",
          "notify_admin_description": "Send e-post til en kvalifisert Moxso-arbeidsområdeadministrator.",
          "notify_employee": "Varsle ansatt",
          "notify_employee_description": "Send e-post til den berørte ansatte om den oppdagede atferden.",
          "notify_manager": "Varsle leder",
          "notify_manager_description": "Send e-post til den ansattes aktive leder.",
          "remove_action": "Fjern {action}"
        },
        "enable_subtitle": "La menneskelig risikoetterretning bryte normale tildelingsregler når høyrisikoatferd oppdages, og eskalere til ledere og sikkerhetsadministratorer.",
        "enable_title": "Aktiver intervensjoner",
        "excluded_groups": "Ekskluderte grupper",
        "excluded_groups_help": "Ansatte i disse gruppene blir aldri målrettet av intervensjonsoverganger.",
        "excluded_roles": "Ekskluderte roller",
        "excluded_roles_description": "Ansatte i disse rollene blir aldri målrettet av intervensjonsoverganger.",
        "groups_description": "Velg hvilke signalgrupper som skal overvåkes, og konfigurer responsen for hver gruppe.",
        "groups_title": "Intervensjonssignalgrupper",
        "severity_label": "Forsinkelsesgrad",
        "threshold_label": "Aktiveringsterskel",
        "threshold_occurrences": "{count} hendelse | {count} hendelser",
        "timeframe_days": "Hver {days}. dag",
        "timeframe_label": "Tidsperiode",
        "timeframe_within_90_days": "Innen 90 dager",
        "triggers": {
          "breach_exposure": {
            "description": "Tillat umiddelbar tildeling når en ansatt vises i et kjent brudd.",
            "title": "Bruddeksponering"
          },
          "phishing_failures": {
            "description": "Tillat umiddelbar tildeling etter at ansatte feiler en simulering.",
            "title": "Feil i phishing-simuleringer"
          },
          "training_non_compliance": {
            "description": "Tillat umiddelbar tildeling når påkrevd opplæring er forsinket.",
            "title": "Manglende opplæringsoverholdelse"
          }
        },
        "triggers_description": "Velg hvilke hendelser som kan utløse umiddelbar opplæring og eskalering til ledere eller sikkerhetsadministratorer, selv om en ansatt nylig mottok annen opplæring.",
        "triggers_title": "Intervensjon utløsere"
      },
      "notifications": {
        "continuous_sending_subtitle": "Send påminnelsesvarsler til fullføring",
        "continuous_sending_title": "Kontinuerlig sending",
        "enable_subtitle": "Send e-postvarsler for nye tildelinger",
        "enable_title": "Aktiver varsler",
        "frequency": {
          "intense": "Intens",
          "loose": "Løs",
          "normal": "Normal (Per tildeling)",
          "per_assignment": "Per tildeling"
        },
        "frequency_label": "Varslingsfrekvens",
        "title": "Varsler"
      },
      "review": {
        "enable_subtitle": "Start personlige opplæringstildelinger basert på ansattes atferd",
        "enable_title": "Aktiver Menneskelig risiko etterretning",
        "frequency": "Frekvens",
        "max_assignments_per_run": "Maks tildelinger per kjøring: {value}",
        "notifications": "Varsler",
        "reminders_until_completion": "Påminnelser til fullføring",
        "save_settings": "Lagre innstillinger",
        "selection": "Utvalg",
        "title": "Gjennomgå og aktiver"
      },
      "selection_strategy": {
        "avoid_repetition_help": "Ikke tildel samme leksjon på nytt innenfor denne perioden.",
        "avoid_repetition_label": "Unngå å gjenta samme opplæring (dager)",
        "cooldown_help": "Vent før ny menneskelig risikoetterretning tildeles etter opplæring.",
        "cooldown_label": "Karensperiode (dager)",
        "enable_subtitle": "La Human Risk Intelligence tildele kontinuerlig opplæring basert på ansattes risikoprofiler.",
        "enable_title": "Aktiver Human Risk Intelligence",
        "excluded_videos": "Ekskluderte videoer",
        "excluded_videos_description": "Disse videoene tildeles aldri av Human Risk Intelligence.",
        "excluded_videos_placeholder": "Velg videoer",
        "frameworks_help": "Velg ett eller flere rammeverk for å prioritere opplæring som er knyttet til dine etterlevelsesmål.",
        "frameworks_label": "Rammeverk",
        "frameworks_placeholder": "Velg rammeverk",
        "hide_advanced_settings": "Skjul avanserte innstillinger",
        "interval_help": "Minimum antall dager mellom fullført opplæring og nye tildelinger.",
        "interval_label": "Intervall (dager)",
        "label": "Utvalgsstrategi",
        "max_assignments_per_run_help": "Maksimalt antall nye opplæringer per ansatt i én evaluering.",
        "max_assignments_per_run_label": "Maks tildelinger per kjøring",
        "show_advanced_settings": "Vis avanserte innstillinger"
      },
      "signals": {
        "failed_simulation": "Mislykket simulering",
        "failed_simulation_help": "Vekt som brukes når en ansatt klikker på en phishing-simulering",
        "low_score": "Lav poeng",
        "low_score_help": "Vekt som brukes når quizscore i opplæring er under terskelen"
      },
      "summary_eligibility": {
        "description": "Bestemmer hvem som er kvalifisert for menneskelig risikoetterretning",
        "excluded_roles": "Ekskluderte roller",
        "minimum_employment_duration": "Minimum ansettelsestid",
        "title": "Kvalifisering"
      },
      "summary_selection": {
        "description": "Bestemmer hvordan leksjoner velges og hvordan ansatte varsles",
        "email_notifications": "E-post varsler",
        "lesson_selection": "Leksjonsutvalg",
        "maximum_lessons_per_employee": "Maksimalt antall leksjoner per ansatt",
        "minimum_time_between_lessons": "Minimum tid mellom leksjoner",
        "notification_settings": "Varslingsinnstillinger",
        "notification_style": "Varslingsstil",
        "prioritize_mandatory_training": "Prioriter obligatorisk opplæring",
        "selection_approach": "Utvalgstilnærming",
        "send_reminders_until_complete": "Send påminnelser til fullført",
        "standard_training_interval": "Standard opplæring intervall",
        "title": "Utvalg og varsler"
      },
      "summary_signals": {
        "description": "Bestemmer hvordan signaler påvirker beslutninger i menneskelig risikoetterretning",
        "impact": {
          "high": "Høy påvirkning",
          "low": "Lav påvirkning",
          "medium": "Middels påvirkning"
        },
        "signal_labels": {
          "failed_simulation": "Mislykket phishing-simulering",
          "low_score": "Lav opplæringspoengsum"
        },
        "title": "Signaler"
      }
    },
    "signal": {
      "associated_risk_categories": "Tilknyttede risikokategorier",
      "behaviour": "Atferd",
      "category": "Kategori",
      "indicator": "Indikator",
      "intel": "Etterretning",
      "no": "Nei",
      "polarity": "Polaritet",
      "sentiment": "Stemning",
      "title": "Risikosignal",
      "value": "Verdi",
      "yes": "Ja"
    },
    "signal_preview": {
      "breach": {
        "title": "Dark web-overvåking"
      },
      "multiple_choice_quiz_answer": {
        "answer": "Svar",
        "question": "Spørsmål",
        "title": "Quizsvar"
      },
      "phishing_quiz_answer": {
        "correct": "Riktig",
        "incorrect": "Feil",
        "question": "Spørsmål",
        "result": "Resultat",
        "subject": "Emne",
        "time": "Tid",
        "title": "Svar på phishingquiz"
      }
    },
    "stats": {
      "assignments": "Tildelinger",
      "completed_assignments": "Fullførte tildelinger",
      "interventions": "Intervensjoner",
      "negative_signals": "Negative signaler",
      "positive_signals": "Positive signaler",
      "risk_level": {
        "country_risk": "Landrisiko",
        "industry_risk": "Bransjerisiko",
        "levels": {
          "high": "Høy",
          "loading": "Laster inn",
          "low": "Lav",
          "medium": "Moderat"
        },
        "title": "Risikonivå"
      },
      "signals": "Signaler"
    },
    "tables": {
      "negative": "Negativ",
      "neutral": "Nøytral",
      "sentiment": "Stemning",
      "severity": "Alvorlighetsgrad",
      "signal_count": "1 signal | {count} signaler",
      "signal_type": "Risikosignal"
    },
    "title": "Human Risk Intelligence",
    "tooltips": {
      "compared_to_prior_period": "Sammenlignet med forrige periode av samme lengde.",
      "previous_value": "Forrige verdi"
    },
    "trending_risk_indicators": "Trendende risikoindikatorer"
  },
  "image_library": {
    "empty_button": "Last opp bilde",
    "empty_description": "Last opp ditt første bilde for å begynne å bygge et gjenbrukbart bibliotek.",
    "empty_title": "Ingen bilder ennå",
    "image_format": "JPG/JPEG/PNG · Opptil 1MB",
    "image_uploaded": "Bildet ble lastet opp",
    "insert_button": "Sett inn bilde",
    "library_tab": "Bildebibliotek",
    "refresh": "Oppdater",
    "show_more": "Vis mer",
    "title": "Sett inn bilde",
    "upload_tab": "Last opp",
    "upload_title": "Last opp et nytt bilde"
  },
  "locale": {
    "current": "Norwegian",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "french": "Français",
    "norwegian": "Norwegian",
    "polish": "Polski",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "login": {
    "back_to_login": "Tilbake til innlogging",
    "button": "Logg inn",
    "change_email": "Endre e-post?",
    "continue": "Fortsett",
    "forgot_password": {
      "link": "Tilbakestill den nå",
      "text": "Glemt passord?"
    },
    "heading": "Velkommen tilbake",
    "loading": "Laster inn",
    "preparing_session": "Forbereder økt",
    "sso": {
      "provider_found": "SSO er tilgjengelig for {provider}. Fortsett for å logge inn via identitetsleverandøren din.",
      "redirecting": "Videresender til SSO",
      "redirecting_text": "Vi forbereder innloggingsforespørselen din.",
      "validating": "Validerer SSO",
      "validating_text": "Vi fullfører innloggingen din."
    },
    "text": "Logg inn på din arbeidsplass"
  },
  "manager_report": {
    "assignment": "Oppgave",
    "assignments": "Oppgaver",
    "company_average": "Bedriftsgjennomsnitt",
    "compared_against": "Sammenlignet med {period}",
    "completed": "Fullført",
    "date": "Dato",
    "days_overdue": "Dager forsinket",
    "deadline": "Frist",
    "deadlines_description": "{count} oppgaver passerte fristen i perioden {period}.",
    "department": "Avdeling",
    "employee": "Ansatt",
    "employees_affected": "Berørte ansatte",
    "employees_at_risk": "Ansatte i risikosonen",
    "gap_to_company": "Forskjell fra bedriften",
    "generated": "Generert {date}",
    "human_risk_intelligence": "Human Risk Intelligence",
    "individual_reports": "Individuelle opplærings- og risikorapporter · {count} ansatte | Individuell opplærings- og risikorapport · {count} ansatt | Individuelle opplærings- og risikorapporter · {count} ansatte",
    "interventions": "Nylige tiltak utløst av Moxso",
    "loading": "Laster lederrapport…",
    "missed_deadlines": "Overskredne frister",
    "missed_team_deadlines": "Teamets overskredne frister",
    "most_dangerous_signals": "Periodens 3 farligste signaler",
    "no_assignments": "Ingen oppgaver",
    "no_dangerous_signals": "Ingen farlige signaler",
    "no_employees_at_risk": "Ingen ansatte i risikosonen",
    "no_interventions": "Ingen tiltak utløst",
    "no_missed_deadlines": "Ingen overskredne frister",
    "no_recent_signals": "Ingen nylige signaler",
    "no_sentiment_data": "Ingen sentimentdata",
    "no_severity_data": "Ingen data om alvorlighetsgrad",
    "oldest_deadline": "Eldste frist",
    "overdue_assignments": "Forsinkede oppgaver",
    "period_over_period": "Sammenlignet med forrige periode",
    "points": "{points} poeng",
    "recent_signals": "Nylige signaler",
    "risk_indicator": "Risikoindikator",
    "score": "Poengsum",
    "sentiment": "Sentiment",
    "severity": "Alvorlighetsgrad",
    "signal": "Signal",
    "signals": "Signaler",
    "signals_by_sentiment": "Signaler etter sentiment",
    "signals_by_severity": "Signaler etter alvorlighetsgrad",
    "sorted_by_deadline": "Sortert etter frist",
    "status": "Status",
    "summary": "Sammendrag",
    "team_average": "Teamgjennomsnitt",
    "threshold": "Grense {value}% · laveste først",
    "title": "Lederrapport",
    "total": "{count} totalt",
    "training_report": "Opplæringsrapport",
    "trend_title": "Motstandsdyktighet, klikk- og rapporteringsrate",
    "type": "Type",
    "unavailable": "Rapporten er utilgjengelig",
    "unavailable_description": "Rapporten kunne ikke lastes. Kontroller at rapportlenken er gyldig og ikke utløpt."
  },
  "navigation": {
    "assigned_learning": "Tildelt læring",
    "at_risk": "Ansatte i fare",
    "audit": {
      "index": "Revisjon",
      "settings": "Innstillinger"
    },
    "automation": {
      "flow_builder": "Sekvensbygger",
      "index": "Automatisering",
      "sequence": "Sekvens",
      "settings": "Innstillinger"
    },
    "breaches": "Brudd",
    "configuration": "Konfigurasjon",
    "custom_upload": {
      "edit": "Rediger",
      "quiz": "Quiz"
    },
    "dashboard": "Analyse",
    "employees": "Ansatte",
    "goals": "Mål",
    "groups": {
      "index": "Grupper",
      "settings": "Innstillinger",
      "single": "Gruppe"
    },
    "human_risk_intelligence": "Menneskelig risikoetterretning",
    "integration": {
      "activity": "Aktivitet",
      "settings": "Innstillinger"
    },
    "integrations": "Integrasjoner",
    "knowledge_base": "Kunnskapsbase",
    "lessons_courses": "Kurs",
    "lessons_deadlines": "Frister",
    "lessons_videos": "Videoer",
    "no_workspaces": "Ingen arbeidsområder funnet",
    "overview": "Oversikt",
    "policies": "Retningslinjer",
    "policy": {
      "edit": "Rediger",
      "quiz": "Quiz"
    },
    "resilience": "Motstandsdyktighet",
    "search_workspaces": "Søk arbeidsområder",
    "settings": {
      "administration": "Administrasjon",
      "admins": "Administratorer",
      "apis_and_data": "API-er og data",
      "audit_logs": "Revisjonslogger",
      "authentication": "Autentisering",
      "back_to_app": "Tilbake til appen",
      "breaches": "Brudd",
      "close_navigation": "Lukk navigasjon",
      "compliance": "Samsvar",
      "domains": "Domer",
      "e_learning": "Opplæring",
      "export": "Eksporter",
      "exports": "Eksport",
      "goals": "Mål",
      "human_risk_intelligence": "Menneskelig risikoetterretning",
      "import": "Importer",
      "index": "Innstillinger",
      "interventions": "Intervensjoner",
      "personal": "Personlig",
      "reporting": "Rapportering",
      "risk": "Risiko",
      "simulations": "Simuleringer",
      "threats": "Trusler",
      "workspace": "Arbeidsområde"
    },
    "sign_out": "Logg ut",
    "simulations": {
      "custom_templates": "Egendefinerte maler",
      "index": "Simuleringer",
      "scheduled": "Planlagt",
      "single": "Aktivitet",
      "single_settings": "Innstillinger"
    },
    "team": "Ansatte",
    "threats": "Trusler",
    "training": "E-læring",
    "user_settings": "Sikkerhet og tilgang",
    "your_workspaces": "Dine arbeidsområder"
  },
  "oauth": {
    "back_to_home": "Tilbake til hjemmet",
    "error": "Integrasjon kunne ikke konfigureres",
    "login": "Logg inn",
    "success": "Tilbyder lagret vellykket"
  },
  "onboarding": {
    "building_training_paths": "Bygge opplæringsveier",
    "calculating_risk_score": "Beregner risikopoengsum",
    "choose_provider": "Velg din identitetsleverandør",
    "continue_button": "Fortsett",
    "exit": "Avslutt",
    "gmail_integration": "Gmail-integrasjon",
    "google_manual_setup": {
      "access_google_admin_console_heading": "Få tilgang til Google Admin-konsollen",
      "access_google_admin_console_text": "Logg inn på administrasjonskonsollen for Google Workspace: {google_admin_console_link}",
      "allow_moxso_ip_addresses_bullet_1": "Utvid seksjonen {email_allowlist}.",
      "allow_moxso_ip_addresses_bullet_2": "Angi følgende Moxso IP-adresser: {ip_1} {ip_2}",
      "allow_moxso_ip_addresses_bullet_3": "Klikk {save_button}.",
      "allow_moxso_ip_addresses_heading": "Tillat Moxso IP-adresser",
      "configure_inbound_gateway_bullet_1": "Utvid {inbound_gateway}-delen.",
      "configure_inbound_gateway_bullet_2": "Aktiver gatewayen ved å slå på bryteren.",
      "configure_inbound_gateway_bullet_3": "Skriv inn følgende Moxso IP-adresser under {gateway_ips}: {ip_1} {ip_2}",
      "configure_inbound_gateway_bullet_4": "Aktiver {require_tls}.",
      "configure_inbound_gateway_bullet_5": "I seksjonen {message_tagging_section}, aktiver {message_spam_eval_header}.",
      "configure_inbound_gateway_bullet_6": "Skriv inn følgende verdi i feltet {regexp_field}: {uuid}",
      "configure_inbound_gateway_bullet_7": "Aktiver {disable_gmail_spam_eval}.",
      "configure_inbound_gateway_bullet_8": "Klikk på {save_button} for å bruke innstillingene.",
      "configure_inbound_gateway_heading": "Konfigurer innkommende gateway",
      "configure_spam_rule_bullet_1": "Naviger til {spam_settings}: Finn Spam-delen i samme meny {menu_path}.",
      "configure_spam_rule_bullet_2": "Legg til en ny regel: Klikk på {add_rule} (eller rediger en eksisterende Moxso-regel) og gi den et navn som {rule_name}.",
      "configure_spam_rule_bullet_3": "Konfigurer omgåelsen: Velg {bypass_option}",
      "configure_spam_rule_bullet_4": "Skjul advarsler (kritisk): Sørg for at du krysser av {hide_warnings_option}",
      "configure_spam_rule_bullet_5": "Sørg for at simuleringsdomenene legges til i adresselisten for denne regelen ved å laste ned CSV-filen:",
      "configure_spam_rule_bullet_6": "Lagre regelen.",
      "configure_spam_rule_heading": "Konfigurer spamregel (omgå advarsler)",
      "disable_gmail_spam_eval": "Deaktiver Gmail-spamevaluering for e-post fra denne gatewayen; bruk bare headerverdien.",
      "email_allowlist": "E-posttillatelsesliste",
      "gateway_ips": "Gateway-IP-er",
      "google_admin_console": "Google Admin-konsoll",
      "inbound_gateway": "Innkommende gateway",
      "inbound_gateway_warning_not_checked": "ikke avkrysset",
      "inbound_gateway_warning_text": "Sørg for at {reject_option} er {not_checked}. Hvis dette alternativet forblir aktivert, vil du bare kunne motta e-poster fra Moxso og ikke fra eksterne avsendere.",
      "message_spam_eval_header": "Meldingen regnes som spam hvis følgende header-regexp samsvarer",
      "message_tagging": "Meldingsmerking",
      "navigate_spam_phishing_malware_heading": "Gå til innstillinger for søppelpost, phishing og skadelig programvare",
      "navigate_spam_phishing_malware_text": "Gå til Gmail-innstillingene for søppelpost, phishing og skadelig programvare: {spam_phishing_link}",
      "regexp": "Regexp",
      "require_tls": "Krev TLS for tilkoblinger fra e-postgatewayene som er oppført ovenfor.",
      "save": "Lagre",
      "spam_phishing_malware_settings": "Innstillinger for søppelpost, phishing og skadelig programvare",
      "whitelisting_moxso_ip_addresses_in_gw": "Allowlisting Moxso IP-adresser i Google Workspace"
    },
    "import_employees": "Importer ansatte",
    "integration_error": "En feil oppstod under oppsettet av integrasjonen til {provider}.",
    "integration_error_title": "Det oppstod en feil",
    "invite": {
      "button": "Inviter bruker",
      "text": "Vi vil sende dem en e-post for å komme i gang.",
      "title": "Inviter teammedlemmer til ditt dashbord"
    },
    "microsoft_bypass_junk_by_header": {
      "bypass_junk_by_header": "Omgå søppel etter hodefelt",
      "finish": "ferdig",
      "step_1_heading": "Exchange administrasjonssenter",
      "step_1_text": "Naviger til regler for mailflyt i administrasjonssenteret for Exchange ved å besøke følgende URL: {url}",
      "step_2_heading": "Opprett en ny regel",
      "step_2_text": "Opprett en ny regel og gi den et navn. For eksempel: {copyField}",
      "step_2b_heading": "Konfigurer regel",
      "step_2b_list_1": "Velg \"Meldingshoder...\"",
      "step_2b_list_2": "Deretter velger du \"matcher disse tekstmønstrene\".",
      "step_2b_p1": "Klikk på den første \"Enter text\"-koblingen og skriv inn header-nøkkelen: {copyField}",
      "step_2b_p2": "Klikk på neste \"Skriv inn tekst\"-lenke og skriv inn følgende topptekstsverdi: {copyField}",
      "step_2b_text": "I rullegardinmenyen \"Bruk denne regelen hvis\":",
      "step_3_heading": "Konfigurer meldingshode",
      "step_3_list_1": "Velg \"Endre egenskapene for meldingen\"",
      "step_3_list_2": "Velg deretter \"Angi en meldingshode\".",
      "step_3_list_3": "Klikk på den første \"Skriv inn tekst\"-lenken og sett overskriften til: {copyField}",
      "step_3_list_4": "Klikk på den andre \"Skriv inn tekst\"-koblingen og sett verdien til: {copyField}",
      "step_3_text": "I rullegardinmenyen \"Gjør følgende\":",
      "step_4_heading": "Innstillinger for regel",
      "step_4_list_1": "Klikk \"neste\" og fortsett til regelinnstillinger.",
      "step_4_list_2": "Under \"Regelmodus\" velg \"Håndheve\".",
      "step_4_list_3": "Klikk \"neste\" og gjennomgå regelkonfigurasjonen.",
      "step_5_heading": "Lagre regelen",
      "step_5_text": "Klikk {finish} for å lagre og bruke regelen."
    },
    "microsoft_bypass_junk_by_ip": {
      "bypass_junk_by_ip": "Omgå søppel etter IP",
      "configure_message_header_heading": "Konfigurer meldingshode",
      "configure_message_header_text_bullet_1": "Velg {modify_message_props}",
      "configure_message_header_text_bullet_2": "Velg deretter {set_msg_header}",
      "configure_message_header_text_bullet_3": "Klikk på den første \"Skriv inn tekst\"-lenken og sett headeren til: {header}",
      "configure_message_header_text_bullet_4": "Klikk på den andre \"Skriv inn tekst\"-lenken og sett verdien til: {value}",
      "configure_message_header_text_intro": "I rullegardinmenyen \"Gjør følgende\":",
      "configure_rule_heading": "Konfigurer regel",
      "configure_rule_text_bullet_1": "Velg {the_sender}",
      "configure_rule_text_bullet_2": "Velg deretter {ip_range}",
      "configure_rule_text_bullet_3": "Skriv inn følgende IP-adresser én etter én i popup-vinduet og klikk \"Legg til\". Når du er ferdig, klikk \"Lagre\".",
      "configure_rule_text_intro": "I rullegardinmenyen \"Bruk denne regelen hvis\":",
      "create_new_rule_heading": "Opprett en ny regel",
      "create_new_rule_text": "Opprett en ny regel og gi den et navn. For eksempel: {example}",
      "exchange_admin_center_heading": "Exchange administrasjonssenter",
      "exchange_admin_center_text": "Naviger til regler for e-postflyt i administrasjonssenteret for Exchange ved å besøke følgende URL: {url}",
      "rule_settings_bullet_1": "Klikk \"neste\" og fortsett til regelinnstillinger.",
      "rule_settings_bullet_2": "Under \"Rule mode\" velg \"Enforce\".",
      "rule_settings_bullet_3": "Klikk \"neste\" og gjennomgå regelkonfigurasjonen.",
      "rule_settings_heading": "Regelinnstillinger",
      "save_the_rule_heading": "Lagre regelen",
      "save_the_rule_text": "Klikk {finish} for å lagre og bruke regelen."
    },
    "microsoft_bypass_safe_links_by_header": {
      "bypass_safe_links_by_header": "Omgå Safe Links etter header",
      "configure_message_header_heading": "Konfigurer meldingshode",
      "configure_message_header_text_bullet_1": "Velg {modify_message_properties}",
      "configure_message_header_text_bullet_2": "Deretter velger du {set_a_message_header}",
      "configure_message_header_text_bullet_3": "Klikk på den første \"Skriv inn tekst\"-koblingen og sett overskriften til: {header}",
      "configure_message_header_text_bullet_4": "Klikk på den andre \"Skriv inn tekst\"-koblingen og sett verdien til: {value}",
      "configure_message_header_text_intro": "I rullegardinmenyen \"Gjør følgende\":",
      "configure_rule_heading": "Konfigurer regel",
      "configure_rule_text_bullet_1": "Velg {the_message_headers}",
      "configure_rule_text_bullet_2": "Velg deretter {matches_text_patterns}",
      "configure_rule_text_intro": "I rullegardinmenyen \"Bruk denne regelen hvis\":",
      "configure_rule_text_paragraph_1": "Klikk på den første \"Enter text\"-lenken og skriv inn header-nøkkelen: {header_key}",
      "configure_rule_text_paragraph_2": "Klikk på neste \"Skriv inn tekst\"-lenke og skriv inn følgende headerverdi: {header_value}",
      "create_new_rule_heading": "Opprett en ny regel",
      "create_new_rule_text": "Opprett en ny regel og gi den et navn. For eksempel: {example}",
      "exchange_admin_center_heading": "Exchange-administrasjonssenter",
      "exchange_admin_center_text": "Naviger til regler for e-postflyt i administrasjonssenteret for Exchange ved å besøke følgende URL: {url}",
      "rule_settings_bullet_1": "Klikk \"neste\" og fortsett til regelinnstillinger.",
      "rule_settings_bullet_2": "Under \"Regelmodus\" velg \"Håndheve\".",
      "rule_settings_bullet_3": "Klikk \"neste\" og gjennomgå regelkonfigurasjonen.",
      "rule_settings_heading": "Regelinnstillinger",
      "save_the_rule_heading": "Lagre regelen",
      "save_the_rule_text": "Klikk {finish} for å lagre og bruke regelen."
    },
    "microsoft_bypass_safe_links_by_ip": {
      "bypass_safe_links_by_ip": "Omgå sikre koblinger etter IP",
      "configure_message_header_heading": "Konfigurer meldingshode",
      "configure_message_header_text_bullet_1": "Velg {modify_message_props}",
      "configure_message_header_text_bullet_2": "Velg deretter {set_msg_header}",
      "configure_message_header_text_bullet_3": "Klikk på den første \"Enter text\"-koblingen og sett overskriften til: {header}",
      "configure_message_header_text_bullet_4": "Klikk på den andre \"Skriv inn tekst\"-lenken og sett verdien til: {value}",
      "configure_message_header_text_intro": "I rullegardinmenyen \"Gjør følgende\":",
      "configure_rule_heading": "Konfigurer regel",
      "configure_rule_text_bullet_1": "Velg {the_sender}",
      "configure_rule_text_bullet_2": "Deretter velg {ip_range}",
      "configure_rule_text_bullet_3": "Skriv inn følgende IP-adresser én etter én i popupen og klikk \"Legg til\". Når du er ferdig, klikk \"Lagre\".",
      "configure_rule_text_intro": "I rullegardinmenyen \"Bruk denne regelen hvis\":",
      "create_new_rule_heading": "Opprett en ny regel",
      "create_new_rule_text": "Opprett en ny regel og gi den et navn. For eksempel: {example}",
      "exchange_admin_center_heading": "Exchange-administrasjonssenter",
      "exchange_admin_center_text": "Naviger til regler for e-postflyt i administrasjonssenteret for Exchange ved å besøke følgende URL: {url}",
      "rule_settings_bullet_1": "Klikk \"neste\" og fortsett til regelinnstillinger.",
      "rule_settings_bullet_2": "Under \"Regelmodus\" velg \"Håndheve\".",
      "rule_settings_bullet_3": "Klikk \"neste\" og gjennomgå regelkonfigurasjonen.",
      "rule_settings_heading": "Regelinnstillinger",
      "save_the_rule_heading": "Lagre regelen",
      "save_the_rule_text": "Klikk {finish} for å lagre og bruke regelen."
    },
    "microsoft_integration": "Microsoft allowlisting",
    "microsoft_tenant_allow_block": {
      "add_moxso_ips_to_tabl": "Legg til Moxso IP-adresser i tillat/blokker-lister for leietaker",
      "add_new_entry_bullet_1": "Klikk på {add_button}-knappen.",
      "add_new_entry_bullet_2": "I delen for domenetilpar, skriv inn følgende: {domain_pair_1} {domain_pair_2}",
      "add_new_entry_bullet_3": "Angi Spoof-type til {spoof_internal}.",
      "add_new_entry_bullet_4": "Angi handling til {allow_action}.",
      "add_new_entry_heading": "Legg til en ny oppføring",
      "microsoft_defender_heading": "Microsoft Defender",
      "microsoft_defender_text": "Gå til Leier Tillat/Blokker-lister i Microsoft Defender ved å besøke følgende URL: {url}",
      "save_the_domain_pair_heading": "Lagre domeneparet",
      "save_the_domain_pair_text": "Klikk {add} for å lagre det nye domeneparet."
    },
    "microsoft_third_party": {
      "add_moxso_ips_domains_title": "Legg til Moxsos IP-er og domener i Microsoft Defenders simulering av tredjeparters phishing",
      "download_simulation_heading": "Last ned simuleringsdomener/IP-er",
      "download_simulation_text": "Last ned simuleringsdomener/IP-adresser ved å klikke på knappen nedenfor: {csv_export_button}",
      "edit_entries_bullet_1": "Klikk på {edit_button}-knappen.",
      "edit_entries_bullet_2": "I {domain_section}-delen, skriv inn hvert domenenavn oppført som {domain_text} i den nedlastede CSV-filen.",
      "edit_entries_bullet_3": "I {sending_ip_section}-delen, skriv inn følgende: {ip_1} {ip_2}",
      "edit_entries_heading": "Rediger oppføringer",
      "microsoft_defender_heading": "Microsoft Defender",
      "microsoft_defender_text": "Gå til innstillingene for simulering av phishing fra tredjepart i Microsoft Defender ved å besøke følgende URL: {url}",
      "save_the_domain_pair_heading": "Lagre domeneparet",
      "save_the_domain_pair_text": "Klikk {save_button} for å lagre innstillingene for phishing-simulering fra tredjepart."
    },
    "redirecting": "Omdirigerer",
    "results": {
      "button": "Gå til dashboard",
      "text": "Velkommen om bord! Basert på svarene dine, har vi tildelt treningsnivåer som passer best for deg. Du kan justere disse når som helst i innstillingene.",
      "title": "Oppsummeringen din"
    },
    "risk": {
      "approx_training_time_per_month": "Anslått opplæringstid per måned",
      "more_training_more_time": "Høyere mål for motstandskraft øker opplæringstiden eksponentielt",
      "targeted_resilience_score": "Målrettet motstandsevnepoeng",
      "text": "Bruk glidebryteren for å indikere selskapets totale risikoeksponering og toleranse. Ta hensyn til bransjen din, arten av virksomheten din og følsomheten til informasjonen du håndterer når du velger et risikonivå.",
      "title": "Angi organisasjonens risikonivå"
    },
    "select_your_email_provider": "Velg din e-postleverandør for trinnvise instruksjoner om allowlisting.",
    "setting_up_workspace": "Setter opp arbeidsområde",
    "skip_button": "Hopp over allowlisting",
    "skip_this_step": "Hopp over dette steget",
    "sync_started": "Synkronisering startet",
    "toggle_gmail_api_integration": "Bruk Gmail API-integrasjon",
    "try_integration_again": "Prøv igjen",
    "use_powershell": "Bruk Powershell",
    "verifying_integration": "Verifiserer integrasjon",
    "we_are_now_importing_employees": "Vi synkroniserer ansatte fra {provider}.",
    "welcome": {
      "graphic": {
        "text": "Du kan også hoppe over dette trinnet for nå.",
        "title": "Velg din identitetsleverandør for å komme i gang"
      },
      "text": "For å få mest mulig ut av Moxso, anbefaler vi å gå gjennom denne onboarding-prosessen.",
      "title": "Velkommen til Moxso"
    }
  },
  "pagination": "Side {page} av {lastPage}",
  "policies": {
    "approve_button": "Godkjenn policy",
    "approve_warning": "Å fullføre denne policyen vil deaktivere enhver fremtidig redigering. Ønsker du å fortsette?",
    "approve_warning_title": "Godkjenn policy",
    "audit": {
      "cancel": {
        "audit_canceled": "Revisjon avbrutt",
        "button": "Avbryt revisjon",
        "title": "Avbryt revisjon",
        "warning": "Alle ventende varsler vil bli stoppet umiddelbart og tildelte brukere vil miste tilgang til denne policyen. Ønsker du å fortsette?"
      },
      "details": {
        "all_completed_tooltip": "Alle {count} ansatte har bekreftet revisjonen",
        "completed_tooltip": "Ingen ansatte har bekreftet revisjonen | {count} av {total} ansatte har bekreftet revisjonen | {count} av {total} ansatte har bekreftet revisjonen",
        "created_at": "Opprettet kl.",
        "end_date": "Sluttdato",
        "enrolling_participants_heading": "Registrering av deltakere",
        "enrolling_participants_text": "Deltakere blir påmeldt. Vennligst vent.",
        "group": "Gruppe",
        "groups_heading": "Målgruppe",
        "groups_text": "Detaljer om publikum",
        "heading": "Revisjon",
        "included_members_count_new_members_tooltip": "Nye medlemmer som er lagt til i gruppen etter at denne revisjonen ble startet, inkluderes ikke.",
        "included_members_count_tooltip": "Ansatte som allerede har bekreftet denne policyen, og nye medlemmer som er lagt til i gruppen etter at denne revisjonen ble startet, er ekskludert.",
        "members": "Medlemmer",
        "no_participants_text": "Ingen deltakere for denne revisjonen",
        "no_participants_title": "Ingen deltakere",
        "not_active_yet_text": "Start revisjon for å registrere deltakere.",
        "not_active_yet_title": "Revisjon ikke aktiv",
        "start_date": "Startdato",
        "status": "Status",
        "text": "Revisjonsdetaljer"
      },
      "filters": {
        "acknowledged": "Bekreftet",
        "acknowledged_at": "Bekreftet kl.",
        "acknowledged_default": "Alle",
        "acknowledged_label": "Bekreftelse",
        "not_acknowledged": "Venter"
      },
      "launch": {
        "audit_started": "Revisjon startet",
        "button": "Start revisjon",
        "input_label": "Antall mottakere",
        "title": "Start revisjon",
        "warning": "Du er i ferd med å starte en revisjon som vil distribuere policyen til medlemmer av følgende grupper. Ønsker du å fortsette?"
      },
      "single": {
        "settings": "Innstillinger",
        "title": "Revisjon"
      }
    },
    "audit_draft": "Inaktiv",
    "audit_running": "Revisjon",
    "audits": {
      "create": {
        "buttons": {
          "back": "Gå tilbake",
          "continue": "Fortsett",
          "submit": "Opprett revisjon"
        },
        "date_range": "Revisjonsperiode",
        "date_range_placeholder": "Velg start- og sluttdato for revisjon",
        "error": "Det oppsto en feil under opprettelsen av revisjonen",
        "select_groups": "Velg grupper",
        "title": "Opprett revisjon"
      },
      "create_new_button": "Legg til revisjon",
      "created": "Revisjon opprettet vellykket",
      "edit_button": "Rediger",
      "empty": "Ingen revisjoner tilgjengelig for denne politikken",
      "help": {
        "include_previously_signed": "Ansatte som allerede har bekreftet denne policyen, inkluderes i revisjonen.",
        "notification_flow_enabled": "Aktiver automatiske varsler for ansatte som ennå ikke har bekreftet retningslinjen.",
        "notification_prelude_enabled": "Send en varsling til ansatte når en ny policy tilordnes dem."
      },
      "labels": {
        "include_previously_signed": "Inkluder ansatte som allerede har bekreftet",
        "notification_flow_enabled": "Aktiver varslingsflyt",
        "notification_frequency": "Varslingsfrekvens",
        "notification_prelude_enabled": "Aktiver prelude-varsling"
      },
      "policy_not_approved_yet": "Godkjenn policyen for å starte en revisjon.",
      "save_settings": "Lagre innstillinger",
      "title": "Revisjonshistorikk",
      "updated": "Revisjonen ble oppdatert"
    },
    "create": {
      "create_button": "Opprett policy",
      "duplicate": "Duplikat",
      "duplicated": "Retningslinje duplisert!",
      "from_template": {
        "text": "Velg fra et bibliotek med vanlige retningslinjer.",
        "title": "Opprett policy fra mal"
      },
      "labels": {
        "locale": "Språk",
        "title": "Tittel"
      },
      "manual": {
        "text": "Opprett policy uten å fylle inn noe.",
        "title": "Opprett policy fra bunnen av"
      },
      "placeholders": {
        "locale": "Velg hovedspråk for policyen",
        "title": "Retningslinjens tittel"
      },
      "success": "Policy opprettet!",
      "title": "Opprett policy"
    },
    "delete": {
      "are_you_sure": "Er du sikker på at du vil slette denne policyen? Denne handlingen kan ikke angres.",
      "button": "Slett",
      "policy_deleted": "Retningslinje slettet."
    },
    "edit": {
      "subtitle": "Rediger retningslinjeinnhold og detaljer",
      "title": "Rediger policy",
      "title_updated": "Tittel endret vellykket"
    },
    "editor": {
      "add_column_after": "Legg til kolonne etter",
      "add_column_before": "Legg til kolonne før",
      "add_row_after": "Legg til rad under",
      "add_row_before": "Legg til rad over",
      "delete_column": "Slett kolonne",
      "delete_image": "Slett bilde",
      "delete_row": "Slett rad",
      "delete_table": "Slett tabell",
      "insert_image": "Sett inn bilde",
      "insert_table": "Sett inn tabell",
      "merge_cells": "Slå sammen celler",
      "split_cell": "Del celle",
      "table": "Tabell",
      "toggle_header_row": "Slå overskriftsrad på/av"
    },
    "list": {
      "create_new": "Opprett policy",
      "subtitle": "Oversikt over alle retningslinjer",
      "title": "Retningslinjer"
    },
    "policy_approved": "Retningslinje godkjent.",
    "quiz": {
      "create_button": "Opprett quiz",
      "done_translate_button": "Ferdig",
      "edit_button": "Rediger quiz",
      "empty": "Ingen spørrekonkurranser",
      "other_translations_have_quizzes": "Andre oversettelser har quizer",
      "other_translations_have_quizzes_want_to_translate": "Andre oversettelser har allerede quizzer. Vil du automatisk oversette denne quizen til disse språkene?",
      "processing_n_languages": "Behandler ett språk | Behandler {count} språk",
      "quiz": "Quiz",
      "quiz_now_available_in": "Din quiz er nå tilgjengelig på ett ekstra språk | Din quiz er nå tilgjengelig på {count} ekstra språk",
      "quiz_translate_success": "Suksess!",
      "quizzes_translated": "Oversettelser av quizer.",
      "select_the_languages_you_want_to_translate_your_quiz_into": "Velg språkene du vil oversette quizen din til",
      "some_translations_have_no_quizzes": "Noen oversettelser har foreløpig ingen quizzer. Oversett nå?",
      "subtitle": "Tilgjengelige quizer",
      "this_translation_has_quizzes_in_other_languages_translate_automatically": "Denne oversettelsen har quizzer på andre språk. Oversett automatisk?",
      "title": "Quizzer",
      "translate_button": "Oversett",
      "translate_from": "Oversett fra",
      "translate_multiple_choice_quiz": "Oversett flervalgsspørrekonkurranse",
      "translate_quiz": "Oversett",
      "translating_your_quiz": "Oversette quizen din",
      "update_this_quiz_and_translate_others": "Oppdater denne quizen og oversett andre quizzer",
      "update_this_quiz_only": "Oppdater kun denne quizen",
      "view_button": "Vis quiz"
    },
    "single": {
      "audits": "Revisjoner",
      "audits_subtitle": "Revisjonshistorikk",
      "details": {
        "heading": "Detaljer",
        "text": "Retningslinjedetaljer"
      },
      "labels": {
        "acknowledgement_rate": "Bekreftelsesrate",
        "approval": "Godkjenningsstatus",
        "approved_at": "Godkjent den {approved_at}",
        "approved_by": "Godkjent av {user}",
        "created_at": "Opprettet på",
        "edit": "Rediger",
        "id": "ID",
        "latest_audit_status": "Siste revisjonsstatus",
        "not_approved": "Ikke godkjent",
        "updated_at": "Oppdatert på"
      },
      "subtitle": "Tilgjengelige oversettelser",
      "title": "Retningslinje"
    },
    "tables": {
      "approved_at": "Godkjent på",
      "created_at": "Opprettet den",
      "has_active_audit": "Revisjonsstatus",
      "status_approved": "Godkjent",
      "status_draft": "Utkast",
      "title": "Tittel"
    },
    "translations": {
      "ai": {
        "done_translate_button": "Ferdig",
        "policy_now_available_in": "Polisen din er nå tilgjengelig på ett ekstra språk | Polisen din er nå tilgjengelig på {count} ekstra språk",
        "policy_translate_success": "Vellykket!",
        "processing_n_languages": "Behandler ett språk | Behandler {count} språk",
        "text": "Bruk DeepL for å automatisk oversette policyen til et valgt språk.",
        "title": "Oversett policy med AI",
        "translate_button": "Oversett",
        "translate_from": "Oversett fra",
        "translating_your_policy": "Oversetter policyen din"
      },
      "create": "Oversett",
      "create_deepl_new_button": "Oversett med AI",
      "create_new_button": "Legg til oversettelse",
      "create_success": "Oversettelse opprettet vellykket",
      "create_title": "Legg til oversettelse",
      "created_at": "Opprettet",
      "default_badge": "Standard",
      "delete_are_you_sure": "Er du sikker på at du vil slette denne oversettelsen? Denne handlingen kan ikke angres.",
      "delete_button": "Slett",
      "edit_button": "Rediger",
      "edit_views": {
        "edit": "Rediger",
        "preview": "Forhåndsvisning"
      },
      "empty": "Ingen oversettelser for denne policyen",
      "empty_sections_overview": {
        "subtitle": "Legg til en Overskrift 1 for å lage en ny seksjon",
        "title": "Ingen seksjoner lagt til"
      },
      "language": "Språk",
      "last_updated": "Sist oppdatert",
      "locked": "Redigering er låst da policyen er godkjent.",
      "make_default": "Sett som standard",
      "manual": {
        "first_translation_text": "Kom i gang ved å opprette en oversettelse fra bunnen av",
        "first_translation_title": "Opprett policyoversettelse",
        "text": "Omskriv oversettelsen fra grunnen av på et nytt språk.",
        "title": "Manuelt oversette policy"
      },
      "save": "Lagre endringer",
      "save_success": "Oversettelse lagret.",
      "save_success_title": "Tittel endret vellykket",
      "select_locale": "Målspråk",
      "select_locale_placeholder": "Velg språket for oversettelsen din",
      "subtitle": "Administrer oversettelser for denne policyen",
      "title": "Oversettelser",
      "title_label": "Oversettelsestittel",
      "title_placeholder": "Skriv inn overskrift for oversettelse",
      "translation_deleted": "Oversettelse slettet.",
      "view_button": "Vis"
    }
  },
  "quiz_builder": {
    "buttons": {
      "add_ai_question": "Legg til AI-spørsmål",
      "add_option": "Legg til alternativ",
      "add_question": "Legg til spørsmål",
      "close": "Lukk",
      "edit": "Rediger",
      "save_quiz": "Lagre quiz"
    },
    "delete_question_confirmation": {
      "are_you_sure": "Er du sikker på at du vil slette dette spørsmålet?",
      "button": "Slett spørsmål"
    },
    "empty": {
      "ai_create_button": "Bruk Moxso Intelligence",
      "ai_description": "Kom i gang ved å enten legge til det første spørsmålet eller bruke Moxso AI til å generere en quiz.",
      "create_button": "Opprett quiz",
      "description": "Kom i gang ved å legge til det første spørsmålet.",
      "manually_create_button": "Opprett quiz manuelt",
      "title": "Ingen spørsmål ennå"
    },
    "labels": {
      "answer_options": "Svaralternativer",
      "question": "Spørsmål"
    },
    "placeholders": {
      "answer_option": "Angi alternativ",
      "question": "Skriv inn spørsmål"
    },
    "quiz_saved": "Quiz lagret",
    "quizzes_translated": "Quizer oversatt.",
    "titles": {
      "question": "Spørsmål {number}"
    }
  },
  "report": {
    "click_rate": "Klikkrate",
    "from_value": "fra {value}",
    "last_12_months": "Siste 12 måneder",
    "last_six_months": "Siste seks måneder",
    "no_data": "Ingen data",
    "polarity": "Polaritet",
    "report_rate": "Rapporteringsrate",
    "resilience": "Motstandsdyktighet",
    "simulations": "Simuleringer",
    "training": "Opplæring",
    "vs_previous_period": "mot forrige periode"
  },
  "reset_password": {
    "heading": "Tilbakestill passord",
    "success_message": "Passord lagret vellykket",
    "text": "Vennligst velg et nytt passord"
  },
  "seo_titles": {
    "automation": {
      "action": "Automatiseringsdeltakere",
      "edit": "Rediger automatisering",
      "index": "Automatiseringer",
      "single": "Sekvens"
    },
    "breach": {
      "index": "Brudd",
      "single": "Brudd"
    },
    "campaign": {
      "index": "Simuleringer",
      "single": "Simulering",
      "templates": "Egendefinerte maler"
    },
    "dashboard": {
      "breaches": "Dashboard – Brudd",
      "human_risk_intelligence": "Dashbord - Menneskelig risikoetterretning",
      "overview": "Dashbord",
      "resilience": "Dashbord – Resiliens",
      "simulations": "Dashbord – Simuleringer",
      "threats": "Dashbord – Trusler",
      "training": "Dashboard – Trening"
    },
    "employee": {
      "index": "Ansatte",
      "single": "Ansatt"
    },
    "forgot_password": "Tilbakestill passord",
    "group": {
      "index": "Grupper",
      "single": "Gruppe"
    },
    "impersonate": "Etterligne",
    "integration": "Integrasjon",
    "invite": {
      "id": "Aksepter invitasjon",
      "index": "Godta invitasjon"
    },
    "login": "Logg inn",
    "policies": {
      "audit": "Revisjon",
      "index": "Retningslinjer",
      "single": "Rediger policyoversettelse",
      "translations": "Policyoversettelser"
    },
    "reset_password": "Tilbakestill passord",
    "settings": {
      "breaches": "Innstillinger – Brudd",
      "domains": "Innstillinger – Domener",
      "e_learning": "Innstillinger – Opplæring",
      "export": "Innstillinger – Eksporter data til CSV",
      "import": "Innstillinger – Importer fra CSV",
      "index": "Innstillinger – Arbeidsområde",
      "integrations": {
        "index": "Innstillinger – Integrasjoner",
        "single": "Innstillinger – Rediger integrasjon"
      },
      "risk": "Innstillinger – Risiko",
      "simulations": "Innstillinger – Simuleringer",
      "threats": "Innstillinger – Trusler"
    },
    "threat": {
      "index": "Trusler",
      "single": "Trussel"
    },
    "training": {
      "deadlines": "Frister",
      "index": "E-læring",
      "participation": "Deltakelse"
    },
    "two_factor": "Tofaktorautentisering",
    "user_settings": "Brukerinnstillinger",
    "validate_domain": "Bekreft domene"
  },
  "settings": {
    "breaches": {
      "enable_breaches": {
        "help": "Aktiver brudd for dette arbeidsområdet.",
        "title": "Aktiver brudd"
      },
      "enable_notifications": {
        "help": "Varsle ansatte direkte når de er involvert i nye brudd.",
        "title": "Aktiver varsler"
      },
      "subtitle": "Konfigurer innstillingene dine for brudd.",
      "title": "Brudd"
    },
    "buttons": {
      "add_domain": "Legg til domene",
      "add_report": "Legg til rapport",
      "add_user": "Legg til bruker",
      "resend_invitation": "Send e-post på nytt",
      "revoke_access": "Opphev tilgang",
      "save_settings": "Lagre innstillinger",
      "verify_domain": "Bekreft"
    },
    "data": {
      "subtitle": "Når aktivert, vil poster bli anonymisert 90 dager etter deres siste relevante handling.",
      "title": "Anonymisering av data"
    },
    "domains": {
      "domain_added": "Domene opprettet",
      "domain_required": "Vennligst oppgi et domene",
      "subtitle": "Administrer domenenavn eid av arbeidsområdet ditt.",
      "title": "Bekreftede domener",
      "verification_email_sent": "Bekreftelsesepost sendt",
      "verification_required": "Verifikasjon venter",
      "verified": "Verifisert",
      "verified_on": "Bekreftet den:",
      "verify_new_domain": "Bekreft nytt domene"
    },
    "e_learning": {
      "alert": {
        "not_allowed": "Ikke tillatt",
        "optional_courses": "Valgfrie kurs",
        "optional_courses_description": "Kurs utenfor obligatorisk opplæring",
        "optional_quiz_questions": "Quizspørsmål",
        "optional_quiz_questions_description": "Valgfrie phishing-quizspørsmål",
        "optional_videos": "Valgfrie videoer",
        "optional_videos_description": "Videoer utenfor obligatorisk opplæring",
        "quiz_limit_value": "15 per uke",
        "title": "Begrensninger som gjelder når aktivert",
        "video_limit_value": "2 per uke"
      },
      "modes": {
        "automatic": {
          "description": "Moxso tar seg av hele opplæringsprogrammet automatisk.",
          "recommended": "Anbefalt",
          "title": "Automatisk opplæring"
        },
        "confirmation": {
          "automatic": {
            "description": "Moxso begynner å tildele opplæring automatisk.",
            "title": "Bytte til automatisk opplæring?"
          },
          "manual": {
            "description": "Moxso slutter å tildele opplæring. Eksisterende tildelinger beholdes.",
            "title": "Bytte til planlagt opplæring?"
          },
          "switch": "Bytt"
        },
        "help": "Velg hvordan opplæring tildeles i organisasjonen din.",
        "label": "Opplæringsmodus",
        "manual": {
          "description": "Administratorer planlegger og tildeler opplæring selv.",
          "title": "Planlagt opplæring"
        },
        "will_be_hidden": "Skjules etter byttet"
      },
      "subtitle": "Konfigurer opplæringsinnstillingene dine.",
      "title": "Opplæring"
    },
    "exports": {
      "custom": "Tilpasset",
      "default": "Standard",
      "download_export": "Last ned eksport",
      "export_type": {
        "automation": "Automatiseringsrapport",
        "employee": "Ansatterapport",
        "text": "Velg typen eksport du vil generere.",
        "title": "Eksporttype",
        "training": "Treningsrapport"
      },
      "form": {
        "deselect_all": "Fjern markering av alle felter",
        "select_all": "Velg alle felter"
      },
      "reports": {
        "delete_button": "Slett",
        "deleted_success": "Rapport slettet",
        "download_button": "Last ned",
        "edit_button": "Rediger",
        "search": "Søk",
        "subtitle": "Konfigurer planlagte rapporter for arbeidsområdet ditt.",
        "title": "Planlagte rapporter"
      },
      "selected_columns": "Felt({count}): {columns}",
      "subtitle": "Velg dataene du vil eksportere.",
      "title": "Last ned eksport"
    },
    "forms": {
      "company": {
        "label": "Selskap",
        "placeholder": "Firma"
      },
      "custom_deeplink_url": {
        "description": "Bruk ::content_id:: som en påkrevd plassholder for innholds-ID-en.",
        "label": "Egendefinert innholds-URL",
        "placeholder": "https://example.com/launch/something-::content_id::"
      },
      "custom_lms_url": {
        "label": "Egendefinert LMS-URL",
        "placeholder": "https://example.com/launch/"
      },
      "data_enrichment": {
        "subtitle": "Tildel roller til ansatte basert på deres data.",
        "title": "Berikelse av ansattdata",
        "tooltip": "Berikelse av ansattdata bruker AI til å tildele roller til ansatte basert på deres avdeling og grupper."
      },
      "enhanced_scoring": {
        "subtitle": "Vekt motstandspoeng basert på ansattes roller.",
        "title": "Forbedret poengberegning",
        "tooltip": "Forbedret poenggiving anvender ulike vekter avhengig av hvor sikkerhetskritisk en rolle er, så enkeltpersoner med større tilgang eller ansvar må gjøre mer for å oppnå den samme motstandsdyktighetspoengsummen."
      },
      "gdpr": {
        "employees": {
          "help": "Automatisk anonymiser inaktive ansatte.",
          "title": "Anonymiser inaktive ansatte"
        },
        "threats": {
          "help": "Anonymiser trusseldata automatisk.",
          "title": "Anonymiser håndterte trusler"
        }
      },
      "hotline": {
        "description": "Dette vil være hovedkontakten for teamet ditt i tilfelle en potensiell trussel eller ansattforespørsel.",
        "label": "Hotline",
        "placeholder": "it{'@'}company.com"
      },
      "industry": {
        "label": "Industri"
      },
      "labels": {
        "active_status": "Status",
        "automation": "Automatisering",
        "custom_fields": "Felt",
        "date_range": "Velg datoer",
        "domain": "Domenet",
        "email": "E-post",
        "first_name": "Fornavn",
        "group": "Gruppe",
        "last_name": "Etternavn",
        "report_frequency": "Hyppighet",
        "report_period": "Periode",
        "report_recipient": "Mottaker",
        "report_status": "Status",
        "report_type": "Rapporttype",
        "role": "Rolle",
        "training_type": "Type"
      },
      "leaderboard": {
        "enabled": {
          "subtitle": "Vis en toppliste i huben og velg hvordan ansatte rangeres.",
          "title": "Toppliste"
        },
        "options": {
          "point_leaderboard": "Poengtoppliste",
          "score_leaderboard": "Toppliste for motstandsscore"
        },
        "setting": {
          "label": "Toppliste-type"
        }
      },
      "placeholders": {
        "date_range": "Velg datoer",
        "domain": "company.com",
        "email": "name{'@'}company.com",
        "first_name": "Fornavn",
        "last_name": "Etternavn",
        "report_recipient": "Søk etter ansatt",
        "search_employee": "Søk etter ansatt"
      },
      "reports": {
        "add_scheduled_report": "Legg til planlagt rapport",
        "choose_report_type": "Velg en annen rapporttype",
        "description": "Sett opp planlagte rapporter som skal sendes automatisk.",
        "edit_scheduled_report": "Rediger planlagt rapport",
        "hierarchy_level": {
          "description": "Når dette er aktivert, inkluderer rapporten ansatte lenger ned i hierarkiet, ikke bare direkte rapporter.",
          "label": "Inkluder underliggende teammedlemmer"
        },
        "manager_report": {
          "text": "En rapport for ledere om deres ansatte.",
          "title": "Lederapport"
        },
        "workspace_report": {
          "text": "En rapport for hele arbeidsområdet.",
          "title": "Arbeidsområderapport"
        }
      },
      "scim": {
        "add_title": "Opprett SCIM-token",
        "connection_add_title": "Opprett SCIM-tilkobling",
        "connection_created": "SCIM-tilkobling opprettet.",
        "connection_deleted": "SCIM-tilkobling slettet.",
        "connection_name_label": "Tilkoblingsnavn",
        "connection_name_placeholder": "Microsoft Entra ID",
        "connection_saved": "SCIM-tilkobling lagret.",
        "connection_token_name_placeholder": "{name}-provisjonering",
        "create_connection_button": "Opprett tilkobling",
        "create_token_button": "Opprett token",
        "create_token_header": "Opprett token",
        "created_title": "SCIM-token opprettet",
        "default_mapping_marker": "Standard",
        "delete_connection_body": "Dette fjerner tilkoblingen og tilbakekaller alle SCIM-tokens som er knyttet til den. Provisjonering fra denne leverandøren stopper umiddelbart.",
        "delete_connection_button": "Slett tilkobling",
        "delete_connection_title": "Slette SCIM-tilkobling?",
        "done": "Ferdig",
        "edit_connection_button": "Rediger tilkobling",
        "enabled_label": "Aktivert",
        "name_help": "Gi tokenet et beskrivende navn, slik at du kan kjenne det igjen senere.",
        "name_label": "Tokennavn",
        "name_placeholder": "Microsoft Entra-provisjonering",
        "note_cannot_view": "Dette tokenet vises bare én gang. Lagre det i identitetsleverandøren før du lukker denne dialogen.",
        "provider_label": "Leverandør",
        "reset_mapping_button": "Tilbakestill til standarder",
        "revoke_body": "Provisjoneringsforespørsler som bruker dette tokenet stopper umiddelbart. Eksisterende ansatte og grupper slettes ikke.",
        "revoke_button": "Tilbakekall token",
        "revoke_title": "Tilbakekall SCIM-token",
        "save_connection_button": "Lagre tilkobling",
        "save_mapping_button": "Lagre mapping",
        "secret_token_label": "Hemmelig token",
        "show_mapping_details": "Mappingdetaljer",
        "success_token_added": "SCIM-token lagt til.",
        "success_token_revoked": "SCIM-token tilbakekalt.",
        "sync_type_employee": "Ansatt",
        "sync_type_employee_description": "Provisjoner ansatte og ansattgrupper fra denne identitetsleverandøren.",
        "sync_type_label": "Provisioneringstype",
        "sync_type_user": "Adminbruker",
        "sync_type_user_description": "Provisjoner adminbrukere som har tilgang til administrasjonsdashbordet."
      },
      "select_automation": "Velg automatisering",
      "select_group": "Velg gruppe",
      "settings_saved": "Innstillinger lagret",
      "success": {
        "invitation_resent": "E-postbekreftelsen har blitt sendt på nytt",
        "report_added": "Rapport lagt til vellykket",
        "report_edited": "Rapport lagret",
        "user_added": "Bruker lagt til"
      },
      "timezone": {
        "label": "Tidssone",
        "placeholder": "Velg tidssone"
      },
      "tokens": {
        "add_title": "Opprett token",
        "are_you_sure_you_want_to_delete": "Er du sikker på at du vil slette denne tokenen? Denne handlingen kan ikke angres.",
        "close": "Lukk",
        "create_token_button": "Opprett token",
        "documentation": "Dokumentasjon",
        "name_help": "Gi tokenet ditt et beskrivende navn for å hjelpe deg med å identifisere det senere.",
        "name_label": "Navn",
        "name_placeholder": "Navn på token",
        "note_cannot_view": "Denne tokenen vil bare vises én gang. Lagre den et trygt sted.",
        "success_token_added": "Token lagt til.",
        "success_token_deleted": "Token slettet.",
        "token_created": "Token opprettet"
      },
      "training_restrictions": {
        "enabled": {
          "subtitle": "Begrens hvor mye ikke-tildelt opplæring ansatte kan fullføre på egen hånd.",
          "title": "Opplæringsbegrensninger",
          "tooltip": "Aktiver standardbegrensningene for valgfri opplæring i huben."
        },
        "unassigned_quiz_limit": {
          "help": "Maksimalt antall ikke-tildelte quizer en ansatt kan fullføre.",
          "label": "Quizgrense"
        },
        "unassigned_video_limit": {
          "help": "Maksimalt antall ikke-tildelte videoer en ansatt kan fullføre.",
          "label": "Videogrense"
        }
      },
      "training_type": {
        "course": "Kurs",
        "video": "Video"
      },
      "users": {
        "add_employee": "Legg til bruker"
      }
    },
    "imports": {
      "back": "Tilbake",
      "button": "{klikk} eller dra og slipp",
      "click_to_upload": "Klikk for å laste opp",
      "completed": "Fullført",
      "done": "Fullført",
      "failed": "Mislyktes",
      "file_requirements": "Filen må inneholde følgende kolonner: <b>first_name</b>, <b>last_name</b>, <b>email</b> og <b>locale</b> (f.eks. da_DK, en_US, de_DE).<br/>Eventuelt kan filen inneholde <b>timezone</b> (f.eks. Europe/Copenhagen), <b>phone_number</b> og <b>phone_country_code</b>.<br/><b>CSV-filer må bruke komma som skilletegn.</b><br/>Godkjente formater: .csv eller .txt (Filen bør lagres i UTF-8 format for å sikre korrekt tegnkoding)",
      "formats": "CSV eller TXT opptil 10MB",
      "import_type": {
        "employees": "{count} ansatt | {count} ansatte",
        "groups": "{count} gruppe | {count} grupper"
      },
      "pending": "Synkroniserer",
      "upload_another": "Last opp en annen fil"
    },
    "integrations": {
      "account": {
        "subtitle": "Synkroniser brukerkontoer med Moxso.",
        "title": "Brukere og kommunikasjon"
      },
      "add_our_domains_and_setup_guides": "Legg til våre domener og følg Gmail/Outlook-veiledningene.",
      "addin_setup_guide": "Oppsettveiledning",
      "coming_soon": "Kommer snart",
      "compliance": {
        "subtitle": "Synkroniser med verktøy for overholdelse.",
        "title": "Verktøy for samsvar"
      },
      "connected": {
        "subtitle": "Foreløpig tilkoblede integrasjoner.",
        "title": "Aktive integrasjoner"
      },
      "delete": {
        "button": "Slett integrasjon",
        "confirmation": "Er du sikker på at du vil slette denne integrasjonen? Denne handlingen kan ikke angres.",
        "description": "Hvis du sletter denne integrasjonen, stopper fremtidig synkronisering. Denne handlingen kan ikke angres.",
        "subtitle": "Fjern denne integrasjonen fra arbeidsområdet ditt.",
        "success": "Integrasjon slettet",
        "title": "Slett integrasjon"
      },
      "edit": {
        "auth_settings": {
          "subtitle": "Oppdater autentiseringsinnstillinger",
          "title": "Autentiseringsinnstillinger"
        },
        "filtering": {
          "text": "E-postfiltrering fjerner automatisk delte e-postadresser fra din integrasjon, dette kan være e-postkontoer som: admin{'@'}domain.com, contact{'@'}domain.com osv.",
          "title": "Generisk og rollebasert e-postfiltrering"
        },
        "groups": {
          "text": "Velg om grupper skal synkroniseres hver gang integrasjonen din oppdateres.",
          "title": "Grupper"
        },
        "managers": {
          "text": "Velg om du vil synkronisere ledere hver gang integrasjonen din oppdateres.",
          "title": "Ledere"
        },
        "offboarding": {
          "text": "Velg om ansatte som fjernes fra integrasjonen din, automatisk skal deaktiveres.",
          "title": "Avvikling"
        },
        "settings": {
          "enable_notifications": {
            "title": "Aktiver treningsvarsler"
          },
          "enable_sync": "Aktiver synkronisering",
          "select_sync_frequency": "Velg hvor ofte du vil at integrasjonen din skal synkroniseres.",
          "subtitle": "Oppdater integrasjonskonfigurasjon",
          "sync_frequency": "Synkroniseringsfrekvens",
          "title": "Rediger integrasjon"
        },
        "sync_phone_numbers": {
          "text": "Velg om telefonnumre skal importeres når du synkroniserer med denne integrasjonen.",
          "title": "Importer telefonnumre"
        },
        "title": "Siste synkroniseringer"
      },
      "enabled": "Aktivert",
      "first_sync": "Første synkronisering",
      "form": {
        "access_token": {
          "help": "API-nøkkelen brukes til å autentisere integrasjonen.",
          "label": "API-nøkkel"
        },
        "api_route": {
          "label": "Api-rute",
          "placeholder": "Skriv inn API-rute"
        },
        "password": {
          "help": "Passordet brukes til å autentisere integrasjonen.",
          "label": "Passord",
          "placeholder": "Skriv inn passord"
        },
        "region": {
          "help": "Velg hvilken dataregion du bruker for denne leverandøren.",
          "label": "Dataregion",
          "options": {
            "eu": "EU",
            "global": "Global"
          }
        },
        "username": {
          "help": "Brukernavnet brukes til å autentisere integrasjonen.",
          "label": "Brukernavn",
          "placeholder": "Skriv inn brukernavn"
        }
      },
      "frequency": {
        "daily": {
          "description": "Dataene dine vil synkroniseres hver dag.",
          "title": "Daglig"
        },
        "monthly": {
          "description": "Dataene dine vil bli synkronisert hver måned på den første dagen.",
          "title": "Månedlig"
        },
        "realtime": {
          "description": "Dataene dine vil bli synkronisert hvert minutt.",
          "title": "Sanntid"
        },
        "weekly": {
          "description": "Dataene dine vil bli synkronisert hver uke på mandag.",
          "title": "Ukentlig"
        }
      },
      "gmail_addin": {
        "apps_marketplace_apps": "Apper → Google Workspace Marketplace-apper",
        "click_install_review_deploy": "Klikk {install}, gjennomgå de forespurte tillatelsene, og velg {deploy_to_organisation} (eller en testgruppe) for å gjøre tillegg tilgjengelig for brukere.",
        "deploy_to_organisation": "Distribuer til organisasjonen din",
        "find_moxso_add_in": "Finn tilleggsmidlene «Moxso Report»",
        "in_admin_console_navigate_to": "I administrasjonskonsollen for Google Workspace, naviger til {marketplace_apps}.",
        "install": "Installer",
        "install_and_deploy": "Installer og distribuer tillegget",
        "moxso_report": "Moxso-rapport",
        "open_workspace_marketplace": "Åpne Google Workspace Marketplace",
        "report_threats_directly_from_gmail": "Rapporter trusler til Moxso direkte fra Gmail.",
        "search_to_locate": "Bruk søkefeltet for å finne {moxso_report} og åpne detaljsiden.",
        "title": "Konfigurer Gmail-tillegg"
      },
      "gmail_whitelisting_guide": "Veiledning for å allowliste i Gmail",
      "hri": {
        "connected": "Tilkoblet",
        "directory_description": "Koble til Microsoft Entra eller Google Workspace for å matche ansatt-ID-er og låse opp andre HRI-integrasjoner. Denne HRI-tilkoblingen er atskilt fra den vanlige integrasjonen din.",
        "directory_title": "Koble til ansattkatalogen din først",
        "enable": "Aktiver",
        "explore_description": "Du kan utforske integrasjonene nedenfor. Oppsett krever en aktiv HRI-tilkobling til Microsoft Entra eller Google Workspace.",
        "explore_title": "Utforsk integrasjoner",
        "recommended": "Anbefalt",
        "recommended_tooltip": "Du bruker allerede denne katalogen",
        "setup_locked": "Oppsett låst",
        "setup_prerequisite": "Sett opp HRI for Microsoft Entra eller Google Workspace først."
      },
      "integration_stored": "Integrasjon lagret",
      "last_sync": "Siste synkronisering",
      "last_update": "Siste oppdatering: {time}",
      "lms": {
        "subtitle": "Synkroniser med læringsstyringssystemer.",
        "title": "Læringsadministrasjonssystemer"
      },
      "never": "Aldri",
      "not_connected": "Ikke koblet til",
      "notifications": {
        "subtitle": "Send varsler via samarbeidsverktøy.",
        "title": "Varsler"
      },
      "open_guide": "Åpne veiledning",
      "outlook_addin": {
        "accept_permissions": "Godta tillatelser",
        "add_ins": "Tilleggsenheter",
        "app_type": "App-type",
        "assign_access": "Tilordne tilgang",
        "assign_users": "Tildel brukere",
        "choose_who_get_add_in": "Under {assign_users} velg hvem som skal motta tillegget. Vi anbefaler å velge {specific_users} og plukke de relevante gruppene.",
        "chose_manifest_url": "Velg {provide_link} og lim inn manifest-URL-en:",
        "click": "Klikk {next}.",
        "click_next_then_finish": "Klikk på {next}, deretter {finish}.",
        "click_you_should_see_message": "Klikk {validate}. Du bør se meldingen \"{file_validated}\".",
        "complete": "Fullfør",
        "confirm_slot_is_selected": "I {app_type}-listen, bekreft at {add_in} er valgt.",
        "done": "Ferdig",
        "examine_permissions": "Undersøk de forespurte tillatelsene. Hvis alt ser riktig ut, velg {accept_permissions} og bekreft ledetekstene.",
        "finalize_deployment": "Fullfør distribusjon",
        "finish_deployment": "Fullfør distribusjon",
        "integrated_apps": "Integrerte apper",
        "manifest_file_validated": "Manifestfil validert",
        "navigate_to_admin_center": "Gå til Microsoft 365 administrasjonssenter > Innstillinger > {link}",
        "next": "Neste",
        "office_add-in": "Office-tillegg",
        "open_integrated_apps": "Åpne integrerte apper",
        "proceed_to_assignment": "Fortsett til oppgave",
        "process_indicator_then_complete": "Du vil se en fremdriftsindikator; dette trinnet overstiger sjelden ett minutt. Etterpå trykk {done} for å fullføre oppsettet.",
        "provide_link_to_manifest_file": "Gi lenke til manifestfil",
        "provide_manifest": "Gi manifestet",
        "report_threats_directly_from_outlook": "Rapporter trusler til Moxso direkte fra Outlook.",
        "restart_outlook": "Start Outlook på nytt for å sikre at tillegget initialiseres, og send deretter inn en test e-postrapport. Vær oppmerksom på at tillegget kan ta opptil 24 timer å vises etter distribusjon.",
        "review_permissions": "Gjennomgå tillatelser",
        "select_upload_custom_apps": "Velg {bold}.",
        "specific_users_groups": "Spesifikke brukere/grupper",
        "specify_app_type": "Spesifiser app-typen",
        "start_the_upload": "Start opplastingsprosessen",
        "title": "Konfigurer Outlook-tillegg",
        "upload_custom_apps": "Last opp tilpassede apper",
        "use_powershell": "Bruk powershell",
        "validate": "Bekreft",
        "validate_manifest": "Valider manifestet",
        "verify_add_in": "Bekreft tillegget i Outlook"
      },
      "outlook_whitelisting_guide": "Outlook-veiledning for allowlisting",
      "overview": {
        "active": "Aktive",
        "active_subtitle": "Foreløpig tilkoblede integrasjoner.",
        "active_title": "Aktive integrasjoner",
        "all": "Alle",
        "all_subtitle": "Koble til tjenester for å samle ansattes sikkerhetsaktivitet i Human Risk Intelligence.",
        "all_title": "Alle integrasjoner",
        "attention": "Krever oppmerksomhet",
        "attention_subtitle": "Integrasjoner som krever oppmerksomhet før de kan synkroniseres.",
        "attention_title": "Krever oppmerksomhet",
        "empty": "Ingen integrasjoner funnet.",
        "hri": "Human risk intelligence",
        "search": "Søk etter integrasjoner...",
        "sections": {
          "compliance": "Compliance",
          "lms": "LMS",
          "notifications": "Varsler",
          "signals": "Signaler",
          "user_sync": "Brukersynkronisering"
        }
      },
      "refresh": "Oppdater data",
      "refresh_data": "Oppdater data",
      "report_threats_directly_from_inbox": "Rapporter trusler direkte fra innboksen.",
      "settings_saved": "Innstillinger lagret",
      "setup": "Koble til",
      "setup_integration": "Konfigurer integrasjon",
      "setup_text": "Vi bruker enkeltpålogging (SSO) for å koble sikkert til {provider}. Du vil bli omdirigert til innloggingssiden til din leverandør for autentisering. Vennligst merk at en administratorkonto er nødvendig for å konfigurere integrasjonen.",
      "simulation_deliverability": "Simulering leveringsdyktighet",
      "single": {
        "provider_title": "Rediger {provider}",
        "subtitle": "Oppdater integrasjonskonfigurasjon",
        "title": "Rediger integrasjon"
      },
      "status": "Integrasjonsstatus",
      "step_by_step": "Trinnvis veiledning for å la e-poster slippe gjennom.",
      "sync_already_enabled_tooltip": "Ansattesynkronisering er allerede aktivert i en annen integrasjon. Vennligst deaktiver den for å bruke dette alternativet.",
      "sync_started": "Sync lagt til i kø",
      "tags": {
        "all": "Alle tagger",
        "compliance": {
          "description": "Del data om sikkerhetsbevissthet med plattformen din for etterlevelse.",
          "headline": "Etterlevelse"
        },
        "filter": "Filtrer etter tagg",
        "learning_management": {
          "description": "Koble opplæring i sikkerhetsbevissthet til læringsplattformen din.",
          "headline": "Læringsadministrasjon"
        },
        "notifications": {
          "description": "Send varsler fra Moxso via kommunikasjonsplattformen din.",
          "headline": "Varsler"
        },
        "user_sync": {
          "description": "Synkroniser brukere fra katalogen eller arbeidsområdet ditt til Moxso.",
          "headline": "Brukersynkronisering"
        }
      },
      "teams_guide": {
        "description": "Følg oppsettsveiledningen i vårt {help_center} for instruksjoner om hvordan du legger til Moxso i Microsoft Teams.",
        "download_zip": "Last ned ZIP-fil",
        "help_center": "hjelpesenter"
      },
      "thunderbird_addin": {
        "description": "Rapporter trusler direkte fra Thunderbird",
        "download_button": "Last ned tillegg",
        "download_text": "Lagre moxso-thunderbird.xpi på datamaskinen. Hvis nettleseren prøver å åpne filen, høyreklikker du på nedlastingslenken og velger Lagre lenke som.",
        "download_title": "Last ned tillegget",
        "install_text": "Åpne tannhjulmenyen, velg Installer utvidelse fra fil og velg moxso-thunderbird.xpi. Se gjennom de forespurte tillatelsene og bekreft installasjonen. Start Thunderbird på nytt hvis du blir bedt om det.",
        "install_title": "Installer tillegget",
        "name": "Thunderbird-tillegg",
        "open_text": "Åpne menyen i Thunderbird, velg Utvidelser og temaer og deretter Utvidelser.",
        "open_title": "Åpne tilleggsbehandleren",
        "title": "Oppsett av Thunderbird-tillegg"
      },
      "title": "Integrasjoner",
      "token_error": "Vi kunne ikke opprette en forbindelse med {provider} for deg. Vårt siste forsøk var på: {date}. Vennligst bekreft kontolegitimasjonen din på nytt.",
      "whitelisting_guide": "Veiledning for å allowliste"
    },
    "magic_links": {
      "description": "La ansatte logge inn automatisk via Hub-lenker i varsler. Når funksjonen er deaktivert, åpner lenkene innloggingssiden til Hub og beholder den opprinnelige destinasjonen.",
      "label": "Aktiver magiske lenker",
      "title": "Magiske lenker til Hub"
    },
    "risk": {
      "organisation_risk_subtitle": "Overordnet risikonivå for {organisation}",
      "organisation_risk_text": "Jo høyere risikonivået er, desto mer opplæring vil ansatte motta. Vurder å balansere opplæringsbehov med arbeidsbelastningen til ansatte.",
      "organisation_risk_title": "Organisasjonsrisiko",
      "subtitle": "Juster treningsnivået for hver kategori.",
      "title": "Treningsnivåer"
    },
    "saml": {
      "acs_url": "ACS-URL",
      "add_provider": "Legg til provider",
      "attribute_mapping": {
        "description": "Map SAML assertion-attributter til administratorprofilfeltene Moxso forventer.",
        "title": "Assertion-attributtmapping"
      },
      "cancel_edit": "Avbryt redigering",
      "create": {
        "manual": {
          "description": "Konfigurer provideren manuelt",
          "title": "Opprett manuelt"
        },
        "metadata": {
          "description": "Importer IdP-innstillinger fra provider",
          "title": "Opprett fra metadata-URL"
        }
      },
      "delete": {
        "cancel": "Avbryt",
        "confirm": "Slett tilkobling",
        "description": "Brukere vil ikke lenger kunne logge inn via denne identitetsleverandøren. Eksisterende koblede SAML-identiteter for denne leverandøren blir også fjernet.",
        "title": "Slett SAML-tilkobling"
      },
      "deleted": "SAML-tilkobling slettet",
      "disabled": "Deaktivert",
      "edit_provider": "Rediger provider",
      "empty": {
        "description": "Legg til en SAML-provider så inviterte administratorer kan starte SSO fra innloggingssiden.",
        "title": "Ingen SAML-providere"
      },
      "enabled": "Aktivert",
      "entity_id": "Entity ID",
      "entity_id_instruction": "Bruk entityID-verdien fra metadata-URL-en.",
      "existing_users_only": "SAML-innlogging fungerer bare for eksisterende inviterte administratorer i dette arbeidsområdet.",
      "form": {
        "app_federation_metadata_url": "App federation metadata-URL",
        "app_federation_metadata_url_placeholder": "https://example.com/federationmetadata.xml",
        "email_attribute": "E-postattributt",
        "email_attribute_placeholder": "email",
        "enabled": "Aktiver provider",
        "enabled_help": "Aktiverte providere kan brukes fra innloggingssiden.",
        "first_name_attribute": "Fornavnattributt",
        "first_name_attribute_placeholder": "firstName",
        "idp_entity_id": "IdP entity ID",
        "idp_entity_id_placeholder": "https://idp.example.com/entity",
        "idp_login_url": "IdP-login-URL",
        "idp_logout_url": "IdP-logout-URL",
        "idp_x509_certificate": "IdP X.509-sertifikat",
        "idp_x509_certificate_help": "Det nåværende sertifikatet kan ikke vises igjen. La feltet stå tomt for å beholde det, eller lim inn et nytt sertifikat for å oppdatere det.",
        "idp_x509_certificate_placeholder": "Lim inn sertifikatet fra identitetsleverandøren",
        "idp_x509_certificate_update": "Oppdater sertifikat",
        "last_name_attribute": "Etternavnattributt",
        "last_name_attribute_placeholder": "lastName",
        "login_type": "Krev SAML for",
        "login_type_employee": "Hub-brukere",
        "login_type_employee_description": "Bruk SAML for ansattinnlogging til læringshuben.",
        "login_type_user": "Administratorer",
        "login_type_user_description": "Bruk SAML for administratorinnlogging til adminområdet.",
        "name": "Navn",
        "name_id_format": "Name ID-format",
        "name_placeholder": "Microsoft Entra ID",
        "provider": "Provider",
        "url_placeholder": "https://idp.example.com/sso"
      },
      "idp_entity_id": "IdP entity ID",
      "login_url": "Login-URL",
      "metadata_url": "Metadata-URL",
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      },
      "read": {
        "description": "Kopier disse verdiene inn i oppsettet hos identitetsleverandøren din.",
        "title": "SAML-konfigurasjon"
      },
      "save_provider": "Lagre provider",
      "saved": "SAML-provider lagret",
      "subtitle": "Konfigurer identitetsleverandører for SSO.",
      "table": {
        "delete": "Slett",
        "edit": "Rediger",
        "name": "Navn",
        "provider": "Provider",
        "provider_id": "Provider-ID",
        "status": "Status"
      },
      "title": "SAML single sign-on"
    },
    "simulation": {
      "ceo_fraud": {
        "ceo": {
          "text": "Skriv inn kontaktinformasjonen til din CEO (eller tilsvarende)",
          "title": "Administrerende direktør (CEO)"
        },
        "cfo": {
          "text": "Skriv inn kontaktinformasjonen til din CFO (eller tilsvarende)",
          "title": "Økonomidirektør (CFO)"
        },
        "cto": {
          "text": "Skriv inn kontaktinformasjonen til din CTO (eller tilsvarende)",
          "title": "Chief technology officer (CTO)"
        },
        "info": "Vi bruker informasjonen nedenfor til å tilpasse våre CEO-svindelsimuleringer for din organisasjon. Hvis du ikke har informasjonen tilgjengelig, vil vi bruke standardverdier.",
        "subtitle": "Innstillinger for bedrageri av administrerende direktør i simuleringer.",
        "title": "CEO-svindel"
      },
      "dmi": {
        "google": {
          "alert_text": "Sørg for å konfigurere DMI i Google Workspace før du aktiverer det her.",
          "subtitle": "Sett opp DMI i Google Workspace for å injisere simuleringse-poster direkte til Gmail-innbokser.",
          "title": "DMI for Google Workspace",
          "toggle": {
            "help": "Konfigurer DMI i Google Workspace, og aktiver det deretter her når oppsettet er fullført.",
            "label": "Aktiver DMI"
          }
        }
      },
      "search": {
        "placeholder": "Søk etter tjenester",
        "results": "Søkeresultater for: {query}"
      },
      "services": {
        "credential_harvest": "Legitimasside",
        "selector": {
          "dialog_title": "Rediger tjenester",
          "edit_button": "Rediger tilgjengelige tjenester",
          "title": "Ingen tjenester aktivert | Én tjeneste aktivert | {count} tjenester aktivert",
          "update_services": "Oppdater tjenester"
        },
        "subtitle": "Innstillinger for målretting basert på programvare.",
        "title": "Programvaremålretting"
      },
      "training": {
        "download": {
          "subtitle": "Last ned domener brukt i våre phishing-simuleringer.",
          "title": "Last ned simuleringsdomener"
        },
        "local_ratio": {
          "help": "Ved 70 % får en tysktalende ansatt 70 % tyske maler og 30 % engelske.",
          "subtitle": "Bestem hvordan maler fordeles mellom språket til hver ansatt og engelsk. Når dette er slått av, er det ikke noe fast forhold.",
          "title": "Maler på de ansattes språk"
        },
        "subtitle": "Juster følsomhets- og sporingsinnstillinger for simuleringene dine.",
        "title": "Generelt",
        "toggle": {
          "subtitle": "Send tilleggsopplæring når en ansatt blir funnet å være sårbar.",
          "title": "E-læring"
        }
      }
    },
    "simulations": {
      "ceo_fraud": {
        "ceo_email": {
          "label": "E-post"
        },
        "ceo_name": {
          "label": "Navn"
        },
        "cfo_email": {
          "label": "E-post"
        },
        "cfo_name": {
          "label": "Navn"
        },
        "cto_email": {
          "label": "E-post"
        },
        "cto_name": {
          "label": "Navn"
        }
      },
      "enable_ceo_fraud": "Aktiver CEO-svindel",
      "enable_module_help": "Aktiver denne modulen for arbeidsområdet.",
      "enable_software_targeting": "Aktiver programvaremålretting"
    },
    "tables": {
      "reports": {
        "frequency": "Hyppighet",
        "period": "Periode",
        "recipient": "Mottaker",
        "status": "Status",
        "type": "Type"
      },
      "scim": {
        "actions": "Handlinger",
        "created": "Opprettet",
        "default_mapping": "Standardmapping",
        "effective_mapping": "Effektiv mapping",
        "last_used": "Sist brukt",
        "name": "Navn",
        "provider": "Leverandør",
        "status": "Status",
        "sync_type": "Type"
      },
      "tokens": {
        "created": "Opprettet",
        "last_used": "Sist brukt",
        "name": "Navn"
      },
      "users": {
        "created": "Opprettet",
        "role": "Rolle",
        "status": "Status",
        "two_factor": "2FA",
        "user": "Bruker"
      }
    },
    "threats": {
      "advanced_settings": {
        "hide": "Skjul avanserte innstillinger",
        "show": "Vis avanserte innstillinger"
      },
      "alias_email": {
        "help": "Vi foreslår å lage en mer brukervennlig aliasversjon av den innkommende e-postadressen. For eksempel security{'@'}example.com",
        "label": "Alias-e-post",
        "placeholder": "sikkerhet{'@'}example.com"
      },
      "clustering": {
        "title": "Trusselklynging"
      },
      "enable_defender_integration": {
        "help": "Videresend rapporterte phishing-e-poster til Microsoft Defender.",
        "label": "Aktiver Microsoft Defender-integrering",
        "title": "Microsoft Defender"
      },
      "enable_forwarding": {
        "help": "Aktiver trusselvideresending til en bestemt e-postadresse.",
        "title": "Aktiver videresending av trusler"
      },
      "enable_grouped_threat_status_transitions": {
        "help": "Når funksjonen er aktivert, får nyopprettede trusler samme status som den relaterte trusselen",
        "title": "Aktiver automatisk statusovergang for trusler i klynger"
      },
      "enable_notifications": {
        "help": "Få et varsel hver gang en potensiell trussel rapporteres",
        "title": "Aktiver varsler"
      },
      "enable_third_party_submission": {
        "help": "Aktiver innsending av phishing-angrep fra tredjepart til Microsoft og Google.",
        "title": "Aktiver innsending fra tredjepart"
      },
      "enable_threat_management": {
        "help": "Aktiver trusselhåndtering for dette arbeidsområdet.",
        "title": "Aktiver trusselhåndtering"
      },
      "forward_reported_emails_to": {
        "label": "Videresend rapporterte e-poster til:",
        "placeholder": "rapportert{'@'}company.com"
      },
      "forward_to": {
        "label": "Videresend til:",
        "placeholder": "phishing{'@'}company.com"
      },
      "forwarding": {
        "defender": {
          "description": "Videresend rapporterte phishing-e-poster til Microsoft Defender.",
          "title": "Videresend til Defender"
        },
        "disabled": {
          "description": "Ikke videresend rapporterte trusler.",
          "title": "Deaktiver videresending"
        },
        "email": {
          "description": "Send rapporterte trusler til en bestemt e-postadresse.",
          "title": "Videresend til e-post"
        },
        "title": "Trusselvideresending"
      },
      "forwarding_warning": "Når trusselvideresending er aktivert, vil rapporterte trusler være skrivebeskyttet i administrasjonspanelet. Ingen analyse vil bli utført av Moxso.",
      "inbound_email": {
        "help": "Denne e-postadressen er din personlige rapporteringsadresse. Alle e-poster sendt til denne adressen vil bli analysert av Moxso.",
        "label": "Innkommende e-post"
      },
      "save_forwarded_emails": {
        "help": "Når dette er aktivert, blir videresendte e-poster lagret.",
        "label": "Lagre videresendte trusler"
      },
      "subtitle": "Konfigurer innstillingene for trusselhåndtering.",
      "threat_grouping_confidence": {
        "help": "Styrer hvor godt trusler må samsvare før de samles i en klynge.",
        "label": "Konfidensnivå for trusselklynger",
        "options": {
          "high": "Høy",
          "low": "Lav",
          "medium": "Middels"
        }
      },
      "title": "Håndtering av trusler"
    },
    "two_factor": {
      "actions": {
        "disable": "Deaktiver tofaktorautentisering",
        "enable": "Aktiver tofaktorautentisering",
        "regenerate_recovery_codes": "Generer gjenopprettingskoder på nytt",
        "view_recovery_codes": "Vis gjenopprettingskoder"
      },
      "disabled": {
        "badge": "Av",
        "text": "Beskytt denne adminkontoen med en kode fra en autentiseringsapp eller passordbehandler.",
        "title": "Tofaktorautentisering er slått av"
      },
      "enabled": {
        "badge": "På",
        "text": "Denne adminkontoen krever en ekstra faktor ved innlogging.",
        "title": "Tofaktorautentisering er aktivert"
      },
      "password_dialog": {
        "cancel": "Avbryt",
        "cancel-setup": {
          "button": "Avbryt oppsett",
          "description": "Bekreft det nåværende passordet ditt for å avbryte det pågående tofaktoroppsettet.",
          "title": "Avbryt tofaktoroppsett"
        },
        "current_password": "Nåværende passord",
        "disable": {
          "button": "Deaktiver",
          "description": "Bekreft det nåværende passordet ditt for å deaktivere tofaktorautentisering for denne kontoen.",
          "title": "Deaktiver tofaktorautentisering"
        },
        "enable": {
          "button": "Fortsett",
          "description": "Bekreft det nåværende passordet ditt før du setter opp tofaktorautentisering.",
          "title": "Aktiver tofaktorautentisering"
        },
        "regenerate-recovery-codes": {
          "button": "Generer koder på nytt",
          "description": "Bekreft det nåværende passordet ditt for å erstatte de eksisterende gjenopprettingskodene.",
          "title": "Generer gjenopprettingskoder på nytt"
        },
        "show-recovery-codes": {
          "button": "Vis koder",
          "description": "Bekreft det nåværende passordet ditt for å se gjenopprettingskodene dine.",
          "title": "Vis gjenopprettingskoder"
        }
      },
      "recovery_codes": {
        "copied": "Kopiert",
        "copy": "Kopier koder",
        "text": "Lagre disse engangskodene i passordbehandleren din. De vises ikke her igjen etter at du lukker dem.",
        "title": "Gjenopprettingskoder"
      },
      "setup": {
        "cancel": "Avbryt oppsett",
        "code_label": "Autentiseringskode",
        "code_placeholder": "123456",
        "confirm": "Bekreft",
        "manual_key": "Manuell oppsettsnøkkel",
        "qr_alt": "QR-kode for tofaktoroppsett",
        "text": "Skann QR-koden med autentiseringsappen eller passordbehandleren din, og skriv deretter inn den 6-sifrede koden den genererer.",
        "title": "Sett opp autentiseringsappen"
      },
      "subtitle": "Krev en ekstra faktor ved innlogging til adminkontoen din.",
      "title": "Tofaktorautentisering"
    },
    "workspace": {
      "lms": {
        "subtitle": "Konfigurer en egendefinert innholds-URL for å omdirigere brukere til en ekstern læringsplattform.",
        "title": "Eksternt LMS"
      },
      "logging": {
        "activity": "Aktivitet",
        "columns": {
          "action_time": "Handlingstidspunkt",
          "action_type": "Handlingstype",
          "actor": "Aktør",
          "zone": "Sone"
        },
        "moxso_support": "Moxso support",
        "partner": "Partner",
        "slideover": {
          "actor": "Aktør",
          "app": "App",
          "audit_log": "Revisjonslogg",
          "created": "Opprettet",
          "email": "E-post",
          "event": "Hendelse",
          "impersonated_by_support": "Etterlignet av support",
          "ip_address": "IP-adresse",
          "name": "Navn",
          "no": "Nei",
          "path": "Sti",
          "request": "Forespørsel",
          "summary": "Oversikt",
          "tabs": {
            "request": "Forespørsel",
            "summary": "Oversikt og aktør"
          },
          "title": "Hendelse",
          "type": "Type",
          "user_agent": "User agent",
          "yes": "Ja"
        },
        "subtitle": "Se historikken over endringer gjort i denne kontoen.",
        "title": "Revisjonslogger"
      },
      "scim": {
        "attribute_mapping": {
          "subtitle": "Overstyr støttede SCIM-attributtmål for denne tilkoblingen. Tomme rader bruker backendens standardmapping.",
          "title": "Attributtmapping"
        },
        "connection_settings": {
          "subtitle": "Administrer leverandør, navn og aktivert status for den valgte SCIM-tilkoblingen.",
          "title": "Tilkoblingsinnstillinger"
        },
        "connections": {
          "disabled": "Deaktivert",
          "enabled": "Aktivert",
          "subtitle": "Konfigurer identitetsleverandørtilkoblinger for automatisert SCIM-provisjonering av brukere og grupper.",
          "title": "SCIM-tilkoblinger"
        },
        "endpoint": {
          "label": "Tenant-URL",
          "subtitle": "Bruk denne base-URLen i identitetsleverandøren. Ikke legg til Users, Groups eller ServiceProviderConfig i URLen.",
          "title": "Provisjoneringsendepunkt"
        },
        "tokens": {
          "subtitle": "Opprett bearer-tokens for Microsoft Entra ID, Okta eller en annen SCIM v2-identitetsleverandør.",
          "title": "SCIM-provisjoneringstokens"
        }
      },
      "subtitle": "Konfigurer innstillingene for arbeidsområdet ditt.",
      "title": "Arbeidsområdets innstillinger",
      "tokens": {
        "subtitle": "Få sikker tilgang til Moxso-datalageret fra appene og tjenestene dine.",
        "title": "Datavarehus"
      },
      "user": {
        "two_factor_disabled": "Deaktivert",
        "two_factor_enabled": "Aktivert",
        "verification_required": "Verifisering venter",
        "verified": "Verifisert"
      },
      "users": {
        "subtitle": "Administrer brukere i ditt arbeidsområde",
        "title": "Brukere"
      }
    }
  },
  "simulations": {
    "audience_missing_phone_numbers_all": "Ingen av de ansatte i det valgte publikumet har telefonnumre. Vennligst endre publikumet eller legg til telefonnumre, og prøv igjen.",
    "audience_missing_phone_numbers_some": "Én ansatt av {total} i det valgte publikumet mangler et telefonnummer. | {count} ansatte av {total} i det valgte publikumet mangler telefonnumre.",
    "click_rate": {
      "title": "Klikkfrekvens"
    },
    "clicked": "Klikket",
    "count": {
      "title": "Behandlede simuleringer",
      "unit": "Simuleringer"
    },
    "create": {
      "button": "Lag simulering",
      "configuration": {
        "choose_type": "Tilbake",
        "text": "Definer publikummet og innstillingene for denne simuleringen.",
        "title": "Konfigurer simuleringen din",
        "token": "Sett en tilpasset e-postheader for allowlisting. Tokenet ditt vil sendes som en {token} header på hver e-post som sendes fra denne simuleringen."
      },
      "credential_harvest": {
        "description": "Når aktivert, vil ansatte utelukkende motta simuleringer som inkluderer innloggingssider. Moxso overvåker innsendte skjemaer, men lagrer aldri noen innskrevne legitimasjoner.",
        "enable_label": "Aktiver innsamling av legitimasjon",
        "title": "Høsting av legitimasjon"
      },
      "delivery_rate": {
        "high": {
          "email_description": "1-2 uker mellom e-poster",
          "sms_description": "1-2 uker mellom tekstmeldinger",
          "title": "Høy"
        },
        "low": {
          "email_description": "1–6 uker mellom e-poster",
          "sms_description": "1-6 uker mellom tekstmeldinger",
          "title": "Lav"
        },
        "medium": {
          "email_description": "1–4 uker mellom e-poster",
          "sms_description": "1-4 uker mellom tekstmeldinger",
          "title": "Middels"
        }
      },
      "help": {
        "audience": "Bestem hvilken målgruppe som skal motta denne simuleringen.",
        "email_delivery_rate": "Definerer tiden mellom simulerings-e-poster. Hyppighet tilpasses innenfor leveringshastighetsområdet basert på ansattes ytelse.",
        "sms_delivery_rate": "Definerer tiden mellom simuleringstekstmeldinger. Frekvensen tilpasses innenfor leveringsfrekvensen basert på ansattes ytelse.",
        "staggered_delivery": "Simuleringer leveres tilfeldig på hverdager innenfor det valgte antallet dager.",
        "test": "Testsimuleringer påvirker ikke brukernes treningsopptegnelser eller rapporteringsmålinger."
      },
      "labels": {
        "audience": "Publikum",
        "delivery_rate": "Leveringsgrad",
        "name": "Navn",
        "preview": "Forhåndsvisning",
        "schedule_type": "Planleggingstype",
        "staggered_delivery": "Forskjøvet levering",
        "template": "Mal",
        "test": "Merk som testsimulering",
        "token": "Token",
        "token_header": "Angi en egendefinert token-header for simulering",
        "use_template": "Bruk egendefinert mal"
      },
      "placeholders": {
        "audience": "Vennligst velg publikum",
        "name": "Navn på simulering",
        "token": "I'm sorry, but \"ABC-123\" does not provide sufficient context or identifiable placeholders to translate or modify. Could you please provide more details or context?"
      },
      "random_template": "Tilfeldig mal",
      "remove_template": "Fjern mal",
      "step_current_of_last": "Steg {current_step} av {last_step}",
      "type": {
        "button": "Neste",
        "email": {
          "text_plural": "Send simuleringer som e-post",
          "text_singular": "Send simulering som e-post",
          "title": "E-post"
        },
        "help": {
          "delivery_method": "Velg hvordan simuleringen skal leveres",
          "schedule_type": "Velg hvor ofte denne simuleringen skal kjøres"
        },
        "labels": {
          "delivery_method": "Leveringsmetode",
          "schedule_type": "Planlegg type"
        },
        "one_off": {
          "text": "Alle angrepene vil bli sendt når simuleringen startes.",
          "title": "Engangssimulering"
        },
        "recurring": {
          "text": "Angrep vil bli sendt hver måned til simuleringen er deaktivert",
          "title": "Automatisert simulering"
        },
        "sms": {
          "text_plural": "Send simuleringer som tekstmeldinger",
          "text_singular": "Send simulering som tekstmelding",
          "title": "Tekstmelding"
        },
        "text": "Velg tidsplanen og leveringsmetoden for denne simuleringen.",
        "title": "Sett opp simuleringleveranse"
      }
    },
    "delete": {
      "are_you_sure": "Er du sikker på at du vil slette denne simuleringen? Denne handlingen kan ikke angres.",
      "button": "Slett simulering",
      "simulation_deleted": "Simulering slettet"
    },
    "details": {
      "heading": "Sammendrag",
      "text": "Simuleringsoppsummering"
    },
    "edit": {
      "button": "Rediger innstillinger",
      "button_save": "Lagre innstillinger",
      "campaign_updated": "Simulering oppdatert",
      "title": "Rediger simulering"
    },
    "filter": {
      "status": {
        "all": "Status: Alle",
        "click": "Status: Klikket",
        "report": "Status: Rapportert",
        "submission": "Status: Pålogging"
      }
    },
    "launch": {
      "button": "Start simulering",
      "input_label": "Skriv inn det totale antallet mottakere",
      "launched": "Simulering startet",
      "no_recipients": "Den valgte målgruppen har ingen medlemmer. Vennligst juster målgruppen og prøv igjen.",
      "no_recipients_title": "Ingen medlemmer",
      "title": "Start simulering",
      "warning": "Du er i ferd med å starte en simulering som vil bli sendt til {count} mottakere. Er du sikker på at du vil fortsette?"
    },
    "opened": "Åpne",
    "pause": "Sett simuleringen på pause",
    "pause_confirmation": {
      "results": "Resultater fra simuleringer som allerede er sendt, beholdes.",
      "title": "Sett simuleringen på pause?",
      "warning": "Når du setter simuleringen på pause, avbrytes {count} planlagt utsendelse. Når du gjenopptar den, erstatter en ny tidsplan de opprinnelige utsendelsesdatoene. Ansatte kan derfor måtte vente lenger på sin neste simulering. | Når du setter simuleringen på pause, avbrytes {count} planlagte utsendelser. Når du gjenopptar den, erstatter en ny tidsplan de opprinnelige utsendelsesdatoene. Ansatte kan derfor måtte vente lenger på sin neste simulering."
    },
    "play": "Gjenoppta simulering",
    "received": "Mottatt",
    "report_rate": {
      "title": "Rapporteringsrate"
    },
    "reported": "Rapportert",
    "scheduled": "Planlagt",
    "send_test": "Send test",
    "send_test_tooltip": "Dette vil sende en testepost til {userEmail}",
    "staggered_delivery": {
      "days": "{count} dag | {count} dager",
      "off": "Av"
    },
    "stop": {
      "button": "Stopp simulering",
      "simulation_stopped": "Simulering stoppet",
      "title": "Stoppe simuleringen?",
      "warning": "Hvis du stopper simuleringen, avbrytes alle gjenstående planlagte leveranser. Resultater fra simuleringer som allerede er sendt, beholdes. Er du sikker på at du vil fortsette?"
    },
    "submission_disabled": "Deaktivert",
    "submission_enabled": "Aktivert",
    "submission_rate": {
      "title": "Innringsfrekvens"
    },
    "submitted": "Logg inn",
    "summary": {
      "credential_harvest": "Innhøsting av legitimasjon",
      "delivery_method": "Leveringsmetode",
      "delivery_rate": "Leveringsgrad",
      "group": "Publikum",
      "schedule_type": "Timeplanstype",
      "staggered_delivery": "Forskjøvet levering",
      "test": "Test simulering",
      "type": "Type"
    },
    "templates": {
      "create": {
        "button": "Opprett mal",
        "success_text": "Malen ble opprettet",
        "title": "Opprett simuleringsmal"
      },
      "duplicate": {
        "button": "Dupliser",
        "subject": "Kopi",
        "success_text": "Mal duplisert",
        "title": "Dupliser simuleringsmal"
      },
      "edit": {
        "button": "Lagre mal",
        "success_text": "Malen er lagret",
        "title": "Rediger simulasjonsmal"
      },
      "editor": {
        "ai_modal": {
          "button": "Generer",
          "placeholder": "Beskriv simuleringsmalen du ønsker å bygge...",
          "title": "Generer mal ved hjelp av AI"
        },
        "attack_link": "Angrepslenke",
        "attack_link_already_applied": "Angrepslenker brukes automatisk på knapper.",
        "buttons": {
          "generate": "Generer",
          "send_preview": "Send meg en forhåndsvisning"
        },
        "change_image": "Endre bilde",
        "default_block_content": {
          "button": "Se gjennom nå",
          "container_text": "Sett inn innhold her",
          "footer_text": "Du mottar denne e-posten fordi du er ansatt hos ::workspace.name::.",
          "heading_1": "Overskrift 1",
          "heading_2": "Overskrift 2",
          "heading_3": "Overskrift 3",
          "image_alt": "Bilde",
          "text": "Skriv meldingen din her.",
          "unsubscribe": "Avmeld"
        },
        "generating_template": "Genererer mal",
        "google_dmi_enabled": "Direct message injection er aktivert",
        "insert_image": "Sett inn bilde",
        "labels": {
          "custom_domain": "Egendefinert domene",
          "email": "E-post",
          "select_domain": "Velg et domene",
          "sender": "Avsender",
          "string_templates": {
            "date_last_month": "Samme dag forrige måned",
            "date_last_week": "Samme dag forrige uke",
            "date_last_year": "Samme dag forrige år",
            "date_next_month": "Samme dag neste måned",
            "date_next_week": "Samme dag neste uke",
            "date_next_year": "Samme dag neste år",
            "date_today": "I dag",
            "date_tomorrow": "I morgen",
            "date_yesterday": "I går",
            "department": "Avdeling",
            "email": "E-post",
            "first_name": "Fornavn",
            "last_name": "Etternavn",
            "manager_email": "Manager e-post",
            "manager_first_name": "Manager fornavn",
            "manager_last_name": "Manager etternavn",
            "workspace_address": "Firmanavnadresse",
            "workspace_city": "Bedriftens by",
            "workspace_name": "Selskapsnavn",
            "workspace_postal_code": "Firmaens postnummer"
          },
          "subject": "Emne"
        },
        "no_image_selected": "Ingen bilde valgt",
        "placeholders": {
          "custom_domain": "example.com",
          "email": "Avsendernavn",
          "sender_name": "Alice Smith",
          "subject": "Skriv inn emne her"
        },
        "preview_sent_success": "Forhåndsvisnings-e-post sendt vellykket.",
        "qr_code": "QR-kode",
        "sidebar": {
          "blocks": "Blokker",
          "no_tags_found": "Ingen tags funnet",
          "settings": "Innstillinger",
          "settings_title": "Innstillinger for valgt blokk",
          "style": "Design",
          "style_title": "Maledesign",
          "tags": "Merkelapper",
          "variables_title": "Flettemerker"
        },
        "sidebar_field_options": {
          "center": "Sentrert",
          "fixed": "Fast bredde",
          "full_width": "Full bredde",
          "left": "Venstre",
          "right": "Høyre"
        },
        "sidebar_fields": {
          "alt_text": "Alt-tekst",
          "auto": "Automatisk",
          "background_color": "Bakgrunnsfarge",
          "border_radius": "Hjørneradius",
          "button_dimensions_hint": "Mål er i piksler. Sett bredde eller høyde til 0 for å tilpasse til teksten.",
          "button_min_height": "Minimumshøyde",
          "color": "Farge",
          "column_width": "Bredde på kolonne {column} (%)",
          "columns": "Kolonner",
          "content_alignment": "Justering",
          "content_width_mode": "Bredde",
          "font_size": "Skriftstørrelse",
          "gap": "Mellomrom",
          "height": "Høyde",
          "image_url": "Bilde",
          "padding": "Utfylling",
          "text_color": "Tekstfarge",
          "thickness": "Tykkelse",
          "width": "Bredde"
        },
        "sidebar_placeholders": {
          "alt_text": "Describe the image",
          "button_label": "Review now",
          "legal_copy": "You are receiving this email because you are an employee of ::workspace.name::."
        },
        "tooltip_fill_out_all_fields": "Fyll ut alle felt for å sende en forhåndsvisning",
        "tooltip_this_will_save_the_template": "Dette vil lagre malen",
        "unsaved_changes": {
          "confirm_exit": "Du har ulagrede endringer. Er du sikker på at du vil avslutte?",
          "description": "Du har ulagrede endringer. Hvis du forlater siden uten å lagre, vil endringene dine gå tapt.",
          "discard": "Forkast endringer",
          "save_and_exit": "Lagre og avslutt",
          "subtile": "Lagre før du avslutter?",
          "title": "Ulagrede endringer"
        },
        "unsaved_changes_badge": "Ulagrede endringer"
      }
    },
    "test_sent": "Test e-post sendt til {userEmail}",
    "tooltip": {
      "click": "En lenke ble klikket på",
      "open": "Denne simuleringen ble åpnet",
      "report": "Simuleringen ble rapportert",
      "submit": "Et påloggingsforsøk ble gjort"
    },
    "updated": "Simulering oppdatert"
  },
  "statistics": {
    "activities_by_type": {
      "completed_courses": "Fullførte kurs",
      "phishing_quiz_correct_answers": "Riktige svar på phishingquiz",
      "phishing_quiz_incorrect_answers": "Feil svar på phishingquiz",
      "quiz_answers": "Svar på quiz",
      "quiz_correct_answers": "Riktige svar på quiz",
      "quiz_incorrect_answers": "Feil svar på quiz",
      "simulations_delivered": "Leverte simuleringer",
      "simulations_failed": "Mislykkede simuleringer",
      "simulations_passed": "Beståtte simuleringer",
      "simulations_reported": "Simuleringer rapportert",
      "text": "Hvordan dine ansatte trener",
      "threats_reported": "Rapporterte trusler",
      "title": "Fullførte aktiviteter",
      "videos_watched": "Videoer sett"
    },
    "benchmarks": {
      "above_benchmark_tooltip": "Verdien er over referanseverdien.",
      "average": "Gjennomsnitt på nettverket",
      "below_benchmark_tooltip": "Verdien er under referanseverdien.",
      "benchmark_tooltip": "Referansepunkt",
      "peer_avg": "Gjennomsnitt blant likemenn.",
      "score": "Gjeldende poengsum",
      "text_higher": "% bedre enn sammenlignbare selskaper",
      "text_lower": "% lavere enn sammenlignbare selskaper",
      "title": "Referanseverdier"
    },
    "breaches": {
      "title": "Brudd"
    },
    "competence": {
      "text": "Hvor godt ansatte presterer i opplæringen sin",
      "title": "Kompetanse"
    },
    "culture": {
      "text": "Hvor engasjerte dine ansatte er i sikkerhetstreningen sin",
      "title": "Kultur"
    },
    "employee_activity": {
      "title": "Ansattaktivitet"
    },
    "employees": {
      "title": "Aktive ansatte"
    },
    "onboarding": {
      "title": "Onboarding"
    },
    "overdue": {
      "change": "{points} prosentpoeng vs. {date}",
      "security_program_text": "Prosentandel av ansatte som ikke følger sikkerhetsprogrammet sitt (opplæring, retningslinjer)",
      "security_program_title": "Ansatte som ligger etter med sikkerhetsprogrammet",
      "text": "Prosentandel av aktive ansatte med overskredne opplæringsfrister",
      "title": "Overskredne frister",
      "unit": "Forsinkede frister"
    },
    "recent_activity": "Siste aktivitet",
    "resilience_score": {
      "change_last_90_days": "{value}% de siste 90 dagene",
      "text": "Beregnet poengsum basert på hvordan alle aktive ansatte trener og presterer i simuleringer.",
      "title": "Nåværende motstandspoengsum"
    },
    "resilience_score_progression": {
      "title": "Motstandsdyktighetspoeng over tid"
    },
    "risk_level": {
      "country": "Land",
      "text": "Risikofaktor er bestemt av land, organisasjon og en syntetisert risikonivå, som gir innsikt i dagens trusselbilde.",
      "title": "Risikobasert nivå",
      "workspace": "Arbeidsområde"
    },
    "show_more": "Vis mer",
    "simulation_coverage": {
      "title": "Simuleringsdekning"
    },
    "simulations": {
      "campaign_overview": "Kampanjeoversikt",
      "click_count": {
        "text": "Antall ganger en simulering har blitt klikket på.",
        "title": "Totalt antall klikk",
        "unit": "Klikk"
      },
      "click_rate": {
        "text": "Beregnet poengsum basert på prosentandelen av ansatte som har klikket på en lenke i en simulering.",
        "title": "Klikkfrekvens",
        "unit": "%"
      },
      "count": {
        "text": "Totalt antall simuleringer sendt.",
        "title": "Simuleringer sendt",
        "unit": "Simuleringer"
      },
      "performance_metrics": "Ytelsesmålinger",
      "reporting_count": {
        "text": "Totalt antall simuleringer rapportert",
        "title": "Totale rapporter",
        "unit": "Rapporter"
      },
      "reporting_rate": {
        "text": "Beregnet poengsum basert på prosentandelen av ansatte som har rapportert en simulering.",
        "title": "Rapporteringsrate",
        "unit": "%"
      },
      "submission_count": {
        "text": "Totalt antall simuleringer sendt inn.",
        "title": "Totalt antall innsendelser",
        "unit": "Innsendinger"
      },
      "submission_rate": {
        "text": "Beregnet poengsum basert på prosentandelen av ansatte som har logget inn på en simulering.",
        "title": "Innloggingsfrekvens",
        "unit": "%"
      },
      "submission_sent_count": "Totalt antall innsendinger sendt"
    },
    "simulations_sent": {
      "title": "Simuleringer sendt"
    },
    "threats": {
      "count": {
        "text": "Antall trusler rapportert av ansatte.",
        "title": "Rapporterte trusler"
      },
      "fraud_count": {
        "text": "Antall falske trusler rapportert av ansatte.",
        "title": "Svindeltrusler"
      },
      "handle_rate": {
        "text": "Beregnet poengsum basert på prosentandelen trusler som er håndtert av en administrator.",
        "title": "Håndteringshastighet for trusler"
      },
      "reporting_rate": {
        "title": "Trusler rapportert"
      },
      "status_partition": {
        "title": "Trusselstatus"
      },
      "text": "Hvordan dine ansatte håndterer trusler",
      "time_to_handle": {
        "text": "Den gjennomsnittlige tiden det tar for dine ansatte å håndtere en trussel.",
        "title": "Behandlingstid"
      },
      "title": "Trusseloppdagelse"
    },
    "timeframe_nienty_days": "I løpet av de siste 90 dagene",
    "training": {
      "courses": {
        "title": "Kurs",
        "unit": "Fullførte kurs"
      },
      "phishing_quizzes": {
        "title": "Phishing-quizzer"
      },
      "quizzes": {
        "title": "Quizer"
      },
      "video_quizzes": {
        "title": "Videokvizer"
      },
      "videos": {
        "title": "Videoer",
        "unit": "Fullførte videoer"
      }
    },
    "training_coverage": {
      "text": "Beregnet poengsum basert på prosentandelen av ansatte som har fullført sikkerhetstrening.",
      "title": "Omfanget av trening"
    }
  },
  "tables": {
    "anonymized_at": "Anonymisert kl.",
    "audience": "Publikum",
    "audit_completed_status": "Bekreftet kl.",
    "available_at": "Tilgjengelig på",
    "breached_at": "Opprettelsesdato",
    "completed_at": "Fullført kl.",
    "created": "Opprettet",
    "created_at": "Opprettet den",
    "deadlines": {
      "deadline": "Frist",
      "employee": "Ansatt",
      "last_learning_interaction": "Siste interaksjon",
      "lesson": "Leksjon",
      "reminder_sent": "Siste påminnelse"
    },
    "delivery_method": "Leveringsmetode",
    "domain": "Domene",
    "employee": "Ansatt",
    "employees": "Ansatte",
    "enrolled_at": "Påmeldt den",
    "error_count": "Hoppet over",
    "filters": {
      "back": "Tilbake",
      "boolean": "{column} er {toggle}",
      "data": "Filtrer data",
      "false": "Falsk",
      "filter_by": "Filtrer etter",
      "group": "Filter etter gruppe",
      "numberRange": "{column} fra {minValue} til {maxValue}",
      "search": "Søk",
      "select_date": "Velg dato",
      "status": "Status",
      "training_type": "Skriv inn",
      "true": "Sann"
    },
    "group": "Gruppe",
    "groups": "Grupper",
    "invited": "Invitert",
    "languages": "Språk",
    "last_sent_at": "Sist sendt",
    "lesson_status": "Leksjonstatus",
    "locale": "Språk",
    "name": "Navn",
    "overdue": "Forfalt",
    "published_at": "Publisert på",
    "report_count": "Rapporteringsantall",
    "reports": "Rapporter",
    "scheduled_at": "Planlagt til",
    "score": "Poeng",
    "sensitivity": "Sensitivitetsnivå",
    "sent_to_count": "Angrep",
    "status": "Status",
    "synced_count": "Synkronisert",
    "title": "Tittel",
    "unique_click_count": "Klikk",
    "unique_submission_count": "Pålogginger",
    "updated_at": "Oppdatert på"
  },
  "threats": {
    "analysis": {
      "attachments": {
        "files": "Filer",
        "subtitle": "E-postvedlegg",
        "title": "Vedlegg"
      },
      "indicators": {
        "common": {
          "heading": "Vanlige trusler",
          "help": "E-postinnholdet nevner firmanavn som ofte brukes i phishing."
        },
        "credentials": {
          "heading": "Legitimasjon",
          "help": "E-postinnholdet nevner legitimasjon eller passord."
        },
        "detected": "Oppdaget",
        "homoglyphs": {
          "heading": "Homoglyffer",
          "help": "Avsenderens navn eller e-post inneholder homoglypher."
        },
        "inconsistency": {
          "heading": "Inkonsekvens",
          "help": "Uoverensstemmelser i lenker og/eller avsenderinformasjon."
        },
        "no_data": "Ingen data",
        "not_detected": "Ikke oppdaget",
        "subtitle": "Indikatorer for trusler",
        "title": "Indikatorer",
        "urgency": {
          "heading": "Hastergrad",
          "help": "Haster brukes til å presse mottakeren til å handle."
        }
      },
      "links": {
        "button": "Nettleserisolering",
        "empty": "Ingen lenker funnet",
        "showing_links": "Viser {shown} av {total} lenker",
        "subtitle": "Lenker funnet i e-post",
        "title": "Koblinger"
      },
      "preview": {
        "not_available": {
          "description": "Vi kunne ikke generere en forhåndsvisning for denne e-posten.",
          "title": "Forhåndsvisning av bilde ikke tilgjengelig"
        },
        "subtitle": "E-post forhåndsvisning",
        "title": "Forhåndsvisning"
      },
      "sender": {
        "domain": "Domene",
        "email": "E-post",
        "empty": "Ingen avsenderanalyse funnet",
        "ip": "IP-adresse",
        "mx": "DNS MX-poster",
        "subtitle": "Avsenderanalyse",
        "title": "Avsender",
        "type": "Type",
        "type_text": {
          "free": "Gratis tjeneste",
          "paid": "Betalt tjeneste"
        }
      }
    },
    "anonymized": {
      "title": "Anonymisert trussel"
    },
    "browser_isolation": {
      "button": "Åpne lenken i nettleserisolasjon",
      "copied": "Kopiert til utklippstavlen",
      "heading": "Nettleserisolasjon",
      "host": "Verts",
      "notice": "BrowserLing er en tredjepartstjeneste som gir et sikkert miljø for å åpne lenker. Ved å klikke på knappen nedenfor, vil du bli omdirigert til BrowserLing-nettstedet. Moxso er ikke tilknyttet BrowserLing og kan ikke holdes ansvarlig for noe innhold eller aktivitet som skjer på BrowserLing-nettstedet.",
      "path": "Sti",
      "scheme": "Ordning",
      "secured_by": "Sikret av BrowserLing"
    },
    "buttons": {
      "delete": "Slett trussel",
      "download_html": "Last ned HTML",
      "fraudulent": "Svindelaktig",
      "legitimate": "Legitim",
      "mark_as_fraudulent": "Merk som svindelaktig",
      "mark_as_legitimate": "Merk som legitim",
      "mark_as_spam": "Merk som spam",
      "notify_reporters": "Varsle journalister",
      "notify_reporters_description": "Varsle journalister om statusendringen for rapportene deres.",
      "show_headers": "Vis e-postoverskrifter",
      "show_less": "Vis mindre",
      "show_more": "Vis mer",
      "spam": "Søppelpost"
    },
    "comment_added": "Kommentar lagt til",
    "created_at": "Opprettet den",
    "current": "Gjeldende",
    "disabled": {
      "button": "Gå til innstillinger",
      "heading": "Håndtering av trusler er deaktivert",
      "text": "Gi de ansatte en sikker måte å varsle deg på og ta affære mot potensielle trusler som lurer i e-postinnboksene deres, og dermed beskytte integriteten til organisasjonen din daglig. Ligg ett skritt foran enhver potensiell skade."
    },
    "export_csv": {
      "description": "Nedlastingen inkluderer bare trusler med den valgte statusen i CSV-eksporten.",
      "subtitle": "Velg trusselstatus",
      "title": "Last ned CSV"
    },
    "filter": {
      "status": {
        "all": "Status: Alle",
        "forwarded": "Status: Videresendt",
        "fraudulent": "Status: Svindelaktig",
        "legitimate": "Status: Legitim",
        "spam": "Status: Spam",
        "unhandled": "Status: Ubehandlet"
      }
    },
    "forwarding_enabled": "Videresending aktivert",
    "forwarding_warning": "Rapporterte trusler er skrivebeskyttede og må håndteres i et eksternt system.",
    "from": "Fra",
    "headers": "Overskrifter",
    "mark_as": "Merk som:",
    "no_more_unhandled_threats_button": "Lukk",
    "no_more_unhandled_threats_text": "Du har gjennomgått alle rapporterte trusler. Innboksen din er nå sikker.",
    "no_more_unhandled_threats_title": "Alt klart!",
    "note_placeholder": "Legg til en notis til rapportererne...",
    "related_threats": "Relaterte trusler",
    "relative_time": {
      "days_ago": "{count} dag siden | {count} dager siden",
      "hours_ago": "{count} time siden | {count} timer siden",
      "minutes_ago": "{count} minutt siden | {count} minutter siden"
    },
    "report_information": "Rapportinformasjon",
    "reported_by": "Rapportert av: {name}",
    "reports": {
      "clicked_link_warning": "Klikket på en lenke",
      "phishing": "Phishing",
      "reported_as_phishing": "Rapportert som phishing",
      "reported_as_spam": "Rapportert som søppelpost",
      "reporter_note": "Rapportørens notat",
      "spam": "Søppelpost"
    },
    "review_next_threat_button": "Gå gjennom neste trussel",
    "review_next_threat_text": "Vil du se gjennom neste ubehandlede trussel?",
    "status_updated": "Status oppdatert",
    "subject": "Emne",
    "this_threat_has_been_forwarded": "Denne trusselen har blitt videresendt til et eksternt system. Ingen analyse er blitt utført.",
    "timeline": {
      "analysis_completed": "Analyse fullført",
      "button": "Lagre",
      "status_transition": "Status endret fra {from} til {to}",
      "textarea_placeholder": "Legg til en kommentar...",
      "title": "Aktivitet"
    },
    "transition_description": "Bekreft hvilke rapporter som får denne statusen.",
    "x_of_n_selected": "{x} av {n} valgt"
  },
  "titles": {
    "automations": {
      "subtitle": "Automatiserte treningssekvenser",
      "title": "Automatisering"
    },
    "breaches": {
      "subtitle": "Oppdag datainnbruddene i ditt arbeidsområde.",
      "title": "Brudd"
    },
    "dashboard": {
      "subtitle": "Oversikt over arbeidsområdet ditt.",
      "title": "Oversikt"
    },
    "group": {
      "subtitle": "Ett aktivt gruppemedlem. | {count} aktive gruppemedlemmer."
    },
    "groups": {
      "subtitle": "Ordne dine ansatte sammen i grupper.",
      "title": "Grupper"
    },
    "integrations": {
      "subtitle": "Oversikt over integrasjoner",
      "title": "Integrasjoner"
    },
    "resilience": {
      "subtitle": "Oversikt over din organisasjons motstandsdyktighet.",
      "title": "Motstandsdyktighet"
    },
    "simulations": {
      "custom_templates": {
        "subtitle": "Oversikt over alle dine tilpassede maler",
        "title": "Egendefinerte maler"
      },
      "subtitle": "Simuler phishingangrep på teamet ditt.",
      "title": "Simuleringer"
    },
    "team": {
      "subtitle": "Alle ansatte som for øyeblikket er i ditt arbeidsområde.",
      "title": "Ansatte"
    },
    "threat": {
      "title": "Trusselrapport"
    },
    "threats": {
      "subtitle": "Oversikt over alle trusler og deres status",
      "title": "Trusler"
    },
    "training": {
      "course": {
        "subtitle": "Oversikt over alle kurs",
        "title": "Kurs"
      },
      "course_overview": {
        "title": "Kursoversikt"
      },
      "deadlines": {
        "subtitle": "Oversikt over frister",
        "title": "Frister"
      },
      "participation": {
        "subtitle": "Oversikt over treningsdeltakelse",
        "title": "Deltakelsesoversikt"
      },
      "subtitle": "Oversikt over din organisasjons opplæring",
      "title": "E-læring",
      "video": {
        "subtitle": "Oversikt over alle videoer",
        "title": "Videoer"
      },
      "video_overview": {
        "title": "Videooversikt"
      }
    }
  },
  "training": {
    "actions": {
      "edit": "Rediger",
      "edit_categories": "Rediger kategorier",
      "save": "Lagre"
    },
    "completed_status": {
      "completed": "Fullført",
      "not_completed": "Ikke fullført"
    },
    "courses": {
      "actions": {
        "collapse_all": "Skjul alle",
        "delete_course": "Slett kurs",
        "edit": "Rediger",
        "edit_categories": "Rediger kategorier",
        "edit_course": "Rediger kurs",
        "expand_all": "Utvid alle",
        "preview_course": "Forhåndsvis kurs",
        "save": "Lagre"
      },
      "add_step": {
        "quiz": "Quiz-innhold",
        "text": "Innhold i teksten",
        "video": "Videoinnhold"
      },
      "create": {
        "button": "Opprett kurs"
      },
      "create_button": "Opprett kurs",
      "create_success": "Kurs opprettet vellykket",
      "create_title": "Opprett nytt kurs",
      "default_language_badge": "Standard",
      "default_language_label": "Standardspråk",
      "default_language_placeholder": "Velg standardspråk",
      "delete": {
        "are_you_sure": "Er du sikker på at du vil slette dette trinnet? Denne handlingen kan ikke angres.",
        "course_are_you_sure": "Er du sikker på at du vil slette dette kurset? All obligatorisk opplæring og alle poeng knyttet til kurset vil også bli slettet. Denne handlingen kan ikke angres.",
        "translation_are_you_sure": "Er du sikker på at du vil slette denne oversettelsen? Denne handlingen kan ikke angres."
      },
      "details": {
        "heading": "Detaljer"
      },
      "edit_name_dialog": {
        "save": "Lagre tittel",
        "title": "Rediger kurstittel"
      },
      "errors": {
        "select_category": "Velg minst én kategori",
        "select_locale": "Vennligst velg minst ett språk"
      },
      "form": {
        "labels": {
          "categories": "Kategorier",
          "risk_categories": "Kategorier",
          "title": "Tittel"
        },
        "placeholders": {
          "categories": "Velg kategorier",
          "title": "Skriv inn tittel"
        }
      },
      "labels": {
        "categories": "Kategori | Kategorier",
        "no_categories": "Ingen kategorier"
      },
      "language_card": {
        "add_language": "Legg til språk",
        "editing": "Redigerer",
        "select_language": "Velg et språk",
        "switch": "Bytt",
        "translate_with_ai": "Oversett med AI"
      },
      "navigation": {
        "course": "Kurs",
        "participants": "Deltakere"
      },
      "notifications": {
        "course_deleted": "Kurs slettet",
        "name_updated": "Kurstittel oppdatert",
        "saved": "Lagret",
        "settings_saved": "Endringer lagret",
        "step_deleted": "Steg slettet"
      },
      "preview": "Forhåndsvisning",
      "publish": "Publiser kurs",
      "publish_confirm": "Ja, publiser kurs",
      "publish_confirm_description": "Er du sikker på at du vil publisere dette kurset? Det kan ikke avpubliseres og vil vises i huben umiddelbart.",
      "publish_success": "Kurs publisert",
      "quiz_editor": {
        "actions": {
          "cancel": "Avbryt",
          "save": "Lagre"
        },
        "ai_prompt": {
          "button": "AI ledetekst",
          "generate": "Generer",
          "no_previous_steps": "Legg til en video- eller tekstoppgave tidligere i kurset for å bruke den som kontekst.",
          "placeholder": "Egendefinerte instruksjoner",
          "select_helper": "Velg trinn",
          "select_label": "Bruk eksisterende innhold, en skrevet prompt, eller begge deler for å generere nye spørsmål.",
          "step_number": "Trinn {order}",
          "step_type": {
            "quiz": "Spørrekonkurranse",
            "text": "Tekst",
            "video": "Video"
          },
          "title": "Legg til spørsmål ved hjelp av AI",
          "untitled": "Uten tittel"
        },
        "heading": {
          "description": "Spørrekonkurranse",
          "title": "Trinn {step}"
        },
        "select_action": {
          "ai": {
            "description": "La AI automatisk generere quizspørsmål fra ditt eksisterende innhold i dette kurset.",
            "title": "Automatisk generert fra innhold"
          },
          "manual": {
            "description": "Bygg din egen quiz fra bunnen av ved å legge til spørsmål og svar manuelt.",
            "title": "Opprett quiz manuelt"
          }
        }
      },
      "select_languages_description": "Velg språkene du ønsker å inkludere i kursinnholdet ditt.",
      "set_current_language_as_default": "Sett som standard",
      "settings": {
        "edit_description": "Rediger kursbeskrivelse",
        "save": "Lagre"
      },
      "status": {
        "draft": "Utkast",
        "missing_content_warning": "Kurset mangler innhold på ett eller flere språk",
        "published": "Publisert"
      },
      "steps": {
        "empty": {
          "description": "Klikk på redigeringsknappen ovenfor for å legge til innhold",
          "title": "Tomt trinn"
        },
        "intro": "Introduksjon",
        "knowledge_check": "Kunnskapssjekk",
        "missing_translation": "Oversettelse mangler for dette språket",
        "quiz": "Quiz",
        "text": "Tekst",
        "video": "Video"
      },
      "tabs": {
        "course": "Kurs",
        "participants": "Deltakere"
      },
      "text_editor": {
        "actions": {
          "cancel": "Avbryt",
          "edit": "Rediger",
          "save": "Lagre"
        },
        "ai_prompt": {
          "button": "Tekstredigerings-AI-knapp",
          "generate": "Generer",
          "label": "Beskriv hva du ønsker at AI-en skal gjøre",
          "placeholder": "\"Hjelp meg med å gjøre teksten mer formell\"",
          "title": "Generer tekstkort med AI"
        },
        "ai_viewer": {
          "accept": "Godta",
          "back": "Avbryt",
          "caption": "Gå gjennom innholdet generert av AI og bestem om du vil godta det eller generere det på nytt.",
          "generating": "Genererer kursinnhold",
          "heading": "Gjennomgå generert innhold"
        },
        "apply_image": {
          "button": "Bruk på andre språk",
          "has_image": "Har bilde",
          "subtitle": "Velg språk for å bruke dette bildet på",
          "title": "Bruk bilde på andre språk"
        },
        "course_title_badge": "Kurstittel",
        "heading": {
          "description": "Tekstredigerer",
          "title": "Trinn {step}"
        },
        "labels": {
          "after": "Etter",
          "before": "Før",
          "excerpt": "Utdrag",
          "image_upload": "Bilde",
          "remove_image": "Fjern bilde",
          "title": "Tittel",
          "uploaded_image_alt": "Lastet opp bilde"
        },
        "placeholders": {
          "content": "Skriv inn innholdet ditt",
          "excerpt": "Skriv inn et utdrag",
          "title": "Skriv inn en tittel"
        },
        "title_linked_tooltip": "Brukes som tittelen i {language}-versjonen av kurset."
      },
      "title_summary": {
        "course_title": "Kurstittel",
        "description": "Brukes som tittelen i {language}-versjonen av kurset."
      },
      "translate": {
        "open": "Oversett kurs",
        "submit": "Oversett",
        "title": "Oversett kurs"
      },
      "translate_success": "Kurs oversatt.",
      "translation_list_label": "Oversettelse | Oversettelser",
      "unpublish": "Avpubliser kurs",
      "unpublish_confirm": "Ja, avpubliser kurs",
      "unpublish_confirm_description": "Er du sikker på at du vil avpublisere dette kurset? Det vil forsvinne fra huben umiddelbart.",
      "unpublish_success": "Kurs avpublisert",
      "untitled": "Uten tittel",
      "validation": {
        "content_missing_in_languages": "Innhold mangler på ett språk | Innhold mangler på {count} språk",
        "missing_content": "Mangler innhold",
        "missing_excerpt": "Mangler utdrag",
        "missing_image": "Manglende bilde",
        "missing_questions": "Manglende spørsmål",
        "missing_title": "Mangler tittel",
        "options_missing_text": "Noen alternativer mangler tekst",
        "questions_missing_correct_options": "Noen spørsmål mangler riktige alternativer",
        "questions_missing_text": "Noen spørsmål mangler tekst",
        "step_issues": "Trinnproblemer"
      },
      "video_editor": {
        "empty_search": {
          "description": "Prøv å justere søkeordene dine eller tøm søket for å se alle videoer.",
          "title": "Ingen videoer samsvarer med søket ditt"
        },
        "empty_state": {
          "description": "Dette trinnet er tomt. Klikk på redigeringsknappen ovenfor for å legge til innhold."
        },
        "fallback_translation_tooltip": "Denne videoen bruker en reserveteksting",
        "search_placeholder": "Søk etter videoer",
        "selected": {
          "button": "Endre video",
          "title": "VIDEO"
        },
        "subtitle": "Velg en video for å legge til i dette steget.",
        "title": "Velg video"
      }
    },
    "custom_uploads": {
      "subtitle": "Videoer opprettet av din organisasjon",
      "title": "Egendefinerte opplastinger",
      "video": {
        "badges": {
          "quiz": "Quiz",
          "video": "Video"
        },
        "create": {
          "create_video": "Opprett video",
          "next_steps_text": "Fyll ut informasjonen nedenfor for å sette opp videoen din. Etter å ha opprettet videoen, blir du tatt til videosiden, hvor du kan velge denne oversettelsen og laste opp en videofil.",
          "video_created": "Video opprettet"
        },
        "delete": {
          "are_you_sure": "Er du sikker på at du vil slette denne videoen? Denne handlingen kan ikke gjøres om.",
          "button": "Slett",
          "video_deleted": "Video slettet"
        },
        "form": {
          "labels": {
            "categories": "Kategorier",
            "description": "Beskrivelse",
            "language": "Språk",
            "title": "Tittel"
          },
          "placeholders": {
            "categories": "Velg kategorier",
            "description": "Skriv inn en beskrivelse",
            "language": "Velg språk",
            "title": "Skriv inn en tittel"
          }
        },
        "publish": "Publiser",
        "publish_confirm": "Publiser",
        "publish_confirm_description": "Publisering gjør denne videoen tilgjengelig i huben og brukbar på tvers av plattformen.",
        "publish_success": "Video publisert",
        "publish_unavailable": "Last opp videoer for alle oversettelser før publisering.",
        "quiz": {
          "available_quizzes": "Tilgjengelige quizer",
          "create": "Opprett",
          "edit": "Rediger",
          "quiz_deleted": "Quiz slettet",
          "quiz_saved": "Quiz lagret",
          "quizzes": "Quizzer",
          "quizzes_translated": "Quizzer oversatt."
        },
        "single": {
          "details": {
            "heading": "Detaljer",
            "text": "Video detaljer"
          },
          "labels": {
            "categories": "Kategori | Kategorier",
            "created_at": "Opprettet den",
            "published_at": "Publisert den",
            "updated_at": "Oppdatert på"
          },
          "title": "Egendefinert video"
        },
        "status": {
          "draft": "Utkast",
          "published": "Publisert"
        },
        "translations": {
          "add_translation": "Legg til oversettelse",
          "ai": {
            "done_translate_button": "Ferdig",
            "processing_n_languages": "Behandler ett språk | Behandler {count} språk",
            "text": "Bruk DeepL til å automatisk oversette videoens tittel og beskrivelse til et valgt språk.",
            "title": "Oversett videodetaljer med AI",
            "translate_button": "Oversett",
            "translating_your_video": "Oversetter videodetaljer",
            "video_now_available_in": "Oversettelser har blitt opprettet på ett ekstra språk | Oversettelser har blitt opprettet på {count} ekstra språk",
            "video_translate_success": "Vellykket!"
          },
          "available_translations": "Tilgjengelige oversettelser",
          "create_title": "Legg til oversettelse",
          "default_badge": "Standard",
          "delete": "Slett",
          "delete_are_you_sure": "Er du sikker på at du vil slette denne oversettelsen? Denne handlingen kan ikke angres.",
          "edit": "Rediger",
          "edit_translation": "Rediger oversettelse",
          "empty": "Ingen oversettelser for denne videoen",
          "make_default": "Sett som standard",
          "manual": {
            "text": "Skriv om oversettelsen fra bunnen av på et nytt språk.",
            "title": "Oversett video manuelt"
          },
          "quiz": {
            "create": "Lag quiz",
            "edit": "Rediger quiz",
            "other_translations_have_quizzes": "Andre oversettelser har quizer",
            "other_translations_have_quizzes_want_to_translate": "Andre oversettelser har allerede quizzer. Vil du automatisk oversette denne quizen til de språkene?",
            "some_translations_have_no_quizzes": "Noen oversettelser har foreløpig ingen quizer. Oversett nå?",
            "this_translation_has_quizzes_in_other_languages_translate_automatically": "Denne oversettelsen har quizer på andre språk. Oversette automatisk?",
            "translate_quiz": "Oversett",
            "update_this_quiz_and_translate_others": "Oppdater denne quizzen og oversett andre quizer",
            "update_this_quiz_only": "Oppdater kun denne quizen"
          },
          "save_changes": "Lagre endringer",
          "single": {
            "edit": {
              "subtitle": "Oppdater videodetaljene",
              "title": "Videodetaljer"
            },
            "upload": {
              "subtitle": "Last opp videofil for denne oversettelsen.",
              "title": "Last opp video",
              "video_deleted": "Video slettet",
              "video_uploaded": "Video lastet opp"
            }
          },
          "translation_added": "Oversettelse lagt til",
          "translation_deleted": "Oversettelse slettet",
          "translation_updated": "Oversettelse oppdatert",
          "translations": "Oversettelser",
          "video": "Video"
        },
        "unpublish": "Avpubliser",
        "unpublish_confirm": "Avpubliser",
        "unpublish_confirm_description": "Å avpublisere vil skjule denne videoen fra huben. Den vil fortsatt være tilgjengelig i alle automatiseringer der den allerede er brukt.",
        "unpublish_success": "Video avpublisert"
      }
    },
    "deadlines": {
      "bulk_reminder_dialog_confirm": "Send {count} påminnelse | Send {count} påminnelser",
      "bulk_reminder_dialog_text": "Dette vil varsle {count} ansatte. Hver ansatt mottar ett varsel, selv om de har flere tildelinger.",
      "bulk_reminder_dialog_title": "Send påminnelser til alle som samsvarer med de valgte filtrene",
      "bulk_reminders_sent": "Påminnelser sendt",
      "delete_reminder": "Slett påminnelse",
      "participation_title": "Deltakelse",
      "reminder_deleted": "Påminnelse slettet",
      "reminder_sent": "Påminnelse sendt",
      "send_bulk_reminder": "Send påminnelser til alle",
      "send_reminder": "Send påminnelse"
    },
    "default_language_updated": "Standardspråk oppdatert",
    "default_translation_tooltip": "Dette er for øyeblikket standardspråket. Velg et annet språk før du sletter det.",
    "errors": {
      "select_category": "Velg minst én kategori"
    },
    "filter": {
      "course": "Vis bare kurs",
      "video": "Vis kun videoer"
    },
    "form": {
      "labels": {
        "categories": "Kategorier",
        "no_categories": "Ingen kategorier"
      },
      "placeholders": {
        "categories": "Velg kategorier"
      }
    },
    "invited_status": {
      "invited": "Invitert",
      "not_invited": "Ikke invitert"
    },
    "moxso_courses": {
      "description": "Kurs levert av Moxso",
      "title": "Moxso-kurs"
    },
    "moxso_uploads": {
      "subtitle": "Videoer levert av Moxso",
      "title": "Moxso-videoer"
    },
    "quiz": "Quiz",
    "search_courses": {
      "description": "Søkeresultater som samsvarer med forespørselen din",
      "title": "Søkeresultater"
    },
    "type": {
      "course": "Kurs",
      "user_course": "Brukerkurs",
      "video": "Video"
    },
    "user_defined_courses": {
      "description": "Kurs opprettet av din organisasjon",
      "title": "Brukerdefinerte kurs"
    }
  },
  "translations": {
    "ai": {
      "overwrite_existing_translations_text": "Dette vil slette de eksisterende oversettelsene og oversette dem fra bunnen av",
      "overwrite_existing_translations_title": "Overskriv eksisterende oversettelser",
      "select_languages_to_translate_item_into": "Velg språkene du vil generere oversettelser for",
      "translate_from": "Oversett fra"
    },
    "deepl_privacy": "DeepLs personvernregler",
    "deepl_text": "Dette vil sende en kopi av oversettelsen din til DeepL, en ekstern AI-drevet oversettelsestjeneste. Innholdet ditt vil bli behandlet eksternt, og {link} vil gjelde.",
    "quizzes": {
      "done_translate_button": "Ferdig",
      "processing_n_languages": "Behandler ett språk | Behandler {count} språk",
      "quiz_now_available_in": "Testen din er nå tilgjengelig på ett ekstra språk | Testen din er nå tilgjengelig på {count} ekstra språk",
      "quiz_translate_success": "Suksess!",
      "select_the_languages_you_want_to_translate_your_quiz_into": "Velg språkene du vil oversette quizen din til",
      "translate_button": "Oversett",
      "translate_from": "Oversett fra",
      "translate_multiple_choice_quiz": "Oversett flervalgstest",
      "translating_your_quiz": "Oversetter quizen din"
    }
  },
  "two_factor_challenge": {
    "back_to_login": "Tilbake til innlogging",
    "code": {
      "label": "Autentiseringskode",
      "placeholder": "123456"
    },
    "heading": "Tofaktorautentisering",
    "recovery_code": {
      "label": "Gjenopprettingskode",
      "placeholder": "aaaaaaaaaa-bbbbbbbbbb"
    },
    "submit": "Bekreft",
    "text": "Skriv inn en kode fra autentiseringsappen din, eller bruk en gjenopprettingskode for å fortsette.",
    "use_authenticator_code": "Bruk en kode fra autentiseringsapp",
    "use_recovery_code": "Bruk en gjenopprettingskode"
  },
  "uploads": {
    "file_upload": {
      "click_to_upload": "Klikk for å laste opp",
      "delete": {
        "are_you_sure": "Er du sikker på at du vil slette denne filen? Denne handlingen kan ikke angres.",
        "button": "Slett"
      },
      "file_upload_limit": "{fileType} · Opptil {fileSize} · {imageRatio} anbefalt",
      "or_drag_and_drop": "{click} eller dra og slipp",
      "placeholder": "fil",
      "title": "Last opp fil",
      "up_to": "Opptil",
      "upload_failed": {
        "button": "Last opp ny",
        "subtitle": "Filen som ble oppgitt, kunne ikke lastes opp.",
        "title": "Opplasting mislyktes"
      },
      "upload_in_progress": {
        "processing_subtitle": "Opplasting fullført. Du kan trygt forlate denne siden mens vi behandler den.",
        "processing_title": "Behandler filen din...",
        "uploading_subtitle": "Filen din lastes opp.",
        "uploading_title": "Laster opp fil..."
      }
    },
    "image_upload": {
      "click_to_upload": "Klikk for å laste opp",
      "delete": {
        "are_you_sure": "Er du sikker på at du vil slette dette bildet? Denne handlingen kan ikke angres.",
        "button": "Slett"
      },
      "or_drag_and_drop": "eller dra og slipp",
      "upload_failed": {
        "button": "Last opp ny",
        "subtitle": "Filen som ble levert, kunne ikke lastes opp.",
        "title": "Opplasting mislyktes"
      },
      "upload_in_progress": {
        "processing_subtitle": "Opplasting fullført. Du kan trygt forlate denne siden mens vi behandler den.",
        "processing_title": "Behandler filen din...",
        "uploading_subtitle": "Filen din blir lastet opp.",
        "uploading_title": "Laster opp fil..."
      }
    },
    "video_upload": {
      "click_to_upload": "Klikk for å laste opp",
      "delete": {
        "are_you_sure": "Er du sikker på at du vil slette denne videoen? Denne handlingen kan ikke angres.",
        "button": "Slett"
      },
      "format": "MP4",
      "max": "Maksimum",
      "or_drag_and_drop": "eller dra og slipp",
      "up_to": "Opptil",
      "upload_failed": {
        "button": "Last opp ny",
        "subtitle": "Den oppgitte filen ble ikke lastet opp.",
        "title": "Opplasting mislyktes"
      },
      "upload_in_progress": {
        "processing_subtitle": "Opplastning fullført. Du kan trygt forlate denne siden mens vi behandler den.",
        "processing_title": "Behandler filen din...",
        "uploading_title": "Laster opp fil..."
      }
    }
  },
  "upsell": {
    "click_to_open": "Klikk for å lese mer",
    "contact": "Varsle Customer Success",
    "knowledge_base": "Kunnskapsbase",
    "learn_more": "Les mer",
    "locked_feature": "Låst funksjon",
    "notify_success": "Varsel sendt til Customer Success",
    "upgrade_required": "Denne funksjonen krever en oppgradering"
  },
  "user_settings": {
    "subtitle": "Administrer sikkerhetsinnstillingene for adminkontoen din.",
    "title": "Sikkerhet og tilgang"
  },
  "validate_domain": {
    "login": "Logg inn",
    "success": "Domenet har blitt bekreftet vellykket."
  },
  "videos": {
    "error": "Strømming er for øyeblikket utilgjengelig"
  },
  "workspace_onboarding": {
    "invite_admins": {
      "form": {
        "button": "Inviter administrator",
        "description": "Legg til flere administratorer hvis andre også skal hjelpe med å eie oppsettet eller administrere Moxso. Alle administratorer har samme tilgang og ser de samme endringene.",
        "title": "Inviter en administrator til"
      },
      "header": {
        "description": "Bestem hvem som skal ha administratortilgang fra starten. Hvis flere personer skal administrere cybersikkerhet eller Moxso, inviter dem nå slik at oppsett og eierskap deles fra dag én. Alle administratorer har samme tilgang og ser de samme endringene.",
        "title": "Inviter administratorer"
      },
      "intro": {
        "admin_added": "Du har allerede mer enn én administrator i dette arbeidsområdet.",
        "description": "Én administrator kan fungere godt for mindre team, mens flere administratorer kan gjøre overlevering og samarbeid enklere.",
        "eyebrow": "Anbefalt før lansering",
        "recommendation": "Velg oppsettet som passer teamet deres, og inviter flere administratorer hvis eierskapet er delt.",
        "title": "Del administratortilgang"
      },
      "list": {
        "added_on": "Lagt til",
        "description": "Se gjennom administratorene som for øyeblikket har tilgang til dette arbeidsområdet.",
        "title": "Arbeidsområdets administratorer",
        "you": "Du"
      }
    },
    "kick_off": {
      "complete": "Planlegg kickoff",
      "dates": {
        "description": "Planlegg kickoffdatoene",
        "locked": "Låst",
        "locked_description": "Fullfør kravene ovenfor for å låse opp planlegging.",
        "simulation": {
          "custom_date": "Egendefinert dato",
          "custom_date_description": "Velg en bestemt dag",
          "label": "Kickoffdato for simulering",
          "one_week_before": "1 uke før trening",
          "recommended": "Anbefalt"
        },
        "title": "Kickoffdatoer",
        "training": {
          "description": "De ansatte mottar sin første treningsmodul denne dagen.",
          "label": "Kickoffdato for trening",
          "placeholder": "Velg en dato"
        }
      },
      "header": {
        "description": "Velg dagen de ansatte starter sikkerhetstreningen. En innledende phishing-simulering kjøres på forhånd for å måle utgangspunktet.",
        "title": "Planlegg kickoff"
      },
      "validation": {
        "description": "Fullfør disse trinnene før du kan planlegge treningen.",
        "requirements_count": "{count} av {total} fullført",
        "set_up": "Sett opp",
        "title": "Validering av kickoff"
      }
    },
    "microsoft_manual_setup": {
      "junk": {
        "button": "Slik omgår du søppelpostfiltre",
        "heading": "Omgå søppelpostfilter",
        "text": "Denne veiledningen gir trinnvise instruksjoner for å la Moxso-e-poster omgå søppelpostfiltre."
      },
      "safe_links": {
        "button": "Slik omgår du Safe Links",
        "heading": "Omgå Safe Links",
        "text": "Denne veiledningen gir trinnvise instruksjoner for å la Moxso-e-poster omgå Safe Links."
      },
      "spam": {
        "button": "Slik omgår du spamfiltre",
        "heading": "Omgå spamfilter",
        "text": "Denne veiledningen gir trinnvise instruksjoner for å la Moxso-e-poster omgå spamfiltre."
      },
      "tenant_allow_block": {
        "button": "Slik allowlister du Moxso via IP i Outlook",
        "heading": "Legg til Moxso-IP-er i Tenant Allow/Block Lists",
        "text": "Denne veiledningen gir trinnvise instruksjoner for å legge til Moxso-IP-adresser i Tenant Allow/Block Lists i Microsoft Defender for å sikre riktig e-postlevering."
      },
      "third_party": {
        "button": "Slik legger du til Moxso-IP-er og domener i Microsoft Defender",
        "heading": "Legg til Moxsos IP-er og domener i Microsoft Defender",
        "text": "Denne veiledningen gir trinnvise instruksjoner for å legge til Moxsos IP-er og domener i Third-Party Phishing Simulation-innstillingene i Microsoft Defender for å sikre riktig e-posttesting og levering."
      }
    },
    "onboarding_actions": {
      "back": "Tilbake",
      "continue": "Fortsett",
      "knowledge_base": "Kunnskapsbase",
      "mark_as_completed": "Marker som fullført",
      "skip": "Sett opp senere"
    },
    "progress_badge": {
      "kick_off_planned": "Kickoff planlagt",
      "simulation_date": "Startdato for simulering",
      "training_start": "Startdato for trening",
      "workspace_setup": "Oppsett:"
    },
    "reporting_add_in": {
      "confirm_setup": {
        "description": "Hvis Moxso-pluginen er synlig i postkassen din, kan ansatte begynne å bruke den til å rapportere mistenkelige e-poster direkte fra innboksen sin.",
        "manage_later": "Se hvordan rapportering fungerer i {link}.",
        "subtitle": "Fullfør guiden for e-postprogrammet ditt, og fortsett når add-in-en er distribuert.",
        "this_guide": "denne guiden",
        "title": "Er Moxso-pluginen synlig i postkassen din?"
      },
      "continue_disabled_tooltip_text": "Velg et e-postprogram for å fortsette.",
      "follow_guide": {
        "gmail": "Gmail",
        "outlook": "Outlook",
        "thunderbird": "Thunderbird",
        "title": "Følg guiden nedenfor"
      },
      "guide_picker": {
        "gmail": {
          "description": "Steg-for-steg-guide for å sette opp reporting add-in i Gmail.",
          "title": "Gmail"
        },
        "outlook": {
          "description": "Steg-for-steg-guide for å sette opp reporting add-in i Outlook.",
          "title": "Outlook"
        },
        "thunderbird": {
          "description": "Steg-for-steg-guide for å sette opp reporting add-in i Thunderbird.",
          "title": "Thunderbird"
        },
        "title": "Velg e-postprogrammet ditt"
      },
      "header": {
        "description": "Sett opp Moxso reporting add-in slik at ansatte raskt kan rapportere mistenkelige e-poster direkte fra innboksen sin som en del av sin vanlige e-postflyt.",
        "title": "Sett opp reporting add-in"
      }
    },
    "setup_provider": {
      "add_simulation": {
        "button": "Opprett simuleringsutkast",
        "continue_disabled_tooltip_text": "Sett opp en phishing-simuleringskampanje for å fortsette",
        "description": "Vi har satt opp en phishing-simuleringskampanje basert på bedriftens profil. Denne kampanjen fungerer som en baseline for å identifisere forbedringsområder.",
        "description_cta": "Klikk på knappen nedenfor for å opprette simuleringen",
        "header": {
          "description": "Sett opp en phishing-simuleringskampanje som sender realistiske e-poster kontinuerlig for å hjelpe ansatte med å øve på å oppdage trusler. Du kan justere innstillinger og målgruppe etter at kampanjen har startet.",
          "title": "Sett opp din første phishing-simulering"
        },
        "settings_card": {
          "Audience": "Målgruppe",
          "Credential harvest": "Credential harvest",
          "Delivery rate": "Leveringsrate",
          "Name": "Navn",
          "all_employees": "Alle ansatte",
          "baseline_campaign": "Baseline-kampanje",
          "credential_harvest": "Aktivert",
          "delivery_rate": "Middels"
        },
        "simulation_created": "Simuleringsutkast opprettet",
        "subtitle": "Klar til lansering",
        "title": "Anbefalte innstillinger"
      },
      "buttons": {
        "back": "Tilbake",
        "continue": "Fortsett"
      },
      "header": {
        "description": "Sett opp en integrasjon for automatisk å synkronisere ansattdata med systemet. Dette holder ansattinformasjon oppdatert og fjerner behovet for manuelle oppdateringer.",
        "title": "Konfigurer integrasjoner"
      },
      "integration": {
        "header": {
          "description": "Velg om du vil integrere med HR-databasen din (identitetsleverandør) eller i stedet importere ansatte manuelt gjennom en CSV-fil. Vi anbefaler ikke det manuelle alternativet da det ikke lar systemet automatisk synkronisere og oppdatere over tid (holde oversikt over nye eller inaktive brukere).",
          "title": "Synkroniser ansatte"
        },
        "warning": "En administratorkonto med globale rettigheter er påkrevd for å sette opp synkronisering med Microsoft Entra ID eller Google Workspace."
      },
      "provider": {
        "csv_import": "CSV-import",
        "description": "Velg plattformen du bruker til å administrere identiteter og ansatte.",
        "employees": "Ansatte",
        "google": "Google Workspace",
        "google_sync": "Google Sync",
        "microsoft": "Microsoft",
        "microsoft_sync": "Microsoft Entra ID",
        "okta": "Okta",
        "title": "Velg leverandør"
      },
      "recommendations": {
        "create_target_group": {
          "description": "Opprett en gruppe med ansatte du ønsker å målrette, slik at du enkelt kan tildele simuleringer og opplæring ved å velge gruppen direkte.",
          "title": "Opprett målgruppe"
        },
        "heading": {
          "description": "Følg disse trinnene før import av ansatte for å sikre at riktige data synkroniseres. Selv om det ikke er obligatorisk, sparer det deg tid senere.",
          "title": "Forbered for integrasjon"
        },
        "verify_language_settings": {
          "description": "Sørg for at ansattes språkinnstillinger er riktige, slik at riktig språk synkroniseres til Moxso.",
          "title": "Bekreft språkinnstillinger"
        },
        "warning": "Sørg for at nye ansatte alltid legges til i gruppene som er synkronisert med Moxso."
      },
      "saml_scim": {
        "header": {
          "description": "Konfigurer single sign-on og automatisk brukerklargjøring. Fullfør begge delene nedenfor, og fortsett når identitetsleverandøren er tilkoblet.",
          "title": "Sett opp SAML og SCIM"
        }
      },
      "setup_method": {
        "header": {
          "description": "Bruk SAML og SCIM for sikker pålogging og automatisk klargjøring, eller koble til en leverandør med standardintegrasjonen.",
          "title": "Velg oppsett"
        },
        "provider_integration": {
          "description": "Synkroniser ansatte direkte fra Microsoft Entra ID, Google Workspace, Slack eller en CSV-fil.",
          "title": "Standardintegrasjon"
        },
        "recommended": "Anbefalt",
        "saml_scim": {
          "description": "Aktiver single sign-on og automatiser brukerklargjøring.",
          "title": "SAML og SCIM"
        }
      },
      "whitelisting": {
        "buttons": {
          "change_guides": "Endre guide",
          "confirm_whitelist": "Bekreft allowlist",
          "manual": "Manuell",
          "test_whitelist": "Test allowlist"
        },
        "continue_disabled_tooltip_text": "Bekreft at allowlisting fungerer før du fortsetter.",
        "follow_guide": {
          "gmail": "Gmail",
          "outlook": "Outlook",
          "title": "Følg guiden nedenfor"
        },
        "guide_picker": {
          "gmail": {
            "description": "Trinn-for-trinn-guide for å slippe e-poster gjennom i Gmail.",
            "title": "Gmail"
          },
          "outlook": {
            "description": "Trinn-for-trinn-guide for å slippe e-poster gjennom i Outlook.",
            "title": "Outlook"
          },
          "title": "Velg din e-postleverandør"
        },
        "header": {
          "description": "Sett opp allowlisting av IP-adressene og domenene våre for å sikre at phishing-simuleringer leveres til ansattes innbokser.",
          "title": "Sørg for at meldinger ikke flagges som spam"
        },
        "send_test": {
          "buttons": {
            "no": "Nei, hjelp meg",
            "send_test": "Send test-epost",
            "yes": "Ja, jeg mottok den"
          },
          "confirm": {
            "text": "Sjekk innboksen din (og spam-mappen).",
            "title": "Mottok du e-posten | Mottok du e-postene"
          },
          "description": "Send en test-epost for å bekrefte at den leveres til innboksen din på {email}. {try_a_few_times}.",
          "subtitle": "Send test-epost",
          "success": {
            "text": "Konfigurasjonen din er korrekt. Du kan nå fortsette til neste steg.",
            "title": "Allowlisting fungerer"
          },
          "title": "Bekreft at allowlisting fungerer",
          "try_a_few_times": "Prøv noen ganger"
        }
      }
    },
    "simulation": {
      "targeting": {
        "add_services": "Legg til tjenester",
        "ceo": "Kontaktinformasjon for CEO",
        "cfo": "Kontaktinformasjon for CFO",
        "content_description": "Legg til lederkontakter og tjenestene deres for mer realistiske simuleringer.",
        "content_title": "Tilpass simuleringene",
        "cto": "Kontaktinformasjon for CTO",
        "description": "Konfigurer realistisk målretting for virksomheten.",
        "edit_services": "Rediger tjenester",
        "no_services": "Ingen tjenester valgt",
        "services": "Tjenester",
        "services_title": "Velg tjenester",
        "title": "Sett opp simuleringer"
      }
    },
    "steps": {
      "add_simulation": "Simuleringer",
      "invite_admins": "Administratorer",
      "kick_off": "Kickoff",
      "reporting_add_in": "Rapporterings-tillegg",
      "setup_provider": "Integrasjoner",
      "training": "Opplæring",
      "verify_domains": "Domener",
      "welcome": "Velkommen",
      "whitelisting": "Allowlisting"
    },
    "training": {
      "header": {
        "description": "Velg om Moxso skal tildele opplæring automatisk, eller om dere planlegger den selv, og tilpass deretter oppsettet til virksomheten.",
        "title": "Sett opp opplæring"
      },
      "mode": {
        "continue_disabled": "Velg en opplæringsform for å fortsette.",
        "description": "Velg en form for å fullføre dette trinnet.",
        "title": "Velg opplæringsform"
      }
    },
    "verify_domains": {
      "buttons": {
        "add": "Legg til",
        "resend": "Send på nytt",
        "verify": "Bekreft"
      },
      "continue_disabled_tooltip_text": "Bekreft minst ett domene før du fortsetter",
      "domain_placeholder": "company.com",
      "empty": {
        "subtitle": "Legg til bedriftens domener ovenfor for å fortsette",
        "title": "Ingen domener lagt til ennå"
      },
      "heading": {
        "description": "Legg til alle bedriftsdomener som brukes i ansattes e-postadresser.",
        "title": "Bekreft domenene dine"
      },
      "labels": {
        "add_domain": "Legg til domene",
        "not_verified": "Ikke bekreftet",
        "verification_pending": "Verifisering venter",
        "verified": "Bekreftet",
        "verified_on": "Bekreftet: {date}"
      },
      "verification_email_sent": "Verifiserings-epost sendt",
      "your_domains": "Dine domener"
    },
    "welcome": {
      "connect_provider": {
        "description": "Forbered for integrasjon og synkronisering av ansatte",
        "title": "Konfigurer integrasjoner"
      },
      "description": "Du kjenner kanskje allerede trinnene nedenfor, men vi skal nå sørge for at alle er fullført slik at du kan gå live. Eventuelle testdata du måtte ha opprettet tidligere er nå fjernet.",
      "get_started": "Kom i gang",
      "invite_admins": {
        "description": "Bestem om andre også skal hjelpe med oppsettet og det løpende administratorarbeidet.",
        "title": "Inviter administratorer"
      },
      "launch_phishing_simulation": {
        "description": "Opprett en baselinesimulering og konfigurer CEO-svindel og programvaremålretting.",
        "title": "Simuleringer"
      },
      "reporting_add_in": {
        "description": "Legg til Moxso-rapportknappen i ansattes innbokser.",
        "title": "Sett opp reporting add-in"
      },
      "review_and_start": {
        "description": "Gå gjennom oppsettet og begynn å bruke Moxso.",
        "title": "Begynn å bruke Moxso"
      },
      "subtitle": "Velkommen til Moxso",
      "title": "La oss gjøre deg klar til lansering.",
      "training": {
        "description": "Velg en opplæringsform og rammeverkene som er viktige for virksomheten.",
        "title": "Opplæring"
      },
      "verify_domains": {
        "description": "Bekreft domenene du vil bruke med Moxso.",
        "title": "Bekreft domener"
      },
      "whitelist_email": {
        "description": "Sørg for at meldinger ikke flagges som spam.",
        "title": "Sett opp allowlisting"
      }
    }
  },
  "workspace_report": {
    "assignments": "Tildelinger",
    "avg_score": "Gj.snittlig poengsum",
    "compared_against": "Sammenlignet med {period}",
    "department": "Avdeling",
    "employee": "Ansatt",
    "employees_at_risk": "Ansatte i risiko",
    "generated": "Generert {date}",
    "group": "Gruppe",
    "group_breakdown": "Gruppeoversikt",
    "group_breakdown_description": "Samlede signaler, tildelinger og tiltak per gruppe",
    "group_breakdown_description_without_hri": "Samlede tildelinger per gruppe",
    "group_breakdown_note": "Gjennomsnittlig poengsum er vektet etter antall ansatte i hver gruppe. Signalstolpen deler aktiviteten inn i negativ, nøytral og positiv stemning.",
    "group_breakdown_note_without_hri": "Gjennomsnittlig poengsum er vektet etter antall ansatte i hver gruppe.",
    "hri_summary": "HRI-oppsummering for arbeidsområdet",
    "human_risk_intelligence": "Human Risk Intelligence",
    "interventions": "Tiltak",
    "interventions_by_type": "Tiltak etter type",
    "last_six_months": "Siste 6 måneder",
    "loading": "Laster arbeidsområderapport…",
    "missed": "Overskredet",
    "no_employees_at_risk": "Ingen ansatte i risiko",
    "no_groups": "Ingen gruppedata tilgjengelig",
    "no_risk_indicators": "Ingen risikoindikatorer",
    "operational_metrics": "Driftsmålinger",
    "performance_by_team": "Resultater etter team",
    "resilience_score": "Robusthetspoeng",
    "risk_index": "Risikoindeks {value}/10 · lavere er bedre",
    "risk_indicator": "Risikoindikator",
    "risk_level": "Risikonivå",
    "risk_levels": {
      "high": "Høy",
      "low": "Lav",
      "moderate": "Moderat"
    },
    "security_behaviour_overview": "Oversikt over sikkerhetsatferd",
    "signals": "Signaler",
    "signals_by_sentiment": "Signaler etter stemning",
    "signals_by_severity": "Signaler etter alvorlighetsgrad",
    "threshold": "Terskel {value}% · sortert fra lav til høy",
    "title": "Arbeidsområderapport",
    "top_five_period": "Topp 5 denne perioden",
    "total": "{count} totalt",
    "total_employees": "{count} ansatte totalt",
    "total_groups": "{count} grupper",
    "total_signals": "{count} signaler",
    "training": "Opplæringsmålinger",
    "training_simulations_risk": "Opplæring, simuleringer og risiko",
    "trend": "Trend",
    "trend_title": "Robusthet, klikk- og rapporteringsrate",
    "trending_risk_indicators": "Aktuelle risikoindikatorer",
    "unavailable": "Rapporten er ikke tilgjengelig",
    "unavailable_description": "Rapporten kunne ikke lastes inn. Kontroller at rapportens URL er gyldig og ikke har utløpt.",
    "workspace_summary": "Oversikt over arbeidsområdet"
  }
}
